/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from "@tanstack/react-query";
import { type VlContext, useVlContext, queryKeyFn } from "./vlContext";
import { deepMerge } from "./vlUtils";
import type * as Fetcher from "./vlFetcher";
import { vlFetch } from "./vlFetcher";
import type * as Schemas from "./vlSchemas";

type QueryFnOptions = {
  signal?: AbortController["signal"];
};

export type GrantAccessApiV1ManageDatasetIdSharePutPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GrantAccessApiV1ManageDatasetIdSharePutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GrantAccessApiV1ManageDatasetIdSharePutVariables = {
  pathParams: GrantAccessApiV1ManageDatasetIdSharePutPathParams;
} & VlContext["fetcherOptions"];

export const fetchGrantAccessApiV1ManageDatasetIdSharePut = (
  variables: GrantAccessApiV1ManageDatasetIdSharePutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GrantAccessApiV1ManageDatasetIdSharePutError,
    undefined,
    {},
    {},
    GrantAccessApiV1ManageDatasetIdSharePutPathParams
  >({
    url: "/api/v1/manage/{datasetId}/share",
    method: "put",
    ...variables,
    signal,
  });

export const useGrantAccessApiV1ManageDatasetIdSharePut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      GrantAccessApiV1ManageDatasetIdSharePutError,
      GrantAccessApiV1ManageDatasetIdSharePutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    GrantAccessApiV1ManageDatasetIdSharePutError,
    GrantAccessApiV1ManageDatasetIdSharePutVariables
  >({
    mutationFn: (variables: GrantAccessApiV1ManageDatasetIdSharePutVariables) =>
      fetchGrantAccessApiV1ManageDatasetIdSharePut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ListAccessApiV1ManageDatasetIdShareGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ListAccessApiV1ManageDatasetIdShareGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListAccessApiV1ManageDatasetIdShareGetVariables = {
  pathParams: ListAccessApiV1ManageDatasetIdShareGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchListAccessApiV1ManageDatasetIdShareGet = (
  variables: ListAccessApiV1ManageDatasetIdShareGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListAccessResponse,
    ListAccessApiV1ManageDatasetIdShareGetError,
    undefined,
    {},
    {},
    ListAccessApiV1ManageDatasetIdShareGetPathParams
  >({
    url: "/api/v1/manage/{datasetId}/share",
    method: "get",
    ...variables,
    signal,
  });

export function listAccessApiV1ManageDatasetIdShareGetQuery(
  variables: ListAccessApiV1ManageDatasetIdShareGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListAccessResponse>;
};

export function listAccessApiV1ManageDatasetIdShareGetQuery(
  variables:
    | ListAccessApiV1ManageDatasetIdShareGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListAccessResponse>)
    | reactQuery.SkipToken;
};

export function listAccessApiV1ManageDatasetIdShareGetQuery(
  variables:
    | ListAccessApiV1ManageDatasetIdShareGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/manage/{datasetId}/share",
      operationId: "listAccessApiV1ManageDatasetIdShareGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListAccessApiV1ManageDatasetIdShareGet(variables, signal),
  };
}

export const useSuspenseListAccessApiV1ManageDatasetIdShareGet = <
  TData = Schemas.ListAccessResponse,
>(
  variables: ListAccessApiV1ManageDatasetIdShareGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListAccessResponse,
      ListAccessApiV1ManageDatasetIdShareGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListAccessResponse,
    ListAccessApiV1ManageDatasetIdShareGetError,
    TData
  >({
    ...listAccessApiV1ManageDatasetIdShareGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListAccessApiV1ManageDatasetIdShareGet = <
  TData = Schemas.ListAccessResponse,
>(
  variables:
    | ListAccessApiV1ManageDatasetIdShareGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListAccessResponse,
      ListAccessApiV1ManageDatasetIdShareGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListAccessResponse,
    ListAccessApiV1ManageDatasetIdShareGetError,
    TData
  >({
    ...listAccessApiV1ManageDatasetIdShareGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SendInviteApiV1ManageDatasetIdInvitePutPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type SendInviteApiV1ManageDatasetIdInvitePutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SendInviteApiV1ManageDatasetIdInvitePutVariables = {
  body?: Schemas.InviteRequest;
  pathParams: SendInviteApiV1ManageDatasetIdInvitePutPathParams;
} & VlContext["fetcherOptions"];

export const fetchSendInviteApiV1ManageDatasetIdInvitePut = (
  variables: SendInviteApiV1ManageDatasetIdInvitePutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    SendInviteApiV1ManageDatasetIdInvitePutError,
    Schemas.InviteRequest,
    {},
    {},
    SendInviteApiV1ManageDatasetIdInvitePutPathParams
  >({
    url: "/api/v1/manage/{datasetId}/invite",
    method: "put",
    ...variables,
    signal,
  });

export const useSendInviteApiV1ManageDatasetIdInvitePut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      SendInviteApiV1ManageDatasetIdInvitePutError,
      SendInviteApiV1ManageDatasetIdInvitePutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    SendInviteApiV1ManageDatasetIdInvitePutError,
    SendInviteApiV1ManageDatasetIdInvitePutVariables
  >({
    mutationFn: (variables: SendInviteApiV1ManageDatasetIdInvitePutVariables) =>
      fetchSendInviteApiV1ManageDatasetIdInvitePut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SendViewInviteApiV1ManageDatasetIdViewIdInvitePutPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  viewId: string;
};

export type SendViewInviteApiV1ManageDatasetIdViewIdInvitePutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SendViewInviteApiV1ManageDatasetIdViewIdInvitePutVariables = {
  pathParams: SendViewInviteApiV1ManageDatasetIdViewIdInvitePutPathParams;
} & VlContext["fetcherOptions"];

export const fetchSendViewInviteApiV1ManageDatasetIdViewIdInvitePut = (
  variables: SendViewInviteApiV1ManageDatasetIdViewIdInvitePutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    SendViewInviteApiV1ManageDatasetIdViewIdInvitePutError,
    undefined,
    {},
    {},
    SendViewInviteApiV1ManageDatasetIdViewIdInvitePutPathParams
  >({
    url: "/api/v1/manage/{datasetId}/{viewId}/invite",
    method: "put",
    ...variables,
    signal,
  });

export const useSendViewInviteApiV1ManageDatasetIdViewIdInvitePut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      SendViewInviteApiV1ManageDatasetIdViewIdInvitePutError,
      SendViewInviteApiV1ManageDatasetIdViewIdInvitePutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    SendViewInviteApiV1ManageDatasetIdViewIdInvitePutError,
    SendViewInviteApiV1ManageDatasetIdViewIdInvitePutVariables
  >({
    mutationFn: (
      variables: SendViewInviteApiV1ManageDatasetIdViewIdInvitePutVariables,
    ) =>
      fetchSendViewInviteApiV1ManageDatasetIdViewIdInvitePut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    revokeFromUserId: string;
  };

export type RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteVariables =
  {
    pathParams: RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchRevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDelete =
  (
    variables: RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteError,
      undefined,
      {},
      {},
      RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeletePathParams
    >({
      url: "/api/v1/manage/{datasetId}/share/{revokeFromUserId}",
      method: "delete",
      ...variables,
      signal,
    });

export const useRevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteError,
      RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteError,
    RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteVariables
  >({
    mutationFn: (
      variables: RevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDeleteVariables,
    ) =>
      fetchRevokeAccessApiV1ManageDatasetIdShareRevokeFromUserIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    revokeFromUserEmail: string;
  };

export type RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteVariables =
  {
    pathParams: RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchRevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDelete =
  (
    variables: RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteError,
      undefined,
      {},
      {},
      RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeletePathParams
    >({
      url: "/api/v1/manage/{datasetId}/invite/{revokeFromUserEmail}",
      method: "delete",
      ...variables,
      signal,
    });

export const useRevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteError,
        RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteError,
      RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteVariables
    >({
      mutationFn: (
        variables: RevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDeleteVariables,
      ) =>
        fetchRevokeInvitationApiV1ManageDatasetIdInviteRevokeFromUserEmailDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    targetUserId: string;
  };

export type UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchVariables =
  {
    body: Schemas.ClustplorerWebApiManageAccessUpdateRoleRequest;
    pathParams: UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchPathParams;
  } & VlContext["fetcherOptions"];

export const fetchUpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatch =
  (
    variables: UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchError,
      Schemas.ClustplorerWebApiManageAccessUpdateRoleRequest,
      {},
      {},
      UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchPathParams
    >({
      url: "/api/v1/manage/{datasetId}/share/{targetUserId}/role",
      method: "patch",
      ...variables,
      signal,
    });

export const useUpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchError,
      UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchError,
    UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchVariables
  >({
    mutationFn: (
      variables: UpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatchVariables,
    ) =>
      fetchUpdateUserRoleApiV1ManageDatasetIdShareTargetUserIdRolePatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type AuthApiV1AuthPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AuthApiV1AuthPostVariables = {
  body: Schemas.AuthRequestBody;
} & VlContext["fetcherOptions"];

export const fetchAuthApiV1AuthPost = (
  variables: AuthApiV1AuthPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, AuthApiV1AuthPostError, Schemas.AuthRequestBody, {}, {}, {}>({
    url: "/api/v1/auth",
    method: "post",
    ...variables,
    signal,
  });

export const useAuthApiV1AuthPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AuthApiV1AuthPostError,
      AuthApiV1AuthPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AuthApiV1AuthPostError,
    AuthApiV1AuthPostVariables
  >({
    mutationFn: (variables: AuthApiV1AuthPostVariables) =>
      fetchAuthApiV1AuthPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type AuthCheckApiV1AuthCheckGetError = Fetcher.ErrorWrapper<undefined>;

export type AuthCheckApiV1AuthCheckGetVariables = VlContext["fetcherOptions"];

/**
 * Check if the current request is authenticated.
 * Used by Caddy forward_auth to protect frontend routes.
 *
 * Returns 200 if:
 * - DISABLE_AUTH is true (auth bypassed)
 * - On-prem with user management disabled (anonymous access allowed)
 * - User has a valid session
 *
 * Returns 401 if authentication is required but not present.
 */
export const fetchAuthCheckApiV1AuthCheckGet = (
  variables: AuthCheckApiV1AuthCheckGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, AuthCheckApiV1AuthCheckGetError, undefined, {}, {}, {}>({
    url: "/api/v1/auth/check",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Check if the current request is authenticated.
 * Used by Caddy forward_auth to protect frontend routes.
 *
 * Returns 200 if:
 * - DISABLE_AUTH is true (auth bypassed)
 * - On-prem with user management disabled (anonymous access allowed)
 * - User has a valid session
 *
 * Returns 401 if authentication is required but not present.
 */
export function authCheckApiV1AuthCheckGetQuery(
  variables: AuthCheckApiV1AuthCheckGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function authCheckApiV1AuthCheckGetQuery(
  variables: AuthCheckApiV1AuthCheckGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function authCheckApiV1AuthCheckGetQuery(
  variables: AuthCheckApiV1AuthCheckGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/auth/check",
      operationId: "authCheckApiV1AuthCheckGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchAuthCheckApiV1AuthCheckGet(variables, signal),
  };
}

/**
 * Check if the current request is authenticated.
 * Used by Caddy forward_auth to protect frontend routes.
 *
 * Returns 200 if:
 * - DISABLE_AUTH is true (auth bypassed)
 * - On-prem with user management disabled (anonymous access allowed)
 * - User has a valid session
 *
 * Returns 401 if authentication is required but not present.
 */
export const useSuspenseAuthCheckApiV1AuthCheckGet = <TData = void>(
  variables: AuthCheckApiV1AuthCheckGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, AuthCheckApiV1AuthCheckGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    AuthCheckApiV1AuthCheckGetError,
    TData
  >({
    ...authCheckApiV1AuthCheckGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

/**
 * Check if the current request is authenticated.
 * Used by Caddy forward_auth to protect frontend routes.
 *
 * Returns 200 if:
 * - DISABLE_AUTH is true (auth bypassed)
 * - On-prem with user management disabled (anonymous access allowed)
 * - User has a valid session
 *
 * Returns 401 if authentication is required but not present.
 */
export const useAuthCheckApiV1AuthCheckGet = <TData = void>(
  variables: AuthCheckApiV1AuthCheckGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, AuthCheckApiV1AuthCheckGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, AuthCheckApiV1AuthCheckGetError, TData>({
    ...authCheckApiV1AuthCheckGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetUserRouteApiV1UserGetError = Fetcher.ErrorWrapper<undefined>;

export type GetUserRouteApiV1UserGetVariables = VlContext["fetcherOptions"];

export const fetchGetUserRouteApiV1UserGet = (
  variables: GetUserRouteApiV1UserGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<Schemas.User, GetUserRouteApiV1UserGetError, undefined, {}, {}, {}>({
    url: "/api/v1/user",
    method: "get",
    ...variables,
    signal,
  });

export function getUserRouteApiV1UserGetQuery(
  variables: GetUserRouteApiV1UserGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.User>;
};

export function getUserRouteApiV1UserGetQuery(
  variables: GetUserRouteApiV1UserGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.User>)
    | reactQuery.SkipToken;
};

export function getUserRouteApiV1UserGetQuery(
  variables: GetUserRouteApiV1UserGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/user",
      operationId: "getUserRouteApiV1UserGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUserRouteApiV1UserGet(variables, signal),
  };
}

export const useSuspenseGetUserRouteApiV1UserGet = <TData = Schemas.User>(
  variables: GetUserRouteApiV1UserGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.User,
      GetUserRouteApiV1UserGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.User,
    GetUserRouteApiV1UserGetError,
    TData
  >({
    ...getUserRouteApiV1UserGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetUserRouteApiV1UserGet = <TData = Schemas.User>(
  variables: GetUserRouteApiV1UserGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.User,
      GetUserRouteApiV1UserGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.User,
    GetUserRouteApiV1UserGetError,
    TData
  >({
    ...getUserRouteApiV1UserGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type PutUserApiV1UserPutError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type PutUserApiV1UserPutRequestBody = {
  [key: string]: any;
};

export type PutUserApiV1UserPutVariables = {
  body?: PutUserApiV1UserPutRequestBody;
} & VlContext["fetcherOptions"];

export const fetchPutUserApiV1UserPut = (
  variables: PutUserApiV1UserPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    PutUserApiV1UserPutError,
    PutUserApiV1UserPutRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v1/user", method: "put", ...variables, signal });

export const usePutUserApiV1UserPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      PutUserApiV1UserPutError,
      PutUserApiV1UserPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    PutUserApiV1UserPutError,
    PutUserApiV1UserPutVariables
  >({
    mutationFn: (variables: PutUserApiV1UserPutVariables) =>
      fetchPutUserApiV1UserPut(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type PutUserApiV1UserPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type PutUserApiV1UserPostRequestBody = {
  [key: string]: any;
};

export type PutUserApiV1UserPostVariables = {
  body?: PutUserApiV1UserPostRequestBody;
} & VlContext["fetcherOptions"];

export const fetchPutUserApiV1UserPost = (
  variables: PutUserApiV1UserPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    PutUserApiV1UserPostError,
    PutUserApiV1UserPostRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v1/user", method: "post", ...variables, signal });

export const usePutUserApiV1UserPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      PutUserApiV1UserPostError,
      PutUserApiV1UserPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    PutUserApiV1UserPostError,
    PutUserApiV1UserPostVariables
  >({
    mutationFn: (variables: PutUserApiV1UserPostVariables) =>
      fetchPutUserApiV1UserPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type GetPvldsApiV1PvldGetQueryParams = {
  /**
   * @default score
   */
  sort_by?: string;
};

export type GetPvldsApiV1PvldGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetPvldsApiV1PvldGetResponse = Schemas.DatasetOutput[];

export type GetPvldsApiV1PvldGetVariables = {
  queryParams?: GetPvldsApiV1PvldGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetPvldsApiV1PvldGet = (
  variables: GetPvldsApiV1PvldGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetPvldsApiV1PvldGetResponse,
    GetPvldsApiV1PvldGetError,
    undefined,
    {},
    GetPvldsApiV1PvldGetQueryParams,
    {}
  >({ url: "/api/v1/pvld", method: "get", ...variables, signal });

export function getPvldsApiV1PvldGetQuery(
  variables: GetPvldsApiV1PvldGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<GetPvldsApiV1PvldGetResponse>;
};

export function getPvldsApiV1PvldGetQuery(
  variables: GetPvldsApiV1PvldGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<GetPvldsApiV1PvldGetResponse>)
    | reactQuery.SkipToken;
};

export function getPvldsApiV1PvldGetQuery(
  variables: GetPvldsApiV1PvldGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/pvld",
      operationId: "getPvldsApiV1PvldGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetPvldsApiV1PvldGet(variables, signal),
  };
}

export const useSuspenseGetPvldsApiV1PvldGet = <
  TData = GetPvldsApiV1PvldGetResponse,
>(
  variables: GetPvldsApiV1PvldGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetPvldsApiV1PvldGetResponse,
      GetPvldsApiV1PvldGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetPvldsApiV1PvldGetResponse,
    GetPvldsApiV1PvldGetError,
    TData
  >({
    ...getPvldsApiV1PvldGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetPvldsApiV1PvldGet = <TData = GetPvldsApiV1PvldGetResponse>(
  variables: GetPvldsApiV1PvldGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetPvldsApiV1PvldGetResponse,
      GetPvldsApiV1PvldGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetPvldsApiV1PvldGetResponse,
    GetPvldsApiV1PvldGetError,
    TData
  >({
    ...getPvldsApiV1PvldGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetDatasetsApiV1DatasetsGetQueryParams = {
  /**
   * @default date
   */
  sort_by?: string;
  /**
   * @default false
   */
  include_hidden?: boolean;
  /**
   * @default false
   */
  wait?: boolean;
  etag?: string | null;
};

export type GetDatasetsApiV1DatasetsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetDatasetsApiV1DatasetsGetVariables = {
  queryParams?: GetDatasetsApiV1DatasetsGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetDatasetsApiV1DatasetsGet = (
  variables: GetDatasetsApiV1DatasetsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetDatasetsApiV1DatasetsGetError,
    undefined,
    {},
    GetDatasetsApiV1DatasetsGetQueryParams,
    {}
  >({ url: "/api/v1/datasets", method: "get", ...variables, signal });

export function getDatasetsApiV1DatasetsGetQuery(
  variables: GetDatasetsApiV1DatasetsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getDatasetsApiV1DatasetsGetQuery(
  variables: GetDatasetsApiV1DatasetsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getDatasetsApiV1DatasetsGetQuery(
  variables: GetDatasetsApiV1DatasetsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets",
      operationId: "getDatasetsApiV1DatasetsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetsApiV1DatasetsGet(variables, signal),
  };
}

export const useSuspenseGetDatasetsApiV1DatasetsGet = <TData = void>(
  variables: GetDatasetsApiV1DatasetsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetDatasetsApiV1DatasetsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetDatasetsApiV1DatasetsGetError,
    TData
  >({
    ...getDatasetsApiV1DatasetsGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetDatasetsApiV1DatasetsGet = <TData = void>(
  variables: GetDatasetsApiV1DatasetsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetDatasetsApiV1DatasetsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetDatasetsApiV1DatasetsGetError, TData>({
    ...getDatasetsApiV1DatasetsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetSampleDatasetsApiV1DatasetsSampleDataGetError =
  Fetcher.ErrorWrapper<undefined>;

export type GetSampleDatasetsApiV1DatasetsSampleDataGetResponse =
  Schemas.DatasetOutput[];

export type GetSampleDatasetsApiV1DatasetsSampleDataGetVariables =
  VlContext["fetcherOptions"];

export const fetchGetSampleDatasetsApiV1DatasetsSampleDataGet = (
  variables: GetSampleDatasetsApiV1DatasetsSampleDataGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
    GetSampleDatasetsApiV1DatasetsSampleDataGetError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v1/datasets/sample_data",
    method: "get",
    ...variables,
    signal,
  });

export function getSampleDatasetsApiV1DatasetsSampleDataGetQuery(
  variables: GetSampleDatasetsApiV1DatasetsSampleDataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSampleDatasetsApiV1DatasetsSampleDataGetResponse>;
};

export function getSampleDatasetsApiV1DatasetsSampleDataGetQuery(
  variables:
    | GetSampleDatasetsApiV1DatasetsSampleDataGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSampleDatasetsApiV1DatasetsSampleDataGetResponse>)
    | reactQuery.SkipToken;
};

export function getSampleDatasetsApiV1DatasetsSampleDataGetQuery(
  variables:
    | GetSampleDatasetsApiV1DatasetsSampleDataGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/sample_data",
      operationId: "getSampleDatasetsApiV1DatasetsSampleDataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSampleDatasetsApiV1DatasetsSampleDataGet(variables, signal),
  };
}

export const useSuspenseGetSampleDatasetsApiV1DatasetsSampleDataGet = <
  TData = GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
>(
  variables: GetSampleDatasetsApiV1DatasetsSampleDataGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
      GetSampleDatasetsApiV1DatasetsSampleDataGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
    GetSampleDatasetsApiV1DatasetsSampleDataGetError,
    TData
  >({
    ...getSampleDatasetsApiV1DatasetsSampleDataGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetSampleDatasetsApiV1DatasetsSampleDataGet = <
  TData = GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
>(
  variables:
    | GetSampleDatasetsApiV1DatasetsSampleDataGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
      GetSampleDatasetsApiV1DatasetsSampleDataGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetSampleDatasetsApiV1DatasetsSampleDataGetResponse,
    GetSampleDatasetsApiV1DatasetsSampleDataGetError,
    TData
  >({
    ...getSampleDatasetsApiV1DatasetsSampleDataGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetDatasetApiV1DatasetDatasetIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetApiV1DatasetDatasetIdGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetDatasetApiV1DatasetDatasetIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetDatasetApiV1DatasetDatasetIdGetVariables = {
  body?: GetDatasetApiV1DatasetDatasetIdGetRequestBody;
  pathParams: GetDatasetApiV1DatasetDatasetIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetDatasetApiV1DatasetDatasetIdGet = (
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    GetDatasetApiV1DatasetDatasetIdGetError,
    GetDatasetApiV1DatasetDatasetIdGetRequestBody,
    {},
    {},
    GetDatasetApiV1DatasetDatasetIdGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}",
    method: "get",
    ...variables,
    signal,
  });

export function getDatasetApiV1DatasetDatasetIdGetQuery(
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DatasetOutput>;
};

export function getDatasetApiV1DatasetDatasetIdGetQuery(
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.DatasetOutput>)
    | reactQuery.SkipToken;
};

export function getDatasetApiV1DatasetDatasetIdGetQuery(
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}",
      operationId: "getDatasetApiV1DatasetDatasetIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetApiV1DatasetDatasetIdGet(variables, signal),
  };
}

export const useSuspenseGetDatasetApiV1DatasetDatasetIdGet = <
  TData = Schemas.DatasetOutput,
>(
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      GetDatasetApiV1DatasetDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DatasetOutput,
    GetDatasetApiV1DatasetDatasetIdGetError,
    TData
  >({
    ...getDatasetApiV1DatasetDatasetIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetDatasetApiV1DatasetDatasetIdGet = <
  TData = Schemas.DatasetOutput,
>(
  variables: GetDatasetApiV1DatasetDatasetIdGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      GetDatasetApiV1DatasetDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.DatasetOutput,
    GetDatasetApiV1DatasetDatasetIdGetError,
    TData
  >({
    ...getDatasetApiV1DatasetDatasetIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DeleteDatasetApiV1DatasetDatasetIdDeletePathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type DeleteDatasetApiV1DatasetDatasetIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteDatasetApiV1DatasetDatasetIdDeleteRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type DeleteDatasetApiV1DatasetDatasetIdDeleteVariables = {
  body?: DeleteDatasetApiV1DatasetDatasetIdDeleteRequestBody;
  pathParams: DeleteDatasetApiV1DatasetDatasetIdDeletePathParams;
} & VlContext["fetcherOptions"];

export const fetchDeleteDatasetApiV1DatasetDatasetIdDelete = (
  variables: DeleteDatasetApiV1DatasetDatasetIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DeleteDatasetApiV1DatasetDatasetIdDeleteError,
    DeleteDatasetApiV1DatasetDatasetIdDeleteRequestBody,
    {},
    {},
    DeleteDatasetApiV1DatasetDatasetIdDeletePathParams
  >({
    url: "/api/v1/dataset/{datasetId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteDatasetApiV1DatasetDatasetIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteDatasetApiV1DatasetDatasetIdDeleteError,
      DeleteDatasetApiV1DatasetDatasetIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteDatasetApiV1DatasetDatasetIdDeleteError,
    DeleteDatasetApiV1DatasetDatasetIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteDatasetApiV1DatasetDatasetIdDeleteVariables,
    ) =>
      fetchDeleteDatasetApiV1DatasetDatasetIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type UpdateDatasetApiV1DatasetDatasetIdPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type UpdateDatasetApiV1DatasetDatasetIdPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateDatasetApiV1DatasetDatasetIdPostVariables = {
  pathParams: UpdateDatasetApiV1DatasetDatasetIdPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchUpdateDatasetApiV1DatasetDatasetIdPost = (
  variables: UpdateDatasetApiV1DatasetDatasetIdPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    UpdateDatasetApiV1DatasetDatasetIdPostError,
    undefined,
    {},
    {},
    UpdateDatasetApiV1DatasetDatasetIdPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}",
    method: "post",
    ...variables,
    signal,
  });

export const useUpdateDatasetApiV1DatasetDatasetIdPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UpdateDatasetApiV1DatasetDatasetIdPostError,
      UpdateDatasetApiV1DatasetDatasetIdPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UpdateDatasetApiV1DatasetDatasetIdPostError,
    UpdateDatasetApiV1DatasetDatasetIdPostVariables
  >({
    mutationFn: (variables: UpdateDatasetApiV1DatasetDatasetIdPostVariables) =>
      fetchUpdateDatasetApiV1DatasetDatasetIdPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetDatasetStatsApiV1DatasetDatasetIdStatsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetStatsApiV1DatasetDatasetIdStatsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetStatsApiV1DatasetDatasetIdStatsGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables = {
  body?: GetDatasetStatsApiV1DatasetDatasetIdStatsGetRequestBody;
  pathParams: GetDatasetStatsApiV1DatasetDatasetIdStatsGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetDatasetStatsApiV1DatasetDatasetIdStatsGet = (
  variables: GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetDatasetStatsApiV1DatasetDatasetIdStatsGetError,
    GetDatasetStatsApiV1DatasetDatasetIdStatsGetRequestBody,
    {},
    {},
    GetDatasetStatsApiV1DatasetDatasetIdStatsGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/stats",
    method: "get",
    ...variables,
    signal,
  });

export function getDatasetStatsApiV1DatasetDatasetIdStatsGetQuery(
  variables: GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getDatasetStatsApiV1DatasetDatasetIdStatsGetQuery(
  variables:
    | GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getDatasetStatsApiV1DatasetDatasetIdStatsGetQuery(
  variables:
    | GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/stats",
      operationId: "getDatasetStatsApiV1DatasetDatasetIdStatsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetStatsApiV1DatasetDatasetIdStatsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetDatasetStatsApiV1DatasetDatasetIdStatsGet = <
  TData = void,
>(
  variables: GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetDatasetStatsApiV1DatasetDatasetIdStatsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetDatasetStatsApiV1DatasetDatasetIdStatsGetError,
    TData
  >({
    ...getDatasetStatsApiV1DatasetDatasetIdStatsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetDatasetStatsApiV1DatasetDatasetIdStatsGet = <TData = void>(
  variables:
    | GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetDatasetStatsApiV1DatasetDatasetIdStatsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetDatasetStatsApiV1DatasetDatasetIdStatsGetError,
    TData
  >({
    ...getDatasetStatsApiV1DatasetDatasetIdStatsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetPathParams =
  {
    clusterId: string | null;
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQueryParams =
  {
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse =

    | {
        [key: string]: any;
      }[]
    | null;

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetRequestBody =
  Schemas.AccessOperation[] | null;

export type GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables =
  {
    body?: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetRequestBody;
    pathParams: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetPathParams;
    queryParams?: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchGetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet =
  (
    variables: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError,
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetRequestBody,
      {},
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQueryParams,
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/issues",
      method: "get",
      ...variables,
      signal,
    });

export function getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQuery(
  variables: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse>;
};

export function getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQuery(
  variables:
    | GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse>)
    | reactQuery.SkipToken;
};

export function getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQuery(
  variables:
    | GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/issues",
      operationId:
        "getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet =
  <
    TData = GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
  >(
    variables: GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
        GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError,
      TData
    >({
      ...getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet =
  <
    TData = GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
  >(
    variables:
      | GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
        GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetResponse,
      GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetError,
      TData
    >({
      ...getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQueryParams = {
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse =
  | {
      [key: string]: any;
    }[]
  | null;

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables = {
  body?: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetRequestBody;
  pathParams: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetPathParams;
  queryParams?: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet = (
  variables: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError,
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetRequestBody,
    {},
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQueryParams,
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/issue_types_of_entities",
    method: "get",
    ...variables,
    signal,
  });

export function getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQuery(
  variables: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse>;
};

export function getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQuery(
  variables:
    | GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse>)
    | reactQuery.SkipToken;
};

export function getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQuery(
  variables:
    | GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/issue_types_of_entities",
      operationId: "getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet =
  <TData = GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse>(
    variables: GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
        GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
      GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError,
      TData
    >({
      ...getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet = <
  TData = GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
>(
  variables:
    | GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
      GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetResponse,
    GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetError,
    TData
  >({
    ...getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type HardDeleteDatasetApiV1DatasetDatasetIdHardDeletePathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteVariables = {
  body?: HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteRequestBody;
  pathParams: HardDeleteDatasetApiV1DatasetDatasetIdHardDeletePathParams;
} & VlContext["fetcherOptions"];

export const fetchHardDeleteDatasetApiV1DatasetDatasetIdHardDelete = (
  variables: HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteError,
    HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteRequestBody,
    {},
    {},
    HardDeleteDatasetApiV1DatasetDatasetIdHardDeletePathParams
  >({
    url: "/api/v1/dataset/{datasetId}/hard",
    method: "delete",
    ...variables,
    signal,
  });

export const useHardDeleteDatasetApiV1DatasetDatasetIdHardDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteError,
      HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteError,
    HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteVariables
  >({
    mutationFn: (
      variables: HardDeleteDatasetApiV1DatasetDatasetIdHardDeleteVariables,
    ) =>
      fetchHardDeleteDatasetApiV1DatasetDatasetIdHardDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutVariables = {
  body: Schemas.BodyUpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPut;
  pathParams: UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutPathParams;
} & VlContext["fetcherOptions"];

/**
 * Update the model pack for a dataset.
 *
 * Model pack can only be changed when the dataset is in DRAFT status (being created).
 * Once the dataset moves to any other status, the model pack becomes immutable.
 *
 * Args:
 *     dataset_id: UUID of the dataset
 *     model_pack: The model pack to set (VL_MINI, VL_LARGE, or VL_ANALYST)
 *     user: Authenticated user
 *
 * Returns:
 *     HTTP 200 OK if successful
 *     HTTP 400 Bad Request if dataset is not in DRAFT status
 *     HTTP 401 Unauthorized if user lacks permission
 */
export const fetchUpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPut = (
  variables: UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutError,
    Schemas.BodyUpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPut,
    {},
    {},
    UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/model_pack",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update the model pack for a dataset.
 *
 * Model pack can only be changed when the dataset is in DRAFT status (being created).
 * Once the dataset moves to any other status, the model pack becomes immutable.
 *
 * Args:
 *     dataset_id: UUID of the dataset
 *     model_pack: The model pack to set (VL_MINI, VL_LARGE, or VL_ANALYST)
 *     user: Authenticated user
 *
 * Returns:
 *     HTTP 200 OK if successful
 *     HTTP 400 Bad Request if dataset is not in DRAFT status
 *     HTTP 401 Unauthorized if user lacks permission
 */
export const useUpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutError,
      UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutError,
    UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutVariables
  >({
    mutationFn: (
      variables: UpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPutVariables,
    ) =>
      fetchUpdateDatasetModelPackApiV1DatasetDatasetIdModelPackPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type UploadToDatasetApiV1DatasetDatasetIdUploadPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type UploadToDatasetApiV1DatasetDatasetIdUploadPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadToDatasetApiV1DatasetDatasetIdUploadPostVariables = {
  body: Schemas.BodyUploadToDatasetApiV1DatasetDatasetIdUploadPost;
  pathParams: UploadToDatasetApiV1DatasetDatasetIdUploadPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchUploadToDatasetApiV1DatasetDatasetIdUploadPost = (
  variables: UploadToDatasetApiV1DatasetDatasetIdUploadPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    UploadToDatasetApiV1DatasetDatasetIdUploadPostError,
    Schemas.BodyUploadToDatasetApiV1DatasetDatasetIdUploadPost,
    {},
    {},
    UploadToDatasetApiV1DatasetDatasetIdUploadPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/upload",
    method: "post",
    ...variables,
    signal,
  });

export const useUploadToDatasetApiV1DatasetDatasetIdUploadPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UploadToDatasetApiV1DatasetDatasetIdUploadPostError,
      UploadToDatasetApiV1DatasetDatasetIdUploadPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UploadToDatasetApiV1DatasetDatasetIdUploadPostError,
    UploadToDatasetApiV1DatasetDatasetIdUploadPostVariables
  >({
    mutationFn: (
      variables: UploadToDatasetApiV1DatasetDatasetIdUploadPostVariables,
    ) =>
      fetchUploadToDatasetApiV1DatasetDatasetIdUploadPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQueryParams = {
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse =
  | {
      [key: string]: any;
    }[]
  | null;

export type GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables = {
  pathParams: GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetPathParams;
  queryParams?: GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet = (
  variables: GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError,
    undefined,
    {},
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQueryParams,
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/tags",
    method: "get",
    ...variables,
    signal,
  });

export function getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQuery(
  variables: GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse>;
};

export function getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQuery(
  variables:
    | GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse>)
    | reactQuery.SkipToken;
};

export function getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQuery(
  variables:
    | GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/tags",
      operationId: "getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet = <
  TData = GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
>(
  variables: GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
      GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError,
    TData
  >({
    ...getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet = <
  TData = GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
>(
  variables:
    | GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
      GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetResponse,
    GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetError,
    TData
  >({
    ...getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostVariables = {
  body: Schemas.BodyAddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPost;
  pathParams: AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchAddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPost = (
  variables: AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostError,
    Schemas.BodyAddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPost,
    {},
    {},
    AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/tags",
    method: "post",
    ...variables,
    signal,
  });

export const useAddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostError,
      AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostError,
    AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostVariables
  >({
    mutationFn: (
      variables: AddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPostVariables,
    ) =>
      fetchAddTagToMediaOrClusterApiV1DatasetDatasetIdTagsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetPathParams =
  {
    clusterId: string | null;
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQueryParams =
  {
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse =

    | {
        [key: string]: any;
      }[]
    | null;

export type GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables =
  {
    pathParams: GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetPathParams;
    queryParams?: GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchGetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet =
  (
    variables: GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError,
      undefined,
      {},
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQueryParams,
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/tags",
      method: "get",
      ...variables,
      signal,
    });

export function getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQuery(
  variables: GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse>;
};

export function getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQuery(
  variables:
    | GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse>)
    | reactQuery.SkipToken;
};

export function getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQuery(
  variables:
    | GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/tags",
      operationId:
        "getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet =
  <
    TData = GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
  >(
    variables: GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
        GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError,
      TData
    >({
      ...getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet =
  <
    TData = GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
  >(
    variables:
      | GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
        GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetResponse,
      GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetError,
      TData
    >({
      ...getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type ShareDatasetApiV1DatasetDatasetIdSharePostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ShareDatasetApiV1DatasetDatasetIdSharePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ShareDatasetApiV1DatasetDatasetIdSharePostVariables = {
  pathParams: ShareDatasetApiV1DatasetDatasetIdSharePostPathParams;
} & VlContext["fetcherOptions"];

export const fetchShareDatasetApiV1DatasetDatasetIdSharePost = (
  variables: ShareDatasetApiV1DatasetDatasetIdSharePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ShareDatasetApiV1DatasetDatasetIdSharePostError,
    undefined,
    {},
    {},
    ShareDatasetApiV1DatasetDatasetIdSharePostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/share",
    method: "post",
    ...variables,
    signal,
  });

export const useShareDatasetApiV1DatasetDatasetIdSharePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ShareDatasetApiV1DatasetDatasetIdSharePostError,
      ShareDatasetApiV1DatasetDatasetIdSharePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ShareDatasetApiV1DatasetDatasetIdSharePostError,
    ShareDatasetApiV1DatasetDatasetIdSharePostVariables
  >({
    mutationFn: (
      variables: ShareDatasetApiV1DatasetDatasetIdSharePostVariables,
    ) =>
      fetchShareDatasetApiV1DatasetDatasetIdSharePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables = {
  body?: GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetRequestBody;
  pathParams: GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet = (
  variables: GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError,
    GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetRequestBody,
    {},
    {},
    GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/label_sources",
    method: "get",
    ...variables,
    signal,
  });

export function getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetQuery(
  variables: GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetQuery(
  variables:
    | GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetQuery(
  variables:
    | GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/label_sources",
      operationId: "getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet =
  <TData = void>(
    variables: GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError,
      TData
    >({
      ...getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet = <
  TData = void,
>(
  variables:
    | GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetError,
    TData
  >({
    ...getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RequestFeatureApiV1RequestFeaturePostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type RequestFeatureApiV1RequestFeaturePostVariables =
  VlContext["fetcherOptions"];

export const fetchRequestFeatureApiV1RequestFeaturePost = (
  variables: RequestFeatureApiV1RequestFeaturePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    RequestFeatureApiV1RequestFeaturePostError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/request_feature", method: "post", ...variables, signal });

export const useRequestFeatureApiV1RequestFeaturePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      RequestFeatureApiV1RequestFeaturePostError,
      RequestFeatureApiV1RequestFeaturePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    RequestFeatureApiV1RequestFeaturePostError,
    RequestFeatureApiV1RequestFeaturePostVariables
  >({
    mutationFn: (variables: RequestFeatureApiV1RequestFeaturePostVariables) =>
      fetchRequestFeatureApiV1RequestFeaturePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type HealthcheckApiV1HealthcheckGetError =
  Fetcher.ErrorWrapper<undefined>;

export type HealthcheckApiV1HealthcheckGetVariables =
  VlContext["fetcherOptions"];

export const fetchHealthcheckApiV1HealthcheckGet = (
  variables: HealthcheckApiV1HealthcheckGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, HealthcheckApiV1HealthcheckGetError, undefined, {}, {}, {}>({
    url: "/api/v1/healthcheck",
    method: "get",
    ...variables,
    signal,
  });

export function healthcheckApiV1HealthcheckGetQuery(
  variables: HealthcheckApiV1HealthcheckGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function healthcheckApiV1HealthcheckGetQuery(
  variables: HealthcheckApiV1HealthcheckGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function healthcheckApiV1HealthcheckGetQuery(
  variables: HealthcheckApiV1HealthcheckGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/healthcheck",
      operationId: "healthcheckApiV1HealthcheckGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchHealthcheckApiV1HealthcheckGet(variables, signal),
  };
}

export const useSuspenseHealthcheckApiV1HealthcheckGet = <TData = void>(
  variables: HealthcheckApiV1HealthcheckGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      HealthcheckApiV1HealthcheckGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    HealthcheckApiV1HealthcheckGetError,
    TData
  >({
    ...healthcheckApiV1HealthcheckGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useHealthcheckApiV1HealthcheckGet = <TData = void>(
  variables: HealthcheckApiV1HealthcheckGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      HealthcheckApiV1HealthcheckGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, HealthcheckApiV1HealthcheckGetError, TData>({
    ...healthcheckApiV1HealthcheckGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetVersionApiV1VersionGetError = Fetcher.ErrorWrapper<undefined>;

export type GetVersionApiV1VersionGetVariables = VlContext["fetcherOptions"];

export const fetchGetVersionApiV1VersionGet = (
  variables: GetVersionApiV1VersionGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, GetVersionApiV1VersionGetError, undefined, {}, {}, {}>({
    url: "/api/v1/version",
    method: "get",
    ...variables,
    signal,
  });

export function getVersionApiV1VersionGetQuery(
  variables: GetVersionApiV1VersionGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getVersionApiV1VersionGetQuery(
  variables: GetVersionApiV1VersionGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getVersionApiV1VersionGetQuery(
  variables: GetVersionApiV1VersionGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/version",
      operationId: "getVersionApiV1VersionGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetVersionApiV1VersionGet(variables, signal),
  };
}

export const useSuspenseGetVersionApiV1VersionGet = <TData = void>(
  variables: GetVersionApiV1VersionGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetVersionApiV1VersionGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetVersionApiV1VersionGetError,
    TData
  >({
    ...getVersionApiV1VersionGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetVersionApiV1VersionGet = <TData = void>(
  variables: GetVersionApiV1VersionGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetVersionApiV1VersionGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetVersionApiV1VersionGetError, TData>({
    ...getVersionApiV1VersionGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetUserConfigApiV1UserConfigGetQueryParams = {
  dataset_id?: string | null;
};

export type GetUserConfigApiV1UserConfigGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUserConfigApiV1UserConfigGetVariables = {
  queryParams?: GetUserConfigApiV1UserConfigGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetUserConfigApiV1UserConfigGet = (
  variables: GetUserConfigApiV1UserConfigGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetUserConfigApiV1UserConfigGetError,
    undefined,
    {},
    GetUserConfigApiV1UserConfigGetQueryParams,
    {}
  >({ url: "/api/v1/user_config", method: "get", ...variables, signal });

export function getUserConfigApiV1UserConfigGetQuery(
  variables: GetUserConfigApiV1UserConfigGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getUserConfigApiV1UserConfigGetQuery(
  variables: GetUserConfigApiV1UserConfigGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getUserConfigApiV1UserConfigGetQuery(
  variables: GetUserConfigApiV1UserConfigGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/user_config",
      operationId: "getUserConfigApiV1UserConfigGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUserConfigApiV1UserConfigGet(variables, signal),
  };
}

export const useSuspenseGetUserConfigApiV1UserConfigGet = <TData = void>(
  variables: GetUserConfigApiV1UserConfigGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetUserConfigApiV1UserConfigGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetUserConfigApiV1UserConfigGetError,
    TData
  >({
    ...getUserConfigApiV1UserConfigGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetUserConfigApiV1UserConfigGet = <TData = void>(
  variables: GetUserConfigApiV1UserConfigGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetUserConfigApiV1UserConfigGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetUserConfigApiV1UserConfigGetError, TData>(
    {
      ...getUserConfigApiV1UserConfigGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    },
  );
};

export type TestBucketConnectivityApiV1BucketGetQueryParams = {
  bucket_path: string;
};

export type TestBucketConnectivityApiV1BucketGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type TestBucketConnectivityApiV1BucketGetVariables = {
  queryParams: TestBucketConnectivityApiV1BucketGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchTestBucketConnectivityApiV1BucketGet = (
  variables: TestBucketConnectivityApiV1BucketGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    TestBucketConnectivityApiV1BucketGetError,
    undefined,
    {},
    TestBucketConnectivityApiV1BucketGetQueryParams,
    {}
  >({ url: "/api/v1/bucket", method: "get", ...variables, signal });

export function testBucketConnectivityApiV1BucketGetQuery(
  variables: TestBucketConnectivityApiV1BucketGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function testBucketConnectivityApiV1BucketGetQuery(
  variables:
    | TestBucketConnectivityApiV1BucketGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function testBucketConnectivityApiV1BucketGetQuery(
  variables:
    | TestBucketConnectivityApiV1BucketGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/bucket",
      operationId: "testBucketConnectivityApiV1BucketGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchTestBucketConnectivityApiV1BucketGet(variables, signal),
  };
}

export const useSuspenseTestBucketConnectivityApiV1BucketGet = <TData = void>(
  variables: TestBucketConnectivityApiV1BucketGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      TestBucketConnectivityApiV1BucketGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    TestBucketConnectivityApiV1BucketGetError,
    TData
  >({
    ...testBucketConnectivityApiV1BucketGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useTestBucketConnectivityApiV1BucketGet = <TData = void>(
  variables:
    | TestBucketConnectivityApiV1BucketGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      TestBucketConnectivityApiV1BucketGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    TestBucketConnectivityApiV1BucketGetError,
    TData
  >({
    ...testBucketConnectivityApiV1BucketGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type BackofficeBackofficeGetError = Fetcher.ErrorWrapper<undefined>;

export type BackofficeBackofficeGetVariables = VlContext["fetcherOptions"];

export const fetchBackofficeBackofficeGet = (
  variables: BackofficeBackofficeGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<undefined, BackofficeBackofficeGetError, undefined, {}, {}, {}>({
    url: "/backoffice",
    method: "get",
    ...variables,
    signal,
  });

export function backofficeBackofficeGetQuery(
  variables: BackofficeBackofficeGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function backofficeBackofficeGetQuery(
  variables: BackofficeBackofficeGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<undefined>)
    | reactQuery.SkipToken;
};

export function backofficeBackofficeGetQuery(
  variables: BackofficeBackofficeGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/backoffice",
      operationId: "backofficeBackofficeGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchBackofficeBackofficeGet(variables, signal),
  };
}

export const useSuspenseBackofficeBackofficeGet = <TData = undefined>(
  variables: BackofficeBackofficeGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BackofficeBackofficeGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    undefined,
    BackofficeBackofficeGetError,
    TData
  >({
    ...backofficeBackofficeGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBackofficeBackofficeGet = <TData = undefined>(
  variables: BackofficeBackofficeGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BackofficeBackofficeGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<undefined, BackofficeBackofficeGetError, TData>({
    ...backofficeBackofficeGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type MustacheMustacheGetError = Fetcher.ErrorWrapper<undefined>;

export type MustacheMustacheGetVariables = VlContext["fetcherOptions"];

export const fetchMustacheMustacheGet = (
  variables: MustacheMustacheGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<undefined, MustacheMustacheGetError, undefined, {}, {}, {}>({
    url: "/mustache",
    method: "get",
    ...variables,
    signal,
  });

export function mustacheMustacheGetQuery(
  variables: MustacheMustacheGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function mustacheMustacheGetQuery(
  variables: MustacheMustacheGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<undefined>)
    | reactQuery.SkipToken;
};

export function mustacheMustacheGetQuery(
  variables: MustacheMustacheGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/mustache",
      operationId: "mustacheMustacheGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchMustacheMustacheGet(variables, signal),
  };
}

export const useSuspenseMustacheMustacheGet = <TData = undefined>(
  variables: MustacheMustacheGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, MustacheMustacheGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    undefined,
    MustacheMustacheGetError,
    TData
  >({
    ...mustacheMustacheGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useMustacheMustacheGet = <TData = undefined>(
  variables: MustacheMustacheGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, MustacheMustacheGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<undefined, MustacheMustacheGetError, TData>({
    ...mustacheMustacheGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GithubSsoEnvApiV1GithubSsoEnvGetPathParams = {
  env: string;
};

export type GithubSsoEnvApiV1GithubSsoEnvGetQueryParams = {
  code: string;
  state: string;
};

export type GithubSsoEnvApiV1GithubSsoEnvGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GithubSsoEnvApiV1GithubSsoEnvGetVariables = {
  pathParams: GithubSsoEnvApiV1GithubSsoEnvGetPathParams;
  queryParams: GithubSsoEnvApiV1GithubSsoEnvGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGithubSsoEnvApiV1GithubSsoEnvGet = (
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GithubSsoEnvApiV1GithubSsoEnvGetError,
    undefined,
    {},
    GithubSsoEnvApiV1GithubSsoEnvGetQueryParams,
    GithubSsoEnvApiV1GithubSsoEnvGetPathParams
  >({ url: "/api/v1/github-sso/{env}", method: "get", ...variables, signal });

export function githubSsoEnvApiV1GithubSsoEnvGetQuery(
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function githubSsoEnvApiV1GithubSsoEnvGetQuery(
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function githubSsoEnvApiV1GithubSsoEnvGetQuery(
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/github-sso/{env}",
      operationId: "githubSsoEnvApiV1GithubSsoEnvGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGithubSsoEnvApiV1GithubSsoEnvGet(variables, signal),
  };
}

export const useSuspenseGithubSsoEnvApiV1GithubSsoEnvGet = <TData = void>(
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GithubSsoEnvApiV1GithubSsoEnvGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GithubSsoEnvApiV1GithubSsoEnvGetError,
    TData
  >({
    ...githubSsoEnvApiV1GithubSsoEnvGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGithubSsoEnvApiV1GithubSsoEnvGet = <TData = void>(
  variables: GithubSsoEnvApiV1GithubSsoEnvGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GithubSsoEnvApiV1GithubSsoEnvGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GithubSsoEnvApiV1GithubSsoEnvGetError,
    TData
  >({
    ...githubSsoEnvApiV1GithubSsoEnvGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GithubSsoApiV1GithubSsoGetQueryParams = {
  code: string;
  state: string;
};

export type GithubSsoApiV1GithubSsoGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GithubSsoApiV1GithubSsoGetVariables = {
  queryParams: GithubSsoApiV1GithubSsoGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGithubSsoApiV1GithubSsoGet = (
  variables: GithubSsoApiV1GithubSsoGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GithubSsoApiV1GithubSsoGetError,
    undefined,
    {},
    GithubSsoApiV1GithubSsoGetQueryParams,
    {}
  >({ url: "/api/v1/github-sso", method: "get", ...variables, signal });

export function githubSsoApiV1GithubSsoGetQuery(
  variables: GithubSsoApiV1GithubSsoGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function githubSsoApiV1GithubSsoGetQuery(
  variables: GithubSsoApiV1GithubSsoGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function githubSsoApiV1GithubSsoGetQuery(
  variables: GithubSsoApiV1GithubSsoGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/github-sso",
      operationId: "githubSsoApiV1GithubSsoGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGithubSsoApiV1GithubSsoGet(variables, signal),
  };
}

export const useSuspenseGithubSsoApiV1GithubSsoGet = <TData = void>(
  variables: GithubSsoApiV1GithubSsoGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GithubSsoApiV1GithubSsoGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GithubSsoApiV1GithubSsoGetError,
    TData
  >({
    ...githubSsoApiV1GithubSsoGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGithubSsoApiV1GithubSsoGet = <TData = void>(
  variables: GithubSsoApiV1GithubSsoGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GithubSsoApiV1GithubSsoGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GithubSsoApiV1GithubSsoGetError, TData>({
    ...githubSsoApiV1GithubSsoGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GoogleSsoApiV1GoogleSsoPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GoogleSsoApiV1GoogleSsoPostVariables = VlContext["fetcherOptions"];

export const fetchGoogleSsoApiV1GoogleSsoPost = (
  variables: GoogleSsoApiV1GoogleSsoPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, GoogleSsoApiV1GoogleSsoPostError, undefined, {}, {}, {}>({
    url: "/api/v1/google-sso",
    method: "post",
    ...variables,
    signal,
  });

export const useGoogleSsoApiV1GoogleSsoPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      GoogleSsoApiV1GoogleSsoPostError,
      GoogleSsoApiV1GoogleSsoPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    GoogleSsoApiV1GoogleSsoPostError,
    GoogleSsoApiV1GoogleSsoPostVariables
  >({
    mutationFn: (variables: GoogleSsoApiV1GoogleSsoPostVariables) =>
      fetchGoogleSsoApiV1GoogleSsoPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type OidcLogoutApiV1OidcLogoutGetError = Fetcher.ErrorWrapper<undefined>;

export type OidcLogoutApiV1OidcLogoutGetVariables = VlContext["fetcherOptions"];

/**
 * End the OIDC session by redirecting to the IdP's end_session_endpoint.
 * Clears all session cookies before redirecting.
 */
export const fetchOidcLogoutApiV1OidcLogoutGet = (
  variables: OidcLogoutApiV1OidcLogoutGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, OidcLogoutApiV1OidcLogoutGetError, undefined, {}, {}, {}>({
    url: "/api/v1/oidc/logout",
    method: "get",
    ...variables,
    signal,
  });

/**
 * End the OIDC session by redirecting to the IdP's end_session_endpoint.
 * Clears all session cookies before redirecting.
 */
export function oidcLogoutApiV1OidcLogoutGetQuery(
  variables: OidcLogoutApiV1OidcLogoutGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function oidcLogoutApiV1OidcLogoutGetQuery(
  variables: OidcLogoutApiV1OidcLogoutGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function oidcLogoutApiV1OidcLogoutGetQuery(
  variables: OidcLogoutApiV1OidcLogoutGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/oidc/logout",
      operationId: "oidcLogoutApiV1OidcLogoutGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchOidcLogoutApiV1OidcLogoutGet(variables, signal),
  };
}

/**
 * End the OIDC session by redirecting to the IdP's end_session_endpoint.
 * Clears all session cookies before redirecting.
 */
export const useSuspenseOidcLogoutApiV1OidcLogoutGet = <TData = void>(
  variables: OidcLogoutApiV1OidcLogoutGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, OidcLogoutApiV1OidcLogoutGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    OidcLogoutApiV1OidcLogoutGetError,
    TData
  >({
    ...oidcLogoutApiV1OidcLogoutGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

/**
 * End the OIDC session by redirecting to the IdP's end_session_endpoint.
 * Clears all session cookies before redirecting.
 */
export const useOidcLogoutApiV1OidcLogoutGet = <TData = void>(
  variables: OidcLogoutApiV1OidcLogoutGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, OidcLogoutApiV1OidcLogoutGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, OidcLogoutApiV1OidcLogoutGetError, TData>({
    ...oidcLogoutApiV1OidcLogoutGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type OidcLoginApiV1OidcLoginGetError = Fetcher.ErrorWrapper<undefined>;

export type OidcLoginApiV1OidcLoginGetVariables = VlContext["fetcherOptions"];

export const fetchOidcLoginApiV1OidcLoginGet = (
  variables: OidcLoginApiV1OidcLoginGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, OidcLoginApiV1OidcLoginGetError, undefined, {}, {}, {}>({
    url: "/api/v1/oidc/login",
    method: "get",
    ...variables,
    signal,
  });

export function oidcLoginApiV1OidcLoginGetQuery(
  variables: OidcLoginApiV1OidcLoginGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function oidcLoginApiV1OidcLoginGetQuery(
  variables: OidcLoginApiV1OidcLoginGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function oidcLoginApiV1OidcLoginGetQuery(
  variables: OidcLoginApiV1OidcLoginGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/oidc/login",
      operationId: "oidcLoginApiV1OidcLoginGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchOidcLoginApiV1OidcLoginGet(variables, signal),
  };
}

export const useSuspenseOidcLoginApiV1OidcLoginGet = <TData = void>(
  variables: OidcLoginApiV1OidcLoginGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, OidcLoginApiV1OidcLoginGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    OidcLoginApiV1OidcLoginGetError,
    TData
  >({
    ...oidcLoginApiV1OidcLoginGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOidcLoginApiV1OidcLoginGet = <TData = void>(
  variables: OidcLoginApiV1OidcLoginGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, OidcLoginApiV1OidcLoginGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, OidcLoginApiV1OidcLoginGetError, TData>({
    ...oidcLoginApiV1OidcLoginGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type OidcCallbackApiV1OidcCallbackGetError =
  Fetcher.ErrorWrapper<undefined>;

export type OidcCallbackApiV1OidcCallbackGetVariables =
  VlContext["fetcherOptions"];

/**
 * Handle the OIDC callback: exchange code, validate token, fetch user info, and set user session.
 */
export const fetchOidcCallbackApiV1OidcCallbackGet = (
  variables: OidcCallbackApiV1OidcCallbackGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, OidcCallbackApiV1OidcCallbackGetError, undefined, {}, {}, {}>({
    url: "/api/v1/oidc/callback",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Handle the OIDC callback: exchange code, validate token, fetch user info, and set user session.
 */
export function oidcCallbackApiV1OidcCallbackGetQuery(
  variables: OidcCallbackApiV1OidcCallbackGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function oidcCallbackApiV1OidcCallbackGetQuery(
  variables: OidcCallbackApiV1OidcCallbackGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function oidcCallbackApiV1OidcCallbackGetQuery(
  variables: OidcCallbackApiV1OidcCallbackGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/oidc/callback",
      operationId: "oidcCallbackApiV1OidcCallbackGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchOidcCallbackApiV1OidcCallbackGet(variables, signal),
  };
}

/**
 * Handle the OIDC callback: exchange code, validate token, fetch user info, and set user session.
 */
export const useSuspenseOidcCallbackApiV1OidcCallbackGet = <TData = void>(
  variables: OidcCallbackApiV1OidcCallbackGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      OidcCallbackApiV1OidcCallbackGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    OidcCallbackApiV1OidcCallbackGetError,
    TData
  >({
    ...oidcCallbackApiV1OidcCallbackGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Handle the OIDC callback: exchange code, validate token, fetch user info, and set user session.
 */
export const useOidcCallbackApiV1OidcCallbackGet = <TData = void>(
  variables: OidcCallbackApiV1OidcCallbackGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      OidcCallbackApiV1OidcCallbackGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    OidcCallbackApiV1OidcCallbackGetError,
    TData
  >({
    ...oidcCallbackApiV1OidcCallbackGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetImageApiV1DatasetImageDatasetIdImageIdGetPathParams = {
  /**
   * @format uuid
   */
  imageId: string;
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetImageApiV1DatasetImageDatasetIdImageIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetImageApiV1DatasetImageDatasetIdImageIdGetVariables = {
  pathParams: GetImageApiV1DatasetImageDatasetIdImageIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetImageApiV1DatasetImageDatasetIdImageIdGet = (
  variables: GetImageApiV1DatasetImageDatasetIdImageIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.Image,
    GetImageApiV1DatasetImageDatasetIdImageIdGetError,
    undefined,
    {},
    {},
    GetImageApiV1DatasetImageDatasetIdImageIdGetPathParams
  >({
    url: "/api/v1/dataset_image/{datasetId}/{imageId}",
    method: "get",
    ...variables,
    signal,
  });

export function getImageApiV1DatasetImageDatasetIdImageIdGetQuery(
  variables: GetImageApiV1DatasetImageDatasetIdImageIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.Image>;
};

export function getImageApiV1DatasetImageDatasetIdImageIdGetQuery(
  variables:
    | GetImageApiV1DatasetImageDatasetIdImageIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.Image>)
    | reactQuery.SkipToken;
};

export function getImageApiV1DatasetImageDatasetIdImageIdGetQuery(
  variables:
    | GetImageApiV1DatasetImageDatasetIdImageIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset_image/{datasetId}/{imageId}",
      operationId: "getImageApiV1DatasetImageDatasetIdImageIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetImageApiV1DatasetImageDatasetIdImageIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetImageApiV1DatasetImageDatasetIdImageIdGet = <
  TData = Schemas.Image,
>(
  variables: GetImageApiV1DatasetImageDatasetIdImageIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Image,
      GetImageApiV1DatasetImageDatasetIdImageIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.Image,
    GetImageApiV1DatasetImageDatasetIdImageIdGetError,
    TData
  >({
    ...getImageApiV1DatasetImageDatasetIdImageIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetImageApiV1DatasetImageDatasetIdImageIdGet = <
  TData = Schemas.Image,
>(
  variables:
    | GetImageApiV1DatasetImageDatasetIdImageIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Image,
      GetImageApiV1DatasetImageDatasetIdImageIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.Image,
    GetImageApiV1DatasetImageDatasetIdImageIdGetError,
    TData
  >({
    ...getImageApiV1DatasetImageDatasetIdImageIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetPathParams = {
  /**
   * @format uuid
   */
  imageId: string;
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables = {
  pathParams: GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetLinksApiV1DatasetImageDatasetIdImageIdLinksGet = (
  variables: GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError,
    undefined,
    {},
    {},
    GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetPathParams
  >({
    url: "/api/v1/dataset_image/{datasetId}/{imageId}/links",
    method: "get",
    ...variables,
    signal,
  });

export function getLinksApiV1DatasetImageDatasetIdImageIdLinksGetQuery(
  variables: GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getLinksApiV1DatasetImageDatasetIdImageIdLinksGetQuery(
  variables:
    | GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getLinksApiV1DatasetImageDatasetIdImageIdLinksGetQuery(
  variables:
    | GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/links",
      operationId: "getLinksApiV1DatasetImageDatasetIdImageIdLinksGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetLinksApiV1DatasetImageDatasetIdImageIdLinksGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetLinksApiV1DatasetImageDatasetIdImageIdLinksGet = <
  TData = void,
>(
  variables: GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError,
    TData
  >({
    ...getLinksApiV1DatasetImageDatasetIdImageIdLinksGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetLinksApiV1DatasetImageDatasetIdImageIdLinksGet = <
  TData = void,
>(
  variables:
    | GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetError,
    TData
  >({
    ...getLinksApiV1DatasetImageDatasetIdImageIdLinksGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetPathParams = {
  /**
   * @format uuid
   */
  imageId: string;
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables = {
  pathParams: GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet = (
  variables: GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError,
    undefined,
    {},
    {},
    GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetPathParams
  >({
    url: "/api/v1/dataset_image/{datasetId}/{imageId}/labels",
    method: "get",
    ...variables,
    signal,
  });

export function getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetQuery(
  variables: GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetQuery(
  variables:
    | GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetQuery(
  variables:
    | GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/labels",
      operationId: "getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet = <
  TData = void,
>(
  variables: GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError,
    TData
  >({
    ...getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet = <
  TData = void,
>(
  variables:
    | GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetError,
    TData
  >({
    ...getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetPathParams = {
  /**
   * @format uuid
   */
  imageId: string;
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables = {
  pathParams: GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet = (
  variables: GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError,
    undefined,
    {},
    {},
    GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetPathParams
  >({
    url: "/api/v1/dataset_image/{datasetId}/{imageId}/issues",
    method: "get",
    ...variables,
    signal,
  });

export function getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetQuery(
  variables: GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetQuery(
  variables:
    | GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetQuery(
  variables:
    | GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/issues",
      operationId: "getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet = <
  TData = void,
>(
  variables: GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError,
    TData
  >({
    ...getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet = <
  TData = void,
>(
  variables:
    | GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetError,
    TData
  >({
    ...getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetPathParams =
  {
    /**
     * @format uuid
     */
    imageId: string;
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables =
  {
    pathParams: GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchGetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet =
  (
    variables: GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError,
      undefined,
      {},
      {},
      GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetPathParams
    >({
      url: "/api/v1/dataset_image/{datasetId}/{imageId}/uniqueness_score",
      method: "get",
      ...variables,
      signal,
    });

export function getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetQuery(
  variables: GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetQuery(
  variables:
    | GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetQuery(
  variables:
    | GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/uniqueness_score",
      operationId:
        "getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet =
  <TData = void>(
    variables: GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError,
      TData
    >({
      ...getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet =
  <TData = void>(
    variables:
      | GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      void,
      GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetError,
      TData
    >({
      ...getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  queryImageId: string;
};

export type GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables = {
  pathParams: GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet = (
  variables: GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.QueryImage,
    GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError,
    undefined,
    {},
    {},
    GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/query_image/{queryImageId}",
    method: "get",
    ...variables,
    signal,
  });

export function getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetQuery(
  variables: GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.QueryImage>;
};

export function getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetQuery(
  variables:
    | GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.QueryImage>)
    | reactQuery.SkipToken;
};

export function getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetQuery(
  variables:
    | GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/query_image/{queryImageId}",
      operationId: "getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet =
  <TData = Schemas.QueryImage>(
    variables: GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.QueryImage,
        GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.QueryImage,
      GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError,
      TData
    >({
      ...getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet = <
  TData = Schemas.QueryImage,
>(
  variables:
    | GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryImage,
      GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.QueryImage,
    GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetError,
    TData
  >({
    ...getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetCredsApiV1ApiCredentialsGetError =
  Fetcher.ErrorWrapper<undefined>;

export type GetCredsApiV1ApiCredentialsGetResponse = {
  [key: string]: any;
};

export type GetCredsApiV1ApiCredentialsGetVariables =
  VlContext["fetcherOptions"];

export const fetchGetCredsApiV1ApiCredentialsGet = (
  variables: GetCredsApiV1ApiCredentialsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetCredsApiV1ApiCredentialsGetResponse,
    GetCredsApiV1ApiCredentialsGetError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/api_credentials", method: "get", ...variables, signal });

export function getCredsApiV1ApiCredentialsGetQuery(
  variables: GetCredsApiV1ApiCredentialsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetCredsApiV1ApiCredentialsGetResponse>;
};

export function getCredsApiV1ApiCredentialsGetQuery(
  variables: GetCredsApiV1ApiCredentialsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetCredsApiV1ApiCredentialsGetResponse>)
    | reactQuery.SkipToken;
};

export function getCredsApiV1ApiCredentialsGetQuery(
  variables: GetCredsApiV1ApiCredentialsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/api_credentials",
      operationId: "getCredsApiV1ApiCredentialsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetCredsApiV1ApiCredentialsGet(variables, signal),
  };
}

export const useSuspenseGetCredsApiV1ApiCredentialsGet = <
  TData = GetCredsApiV1ApiCredentialsGetResponse,
>(
  variables: GetCredsApiV1ApiCredentialsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetCredsApiV1ApiCredentialsGetResponse,
      GetCredsApiV1ApiCredentialsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetCredsApiV1ApiCredentialsGetResponse,
    GetCredsApiV1ApiCredentialsGetError,
    TData
  >({
    ...getCredsApiV1ApiCredentialsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetCredsApiV1ApiCredentialsGet = <
  TData = GetCredsApiV1ApiCredentialsGetResponse,
>(
  variables: GetCredsApiV1ApiCredentialsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetCredsApiV1ApiCredentialsGetResponse,
      GetCredsApiV1ApiCredentialsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetCredsApiV1ApiCredentialsGetResponse,
    GetCredsApiV1ApiCredentialsGetError,
    TData
  >({
    ...getCredsApiV1ApiCredentialsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetCredsApiV1ApiCredentialsPostError =
  Fetcher.ErrorWrapper<undefined>;

export type GetCredsApiV1ApiCredentialsPostResponse = {
  [key: string]: any;
};

export type GetCredsApiV1ApiCredentialsPostVariables =
  VlContext["fetcherOptions"];

export const fetchGetCredsApiV1ApiCredentialsPost = (
  variables: GetCredsApiV1ApiCredentialsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetCredsApiV1ApiCredentialsPostResponse,
    GetCredsApiV1ApiCredentialsPostError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/api_credentials", method: "post", ...variables, signal });

export const useGetCredsApiV1ApiCredentialsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      GetCredsApiV1ApiCredentialsPostResponse,
      GetCredsApiV1ApiCredentialsPostError,
      GetCredsApiV1ApiCredentialsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    GetCredsApiV1ApiCredentialsPostResponse,
    GetCredsApiV1ApiCredentialsPostError,
    GetCredsApiV1ApiCredentialsPostVariables
  >({
    mutationFn: (variables: GetCredsApiV1ApiCredentialsPostVariables) =>
      fetchGetCredsApiV1ApiCredentialsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ExportDatasetApiV1DatasetDatasetIdExportGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExportDatasetApiV1DatasetDatasetIdExportGetQueryParams = {
  export_format?: Schemas.ExportFormat;
  cluster_ids?: string | null;
  media_ids?: string | null;
};

export type ExportDatasetApiV1DatasetDatasetIdExportGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportDatasetApiV1DatasetDatasetIdExportGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExportDatasetApiV1DatasetDatasetIdExportGetVariables = {
  body?: ExportDatasetApiV1DatasetDatasetIdExportGetRequestBody;
  pathParams: ExportDatasetApiV1DatasetDatasetIdExportGetPathParams;
  queryParams?: ExportDatasetApiV1DatasetDatasetIdExportGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchExportDatasetApiV1DatasetDatasetIdExportGet = (
  variables: ExportDatasetApiV1DatasetDatasetIdExportGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExportDatasetApiV1DatasetDatasetIdExportGetError,
    ExportDatasetApiV1DatasetDatasetIdExportGetRequestBody,
    {},
    ExportDatasetApiV1DatasetDatasetIdExportGetQueryParams,
    ExportDatasetApiV1DatasetDatasetIdExportGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/export",
    method: "get",
    ...variables,
    signal,
  });

export function exportDatasetApiV1DatasetDatasetIdExportGetQuery(
  variables: ExportDatasetApiV1DatasetDatasetIdExportGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportDatasetApiV1DatasetDatasetIdExportGetQuery(
  variables:
    | ExportDatasetApiV1DatasetDatasetIdExportGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportDatasetApiV1DatasetDatasetIdExportGetQuery(
  variables:
    | ExportDatasetApiV1DatasetDatasetIdExportGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export",
      operationId: "exportDatasetApiV1DatasetDatasetIdExportGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportDatasetApiV1DatasetDatasetIdExportGet(variables, signal),
  };
}

export const useSuspenseExportDatasetApiV1DatasetDatasetIdExportGet = <
  TData = void,
>(
  variables: ExportDatasetApiV1DatasetDatasetIdExportGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportDatasetApiV1DatasetDatasetIdExportGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExportDatasetApiV1DatasetDatasetIdExportGetError,
    TData
  >({
    ...exportDatasetApiV1DatasetDatasetIdExportGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useExportDatasetApiV1DatasetDatasetIdExportGet = <TData = void>(
  variables:
    | ExportDatasetApiV1DatasetDatasetIdExportGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportDatasetApiV1DatasetDatasetIdExportGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportDatasetApiV1DatasetDatasetIdExportGetError,
    TData
  >({
    ...exportDatasetApiV1DatasetDatasetIdExportGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQueryParams = {
  export_format?: Schemas.ExportFormat;
  /**
   * @default false
   */
  include_images?: boolean;
  file_name?: string | null;
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
  cluster_ids?: string | null;
  media_ids?: string | null;
};

export type ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables = {
  body?: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetRequestBody;
  pathParams: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetPathParams;
  queryParams?: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchExportEntitiesApiV1DatasetDatasetIdExportEntitiesGet = (
  variables: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError,
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetRequestBody,
    {},
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQueryParams,
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/export_entities",
    method: "get",
    ...variables,
    signal,
  });

export function exportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQuery(
  variables: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQuery(
  variables:
    | ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQuery(
  variables:
    | ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_entities",
      operationId: "exportEntitiesApiV1DatasetDatasetIdExportEntitiesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportEntitiesApiV1DatasetDatasetIdExportEntitiesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExportEntitiesApiV1DatasetDatasetIdExportEntitiesGet = <
  TData = void,
>(
  variables: ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError,
    TData
  >({
    ...exportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useExportEntitiesApiV1DatasetDatasetIdExportEntitiesGet = <
  TData = void,
>(
  variables:
    | ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetError,
    TData
  >({
    ...exportEntitiesApiV1DatasetDatasetIdExportEntitiesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExportContextApiV1DatasetDatasetIdExportContextGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExportContextApiV1DatasetDatasetIdExportContextGetQueryParams = {
  export_format?: Schemas.ExportFormat;
  /**
   * @default false
   */
  include_images?: boolean;
  file_name?: string | null;
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type ExportContextApiV1DatasetDatasetIdExportContextGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportContextApiV1DatasetDatasetIdExportContextGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExportContextApiV1DatasetDatasetIdExportContextGetVariables = {
  body?: ExportContextApiV1DatasetDatasetIdExportContextGetRequestBody;
  pathParams: ExportContextApiV1DatasetDatasetIdExportContextGetPathParams;
  queryParams?: ExportContextApiV1DatasetDatasetIdExportContextGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchExportContextApiV1DatasetDatasetIdExportContextGet = (
  variables: ExportContextApiV1DatasetDatasetIdExportContextGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExportContextApiV1DatasetDatasetIdExportContextGetError,
    ExportContextApiV1DatasetDatasetIdExportContextGetRequestBody,
    {},
    ExportContextApiV1DatasetDatasetIdExportContextGetQueryParams,
    ExportContextApiV1DatasetDatasetIdExportContextGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/export_context",
    method: "get",
    ...variables,
    signal,
  });

export function exportContextApiV1DatasetDatasetIdExportContextGetQuery(
  variables: ExportContextApiV1DatasetDatasetIdExportContextGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportContextApiV1DatasetDatasetIdExportContextGetQuery(
  variables:
    | ExportContextApiV1DatasetDatasetIdExportContextGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportContextApiV1DatasetDatasetIdExportContextGetQuery(
  variables:
    | ExportContextApiV1DatasetDatasetIdExportContextGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_context",
      operationId: "exportContextApiV1DatasetDatasetIdExportContextGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportContextApiV1DatasetDatasetIdExportContextGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExportContextApiV1DatasetDatasetIdExportContextGet = <
  TData = void,
>(
  variables: ExportContextApiV1DatasetDatasetIdExportContextGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportContextApiV1DatasetDatasetIdExportContextGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExportContextApiV1DatasetDatasetIdExportContextGetError,
    TData
  >({
    ...exportContextApiV1DatasetDatasetIdExportContextGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useExportContextApiV1DatasetDatasetIdExportContextGet = <
  TData = void,
>(
  variables:
    | ExportContextApiV1DatasetDatasetIdExportContextGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportContextApiV1DatasetDatasetIdExportContextGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportContextApiV1DatasetDatasetIdExportContextGetError,
    TData
  >({
    ...exportContextApiV1DatasetDatasetIdExportContextGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQueryParams =
  {
    export_format?: Schemas.ExportFormat;
    /**
     * @default false
     */
    include_images?: boolean;
    file_name?: string | null;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    cluster_ids?: string | null;
    media_ids?: string | null;
  };

export type ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetRequestBody =
  Schemas.AccessOperation[] | null;

export type ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables =
  {
    body?: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetRequestBody;
    pathParams: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetPathParams;
    queryParams?: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet =
  (
    variables: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError,
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetRequestBody,
      {},
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQueryParams,
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/export_entities_async",
      method: "get",
      ...variables,
      signal,
    });

export function exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQuery(
  variables: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQuery(
  variables:
    | ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQuery(
  variables:
    | ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_entities_async",
      operationId:
        "exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet =
  <TData = void>(
    variables: ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError,
      TData
    >({
      ...exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet =
  <TData = void>(
    variables:
      | ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      void,
      ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetError,
      TData
    >({
      ...exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostQueryParams =
  {
    export_format?: Schemas.ExportFormat;
    /**
     * @default false
     */
    include_images?: boolean;
    file_name?: string | null;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostVariables =
  {
    body: Schemas.DatasetSelectionPayload;
    pathParams: ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostPathParams;
    queryParams?: ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPost =
  (
    variables: ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostError,
      Schemas.DatasetSelectionPayload,
      {},
      ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostQueryParams,
      ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/export_entities_async",
      method: "post",
      ...variables,
      signal,
    });

export const useExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostError,
        ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostError,
      ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostVariables
    >({
      mutationFn: (
        variables: ExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPostVariables,
      ) =>
        fetchExportEntitiesShoppingCartAsyncApiV1DatasetDatasetIdExportEntitiesAsyncPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQueryParams =
  {
    export_format?: Schemas.ExportFormat;
    /**
     * @default false
     */
    include_images?: boolean;
    file_name?: string | null;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetRequestBody =
  Schemas.AccessOperation[] | null;

export type ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables =
  {
    body?: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetRequestBody;
    pathParams: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetPathParams;
    queryParams?: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet =
  (
    variables: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError,
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetRequestBody,
      {},
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQueryParams,
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/export_context_async",
      method: "get",
      ...variables,
      signal,
    });

export function exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQuery(
  variables: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQuery(
  variables:
    | ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQuery(
  variables:
    | ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_context_async",
      operationId:
        "exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet =
  <TData = void>(
    variables: ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError,
      TData
    >({
      ...exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet = <
  TData = void,
>(
  variables:
    | ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetError,
    TData
  >({
    ...exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExportStatusApiV1DatasetDatasetIdExportStatusGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExportStatusApiV1DatasetDatasetIdExportStatusGetQueryParams = {
  /**
   * @format uuid
   */
  export_task_id?: string;
};

export type ExportStatusApiV1DatasetDatasetIdExportStatusGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportStatusApiV1DatasetDatasetIdExportStatusGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables = {
  body?: ExportStatusApiV1DatasetDatasetIdExportStatusGetRequestBody;
  pathParams: ExportStatusApiV1DatasetDatasetIdExportStatusGetPathParams;
  queryParams?: ExportStatusApiV1DatasetDatasetIdExportStatusGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchExportStatusApiV1DatasetDatasetIdExportStatusGet = (
  variables: ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExportStatusApiV1DatasetDatasetIdExportStatusGetError,
    ExportStatusApiV1DatasetDatasetIdExportStatusGetRequestBody,
    {},
    ExportStatusApiV1DatasetDatasetIdExportStatusGetQueryParams,
    ExportStatusApiV1DatasetDatasetIdExportStatusGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/export_status",
    method: "get",
    ...variables,
    signal,
  });

export function exportStatusApiV1DatasetDatasetIdExportStatusGetQuery(
  variables: ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportStatusApiV1DatasetDatasetIdExportStatusGetQuery(
  variables:
    | ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportStatusApiV1DatasetDatasetIdExportStatusGetQuery(
  variables:
    | ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_status",
      operationId: "exportStatusApiV1DatasetDatasetIdExportStatusGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportStatusApiV1DatasetDatasetIdExportStatusGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExportStatusApiV1DatasetDatasetIdExportStatusGet = <
  TData = void,
>(
  variables: ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportStatusApiV1DatasetDatasetIdExportStatusGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExportStatusApiV1DatasetDatasetIdExportStatusGetError,
    TData
  >({
    ...exportStatusApiV1DatasetDatasetIdExportStatusGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useExportStatusApiV1DatasetDatasetIdExportStatusGet = <
  TData = void,
>(
  variables:
    | ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportStatusApiV1DatasetDatasetIdExportStatusGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportStatusApiV1DatasetDatasetIdExportStatusGetError,
    TData
  >({
    ...exportStatusApiV1DatasetDatasetIdExportStatusGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQueryParams = {
  /**
   * @default media_export.csv
   */
  file_name?: string | null;
};

export type ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables = {
  body?: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetRequestBody;
  pathParams: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetPathParams;
  queryParams?: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Export media data as CSV with filename, media_id, and file_fullpath columns.
 */
export const fetchExportMediaIdApiV1DatasetDatasetIdExportMediaIdGet = (
  variables: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError,
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetRequestBody,
    {},
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQueryParams,
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/export_media_id",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Export media data as CSV with filename, media_id, and file_fullpath columns.
 */
export function exportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQuery(
  variables: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQuery(
  variables:
    | ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQuery(
  variables:
    | ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/export_media_id",
      operationId: "exportMediaIdApiV1DatasetDatasetIdExportMediaIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExportMediaIdApiV1DatasetDatasetIdExportMediaIdGet(
              variables,
              signal,
            ),
  };
}

/**
 * Export media data as CSV with filename, media_id, and file_fullpath columns.
 */
export const useSuspenseExportMediaIdApiV1DatasetDatasetIdExportMediaIdGet = <
  TData = void,
>(
  variables: ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError,
    TData
  >({
    ...exportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Export media data as CSV with filename, media_id, and file_fullpath columns.
 */
export const useExportMediaIdApiV1DatasetDatasetIdExportMediaIdGet = <
  TData = void,
>(
  variables:
    | ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetError,
    TData
  >({
    ...exportMediaIdApiV1DatasetDatasetIdExportMediaIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQueryParams =
  {
    /**
     * @default false
     */
    verbose?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse =
  {
    [key: string]: any;
  } | null;

export type GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables =
  {
    pathParams: GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetPathParams;
    queryParams?: GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves metadata about the dataset exploration. This includes information like the count
 * of clusters in the dataset, if a specific threshold is provided. Otherwise, returns the list
 * of available thresholds.
 */
export const fetchGetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet =
  (
    variables: GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError,
      undefined,
      {},
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQueryParams,
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/exploration_metadata",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves metadata about the dataset exploration. This includes information like the count
 * of clusters in the dataset, if a specific threshold is provided. Otherwise, returns the list
 * of available thresholds.
 */
export function getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQuery(
  variables: GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse>;
};

export function getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQuery(
  variables:
    | GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse>)
    | reactQuery.SkipToken;
};

export function getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQuery(
  variables:
    | GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/exploration_metadata",
      operationId:
        "getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves metadata about the dataset exploration. This includes information like the count
 * of clusters in the dataset, if a specific threshold is provided. Otherwise, returns the list
 * of available thresholds.
 */
export const useSuspenseGetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet =
  <
    TData = GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
  >(
    variables: GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
        GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError,
      TData
    >({
      ...getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves metadata about the dataset exploration. This includes information like the count
 * of clusters in the dataset, if a specific threshold is provided. Otherwise, returns the list
 * of available thresholds.
 */
export const useGetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet =
  <
    TData = GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
  >(
    variables:
      | GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
        GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetResponse,
      GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetError,
      TData
    >({
      ...getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQueryParams =
  {
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse =
  {
    [key: string]: any;
  } | null;

export type GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables =
  {
    pathParams: GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetPathParams;
    queryParams?: GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves metadata about the dataset exploration. This includes the list of available similarity thresholds.
 */
export const fetchGetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet =
  (
    variables: GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError,
      undefined,
      {},
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQueryParams,
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/exploration_metadata_get_thresholds",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves metadata about the dataset exploration. This includes the list of available similarity thresholds.
 */
export function getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQuery(
  variables: GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse>;
};

export function getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQuery(
  variables:
    | GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse>)
    | reactQuery.SkipToken;
};

export function getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQuery(
  variables:
    | GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/exploration_metadata_get_thresholds",
      operationId:
        "getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves metadata about the dataset exploration. This includes the list of available similarity thresholds.
 */
export const useSuspenseGetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet =
  <
    TData = GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
  >(
    variables: GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
        GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError,
      TData
    >({
      ...getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves metadata about the dataset exploration. This includes the list of available similarity thresholds.
 */
export const useGetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet =
  <
    TData = GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
  >(
    variables:
      | GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
        GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetResponse,
      GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetError,
      TData
    >({
      ...getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type ExploreApiV1ExploreDatasetIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExploreApiV1ExploreDatasetIdGetQueryParams = {
  /**
   * @default false
   */
  verbose?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
};

export type ExploreApiV1ExploreDatasetIdGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ExploreApiV1ExploreDatasetIdGetResponse = {
  [key: string]: any;
} | null;

export type ExploreApiV1ExploreDatasetIdGetVariables = {
  pathParams: ExploreApiV1ExploreDatasetIdGetPathParams;
  queryParams?: ExploreApiV1ExploreDatasetIdGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieves a paginated list of clusters for a given dataset.
 *
 * Common query parameters:
 * - threshold: '0' (most inclusive), '1', '2', '3', '4' (most restrictive)
 * - entity_type: 'IMAGES', 'OBJECTS', or 'IMAGES,OBJECTS'
 * - labels: '["cat","dog"]' or 'unlabeled'
 * - issues: '[1,2,3]' (issue type IDs)
 * - image_caption: text for semantic search
 * - textual_similarity_threshold: 0.0-1.0 for semantic search strength
 * - anchor_media_id: UUID for similarity-based searches
 * - vql: Visual Query Language for advanced filtering
 *
 * Examples:
 * - Basic: /api/v1/explore/{dataset_id}?threshold=0&entity_type=IMAGES&labels=["cat"]
 * - Semantic: /api/v1/explore/{dataset_id}?image_caption=dog&textual_similarity_threshold=0.8
 * - VQL: /api/v1/explore/{dataset_id}?vql=similarity(uuid) > 0.9
 */
export const fetchExploreApiV1ExploreDatasetIdGet = (
  variables: ExploreApiV1ExploreDatasetIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    ExploreApiV1ExploreDatasetIdGetResponse,
    ExploreApiV1ExploreDatasetIdGetError,
    undefined,
    {},
    ExploreApiV1ExploreDatasetIdGetQueryParams,
    ExploreApiV1ExploreDatasetIdGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves a paginated list of clusters for a given dataset.
 *
 * Common query parameters:
 * - threshold: '0' (most inclusive), '1', '2', '3', '4' (most restrictive)
 * - entity_type: 'IMAGES', 'OBJECTS', or 'IMAGES,OBJECTS'
 * - labels: '["cat","dog"]' or 'unlabeled'
 * - issues: '[1,2,3]' (issue type IDs)
 * - image_caption: text for semantic search
 * - textual_similarity_threshold: 0.0-1.0 for semantic search strength
 * - anchor_media_id: UUID for similarity-based searches
 * - vql: Visual Query Language for advanced filtering
 *
 * Examples:
 * - Basic: /api/v1/explore/{dataset_id}?threshold=0&entity_type=IMAGES&labels=["cat"]
 * - Semantic: /api/v1/explore/{dataset_id}?image_caption=dog&textual_similarity_threshold=0.8
 * - VQL: /api/v1/explore/{dataset_id}?vql=similarity(uuid) > 0.9
 */
export function exploreApiV1ExploreDatasetIdGetQuery(
  variables: ExploreApiV1ExploreDatasetIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<ExploreApiV1ExploreDatasetIdGetResponse>;
};

export function exploreApiV1ExploreDatasetIdGetQuery(
  variables: ExploreApiV1ExploreDatasetIdGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<ExploreApiV1ExploreDatasetIdGetResponse>)
    | reactQuery.SkipToken;
};

export function exploreApiV1ExploreDatasetIdGetQuery(
  variables: ExploreApiV1ExploreDatasetIdGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}",
      operationId: "exploreApiV1ExploreDatasetIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExploreApiV1ExploreDatasetIdGet(variables, signal),
  };
}

/**
 * Retrieves a paginated list of clusters for a given dataset.
 *
 * Common query parameters:
 * - threshold: '0' (most inclusive), '1', '2', '3', '4' (most restrictive)
 * - entity_type: 'IMAGES', 'OBJECTS', or 'IMAGES,OBJECTS'
 * - labels: '["cat","dog"]' or 'unlabeled'
 * - issues: '[1,2,3]' (issue type IDs)
 * - image_caption: text for semantic search
 * - textual_similarity_threshold: 0.0-1.0 for semantic search strength
 * - anchor_media_id: UUID for similarity-based searches
 * - vql: Visual Query Language for advanced filtering
 *
 * Examples:
 * - Basic: /api/v1/explore/{dataset_id}?threshold=0&entity_type=IMAGES&labels=["cat"]
 * - Semantic: /api/v1/explore/{dataset_id}?image_caption=dog&textual_similarity_threshold=0.8
 * - VQL: /api/v1/explore/{dataset_id}?vql=similarity(uuid) > 0.9
 */
export const useSuspenseExploreApiV1ExploreDatasetIdGet = <
  TData = ExploreApiV1ExploreDatasetIdGetResponse,
>(
  variables: ExploreApiV1ExploreDatasetIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ExploreApiV1ExploreDatasetIdGetResponse,
      ExploreApiV1ExploreDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    ExploreApiV1ExploreDatasetIdGetResponse,
    ExploreApiV1ExploreDatasetIdGetError,
    TData
  >({
    ...exploreApiV1ExploreDatasetIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieves a paginated list of clusters for a given dataset.
 *
 * Common query parameters:
 * - threshold: '0' (most inclusive), '1', '2', '3', '4' (most restrictive)
 * - entity_type: 'IMAGES', 'OBJECTS', or 'IMAGES,OBJECTS'
 * - labels: '["cat","dog"]' or 'unlabeled'
 * - issues: '[1,2,3]' (issue type IDs)
 * - image_caption: text for semantic search
 * - textual_similarity_threshold: 0.0-1.0 for semantic search strength
 * - anchor_media_id: UUID for similarity-based searches
 * - vql: Visual Query Language for advanced filtering
 *
 * Examples:
 * - Basic: /api/v1/explore/{dataset_id}?threshold=0&entity_type=IMAGES&labels=["cat"]
 * - Semantic: /api/v1/explore/{dataset_id}?image_caption=dog&textual_similarity_threshold=0.8
 * - VQL: /api/v1/explore/{dataset_id}?vql=similarity(uuid) > 0.9
 */
export const useExploreApiV1ExploreDatasetIdGet = <
  TData = ExploreApiV1ExploreDatasetIdGetResponse,
>(
  variables: ExploreApiV1ExploreDatasetIdGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ExploreApiV1ExploreDatasetIdGetResponse,
      ExploreApiV1ExploreDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    ExploreApiV1ExploreDatasetIdGetResponse,
    ExploreApiV1ExploreDatasetIdGetError,
    TData
  >({
    ...exploreApiV1ExploreDatasetIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQueryParams = {
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse = {
  [key: string]: any;
} | null;

export type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables = {
  pathParams: GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetPathParams;
  queryParams?: GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieves labels of dataset with their sources. Optionally filter by entity type (IMAGES, OBJECTS).
 */
export const fetchGetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet = (
  variables: GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError,
    undefined,
    {},
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQueryParams,
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/labels",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves labels of dataset with their sources. Optionally filter by entity type (IMAGES, OBJECTS).
 */
export function getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQuery(
  variables: GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse>;
};

export function getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQuery(
  variables:
    | GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQuery(
  variables:
    | GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/labels",
      operationId: "getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves labels of dataset with their sources. Optionally filter by entity type (IMAGES, OBJECTS).
 */
export const useSuspenseGetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet = <
  TData = GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
>(
  variables: GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
      GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError,
    TData
  >({
    ...getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieves labels of dataset with their sources. Optionally filter by entity type (IMAGES, OBJECTS).
 */
export const useGetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet = <
  TData = GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
>(
  variables:
    | GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
      GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetResponse,
    GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetError,
    TData
  >({
    ...getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetPathParams =
  {
    /**
     * Unique identifier of the dataset
     *
     * @format uuid
     */
    datasetId: string;
    /**
     * Unique identifier of the cluster
     *
     * @format uuid
     */
    clusterId: string;
  };

export type GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse =
  {
    [key: string]: any;
  };

export type GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables =
  {
    pathParams: GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves labels of specific cluster with their sources.
 */
export const fetchGetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet =
  (
    variables: GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError,
      undefined,
      {},
      {},
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/cluster/{clusterId}/labels",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves labels of specific cluster with their sources.
 */
export function getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetQuery(
  variables: GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse>;
};

export function getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetQuery(
  variables:
    | GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse>)
    | reactQuery.SkipToken;
};

export function getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetQuery(
  variables:
    | GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/cluster/{clusterId}/labels",
      operationId:
        "getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves labels of specific cluster with their sources.
 */
export const useSuspenseGetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet =
  <
    TData = GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
  >(
    variables: GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
        GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError,
      TData
    >({
      ...getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves labels of specific cluster with their sources.
 */
export const useGetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet =
  <
    TData = GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
  >(
    variables:
      | GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
        GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetResponse,
      GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetError,
      TData
    >({
      ...getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetPathParams = {
  /**
   * Unique identifier of the dataset
   *
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse = {
  [key: string]: any;
};

export type GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables = {
  pathParams: GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieves list of origins for a given dataset.
 */
export const fetchGetDatasetOriginsApiV1ExploreDatasetIdOriginsGet = (
  variables: GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError,
    undefined,
    {},
    {},
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/origins",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves list of origins for a given dataset.
 */
export function getDatasetOriginsApiV1ExploreDatasetIdOriginsGetQuery(
  variables: GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse>;
};

export function getDatasetOriginsApiV1ExploreDatasetIdOriginsGetQuery(
  variables:
    | GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetOriginsApiV1ExploreDatasetIdOriginsGetQuery(
  variables:
    | GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/origins",
      operationId: "getDatasetOriginsApiV1ExploreDatasetIdOriginsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetOriginsApiV1ExploreDatasetIdOriginsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves list of origins for a given dataset.
 */
export const useSuspenseGetDatasetOriginsApiV1ExploreDatasetIdOriginsGet = <
  TData = GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
>(
  variables: GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
      GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError,
    TData
  >({
    ...getDatasetOriginsApiV1ExploreDatasetIdOriginsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieves list of origins for a given dataset.
 */
export const useGetDatasetOriginsApiV1ExploreDatasetIdOriginsGet = <
  TData = GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
>(
  variables:
    | GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
      GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetResponse,
    GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetError,
    TData
  >({
    ...getDatasetOriginsApiV1ExploreDatasetIdOriginsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    clusterId: string | null;
  };

export type GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQueryParams =
  {
    /**
     * @default false
     */
    verbose?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse =
  Schemas.SimilarityClusterView | null;

export type GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables =
  {
    pathParams: GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetPathParams;
    queryParams?: GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a specific similarity cluster by its ID.
 */
export const fetchGetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet =
  (
    variables: GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError,
      undefined,
      {},
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQueryParams,
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a specific similarity cluster by its ID.
 */
export function getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQuery(
  variables: GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse>;
};

export function getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQuery(
  variables:
    | GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse>)
    | reactQuery.SkipToken;
};

export function getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQuery(
  variables:
    | GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}",
      operationId:
        "getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a specific similarity cluster by its ID.
 */
export const useSuspenseGetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet =
  <
    TData = GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
  >(
    variables: GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
        GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError,
      TData
    >({
      ...getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a specific similarity cluster by its ID.
 */
export const useGetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet =
  <
    TData = GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
  >(
    variables:
      | GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
        GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetResponse,
      GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetError,
      TData
    >({
      ...getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    clusterId: string | null;
  };

export type GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQueryParams =
  {
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse =
  Schemas.SimilarityClusterView | null;

export type GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables =
  {
    pathParams: GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetPathParams;
    queryParams?: GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a specific similarity cluster by its ID, focusing on tags data.
 */
export const fetchGetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet =
  (
    variables: GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError,
      undefined,
      {},
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQueryParams,
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/tags",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a specific similarity cluster by its ID, focusing on tags data.
 */
export function getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQuery(
  variables: GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse>;
};

export function getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQuery(
  variables:
    | GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse>)
    | reactQuery.SkipToken;
};

export function getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQuery(
  variables:
    | GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/tags",
      operationId:
        "getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a specific similarity cluster by its ID, focusing on tags data.
 */
export const useSuspenseGetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet =
  <
    TData = GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
  >(
    variables: GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
        GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError,
      TData
    >({
      ...getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a specific similarity cluster by its ID, focusing on tags data.
 */
export const useGetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet =
  <
    TData = GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
  >(
    variables:
      | GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
        GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetResponse,
      GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetError,
      TData
    >({
      ...getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    clusterId: string | null;
  };

export type GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQueryParams =
  {
    /**
     * @default false
     */
    verbose?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse =
  {
    [key: string]: any;
  } | null;

export type GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables =
  {
    pathParams: GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetPathParams;
    queryParams?: GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves metadata for a specific similarity cluster, including its size.
 */
export const fetchGetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet =
  (
    variables: GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError,
      undefined,
      {},
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQueryParams,
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/cluster_metadata",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves metadata for a specific similarity cluster, including its size.
 */
export function getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQuery(
  variables: GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse>;
};

export function getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQuery(
  variables:
    | GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse>)
    | reactQuery.SkipToken;
};

export function getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQuery(
  variables:
    | GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/cluster_metadata",
      operationId:
        "getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves metadata for a specific similarity cluster, including its size.
 */
export const useSuspenseGetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet =
  <
    TData = GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
  >(
    variables: GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
        GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError,
      TData
    >({
      ...getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves metadata for a specific similarity cluster, including its size.
 */
export const useGetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet =
  <
    TData = GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
  >(
    variables:
      | GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
        GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetResponse,
      GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetError,
      TData
    >({
      ...getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetFileTreeApiV1ExploreDatasetIdFileTreeGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetFileTreeApiV1ExploreDatasetIdFileTreeGetQueryParams = {
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type GetFileTreeApiV1ExploreDatasetIdFileTreeGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse = {
  [key: string]: any;
} | null;

export type GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables = {
  pathParams: GetFileTreeApiV1ExploreDatasetIdFileTreeGetPathParams;
  queryParams?: GetFileTreeApiV1ExploreDatasetIdFileTreeGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieves the file system structure within a dataset.
 */
export const fetchGetFileTreeApiV1ExploreDatasetIdFileTreeGet = (
  variables: GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetError,
    undefined,
    {},
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetQueryParams,
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/file_tree",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves the file system structure within a dataset.
 */
export function getFileTreeApiV1ExploreDatasetIdFileTreeGetQuery(
  variables: GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse>;
};

export function getFileTreeApiV1ExploreDatasetIdFileTreeGetQuery(
  variables:
    | GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse>)
    | reactQuery.SkipToken;
};

export function getFileTreeApiV1ExploreDatasetIdFileTreeGetQuery(
  variables:
    | GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/file_tree",
      operationId: "getFileTreeApiV1ExploreDatasetIdFileTreeGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetFileTreeApiV1ExploreDatasetIdFileTreeGet(variables, signal),
  };
}

/**
 * Retrieves the file system structure within a dataset.
 */
export const useSuspenseGetFileTreeApiV1ExploreDatasetIdFileTreeGet = <
  TData = GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
>(
  variables: GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
      GetFileTreeApiV1ExploreDatasetIdFileTreeGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetError,
    TData
  >({
    ...getFileTreeApiV1ExploreDatasetIdFileTreeGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieves the file system structure within a dataset.
 */
export const useGetFileTreeApiV1ExploreDatasetIdFileTreeGet = <
  TData = GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
>(
  variables:
    | GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
      GetFileTreeApiV1ExploreDatasetIdFileTreeGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetResponse,
    GetFileTreeApiV1ExploreDatasetIdFileTreeGetError,
    TData
  >({
    ...getFileTreeApiV1ExploreDatasetIdFileTreeGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetPathParams =
  {
    /**
     * Unique identifier of the dataset
     *
     * @format uuid
     */
    datasetId: string;
  };

export type GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQueryParams =
  {
    entity_type: Schemas.SimilarityClusterType;
  };

export type GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse =
  Schemas.MetadataSource[];

export type GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables =
  {
    pathParams: GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetPathParams;
    queryParams: GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves metadata sources for the given dataset.
 */
export const fetchGetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet = (
  variables: GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError,
    undefined,
    {},
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQueryParams,
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/metadata_sources",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves metadata sources for the given dataset.
 */
export function getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQuery(
  variables: GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse>;
};

export function getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQuery(
  variables:
    | GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse>)
    | reactQuery.SkipToken;
};

export function getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQuery(
  variables:
    | GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/metadata_sources",
      operationId: "getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves metadata sources for the given dataset.
 */
export const useSuspenseGetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet =
  <TData = GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse>(
    variables: GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
        GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
      GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError,
      TData
    >({
      ...getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves metadata sources for the given dataset.
 */
export const useGetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet = <
  TData = GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
>(
  variables:
    | GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
      GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetResponse,
    GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetError,
    TData
  >({
    ...getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    clusterId: string | null;
  };

export type GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQueryParams =
  {
    /**
     * @default false
     */
    verbose?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse =
  Schemas.MetadataSummary | null;

export type GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables =
  {
    pathParams: GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetPathParams;
    queryParams?: GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a structured summary of metadata for a given cluster, such as labels, user_tags, videos, and issues..
 */
export const fetchGetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet =
  (
    variables: GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError,
      undefined,
      {},
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQueryParams,
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a structured summary of metadata for a given cluster, such as labels, user_tags, videos, and issues..
 */
export function getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQuery(
  variables: GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse>;
};

export function getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQuery(
  variables:
    | GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse>)
    | reactQuery.SkipToken;
};

export function getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQuery(
  variables:
    | GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary",
      operationId:
        "getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a structured summary of metadata for a given cluster, such as labels, user_tags, videos, and issues..
 */
export const useSuspenseGetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet =
  <
    TData = GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
  >(
    variables: GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
        GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError,
      TData
    >({
      ...getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a structured summary of metadata for a given cluster, such as labels, user_tags, videos, and issues..
 */
export const useGetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet =
  <
    TData = GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
  >(
    variables:
      | GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
        GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetResponse,
      GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetError,
      TData
    >({
      ...getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQueryParams =
  {
    /**
     * @default false
     */
    verbose?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse =
  Schemas.MetadataSummary | null;

export type GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables =
  {
    pathParams: GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetPathParams;
    queryParams?: GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a structured summary of metadata for the entire dataset, e.g. labels, user_tags, issues, etc.
 */
export const fetchGetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet =
  (
    variables: GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError,
      undefined,
      {},
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQueryParams,
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/metadata_summary",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a structured summary of metadata for the entire dataset, e.g. labels, user_tags, issues, etc.
 */
export function getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQuery(
  variables: GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse>;
};

export function getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQuery(
  variables:
    | GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQuery(
  variables:
    | GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/metadata_summary",
      operationId:
        "getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a structured summary of metadata for the entire dataset, e.g. labels, user_tags, issues, etc.
 */
export const useSuspenseGetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet =
  <
    TData = GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
  >(
    variables: GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
        GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError,
      TData
    >({
      ...getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a structured summary of metadata for the entire dataset, e.g. labels, user_tags, issues, etc.
 */
export const useGetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet =
  <
    TData = GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
  >(
    variables:
      | GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
        GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetResponse,
      GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetError,
      TData
    >({
      ...getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetPathParams =
  {
    section: Schemas.DisplaySection;
    /**
     * @format uuid
     */
    datasetId: string;
    clusterId: string | null;
  };

export type GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQueryParams =
  {
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse =
  {
    [key: string]: any;
  } | null;

export type GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables =
  {
    pathParams: GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetPathParams;
    queryParams?: GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a section of metadata for a given cluster (labels, issues, user_tags, or metadata).
 */
export const fetchGetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet =
  (
    variables: GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError,
      undefined,
      {},
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQueryParams,
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary/{section}",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a section of metadata for a given cluster (labels, issues, user_tags, or metadata).
 */
export function getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQuery(
  variables: GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse>;
};

export function getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQuery(
  variables:
    | GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse>)
    | reactQuery.SkipToken;
};

export function getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQuery(
  variables:
    | GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary/{section}",
      operationId:
        "getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a section of metadata for a given cluster (labels, issues, user_tags, or metadata).
 */
export const useSuspenseGetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet =
  <
    TData = GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
  >(
    variables: GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
        GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError,
      TData
    >({
      ...getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a section of metadata for a given cluster (labels, issues, user_tags, or metadata).
 */
export const useGetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet =
  <
    TData = GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
  >(
    variables:
      | GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
        GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetResponse,
      GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetError,
      TData
    >({
      ...getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetPathParams =
  {
    section: Schemas.DisplaySection;
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQueryParams =
  {
    /**
     * @default false
     */
    allow_deleted?: boolean;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
  };

export type GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse =
  {
    [key: string]: any;
  } | null;

export type GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables =
  {
    pathParams: GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetPathParams;
    queryParams?: GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves a section of metadata for the entire dataset (labels, issues, user_tags, or metadata).
 */
export const fetchGetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet =
  (
    variables: GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError,
      undefined,
      {},
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQueryParams,
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetPathParams
    >({
      url: "/api/v1/explore/{datasetId}/metadata_summary/{section}",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Retrieves a section of metadata for the entire dataset (labels, issues, user_tags, or metadata).
 */
export function getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQuery(
  variables: GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse>;
};

export function getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQuery(
  variables:
    | GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQuery(
  variables:
    | GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/metadata_summary/{section}",
      operationId:
        "getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a section of metadata for the entire dataset (labels, issues, user_tags, or metadata).
 */
export const useSuspenseGetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet =
  <
    TData = GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
  >(
    variables: GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
        GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError,
      TData
    >({
      ...getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves a section of metadata for the entire dataset (labels, issues, user_tags, or metadata).
 */
export const useGetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet =
  <
    TData = GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
  >(
    variables:
      | GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
        GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetResponse,
      GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetError,
      TData
    >({
      ...getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * Unique identifier of the media
   *
   * @format uuid
   */
  mediaId: string;
};

export type GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQueryParams = {
  /**
   * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
   */
  threshold?: string | null;
  render?: Schemas.VertexRenderMode;
  /**
   * @default false
   */
  verbose?: boolean | null;
  /**
   * @default false
   */
  allow_deleted?: boolean;
  /**
   * UUID of media item used for anchor similarity searches
   */
  anchor_media_id?: string | null;
  /**
   * AnchorType: 'MEDIA' or 'UPLOAD'
   */
  anchor_type?: ("MEDIA" | "UPLOAD") | null;
  /**
   * Additional context for anchor-based similarity searches
   */
  anchor_context?: string | null;
  /**
   * Filter results by caption text (semantic search)
   */
  caption?: string | null;
  /**
   * Filter results by caption text but ignoring label constraints
   */
  caption_only_filter?: string | null;
  /**
   * Filter results by file path. Accepts % as wildcard.
   */
  path_filter?: string | null;
  /**
   * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
   */
  entity_type?: string | null;
  /**
   * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
   */
  tags?: string | null;
  /**
   * Page number for pagination
   */
  page_number?: number | null;
  /**
   * Minimum uniqueness_score filter
   */
  uniqueness_score?: number | null;
  /**
   * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
   */
  semantic_relevance_threshold?: number | null;
  /**
   * Minimum threshold for semantic text similarity search (0.0-1.0)
   */
  textual_similarity_threshold?: number | null;
  /**
   * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
   *
   * @deprecated true
   */
  labels?: string | null;
  /**
   * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
   */
  metadata_sources?: string | null;
  /**
   * Filter results by duplication threshold
   *
   * @deprecated true
   */
  duplicate_threshold?: number | null;
  /**
   * List of issue type IDs as JSON array, e.g. '[1,2,3]'
   *
   * @deprecated true
   */
  issues?: string | null;
  /**
   * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
   *
   *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
   *
   *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
   *
   *             **Filter Type Reference:**
   *
   *             • **entity_type**: Filter by media type
   *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
   *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
   *
   *             • **labels**: Filter by classification labels (from ML models)
   *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
   *               - Special: Use "unlabeled" in value array to match items without labels
   *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
   *
   *             • **tags**: Filter by user-defined UUID tags
   *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
   *               - Special: Use "untagged" in value array to match items without user tags
   *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
   *
   *             • **issues**: Filter by quality issues detected by analysis pipeline
   *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
   *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
   *               - mode: "in" to include issues, "out" to exclude them
   *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
   *
   *             • **text**: Full-text or semantic search on captions/descriptions
   *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
   *               - fts: Full-text search with stemming and ranking
   *               - semantic: Vector similarity search using embedding models
   *               - threshold: Optional similarity threshold for semantic search
   *               - include_labels: Extend search to include label text
   *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
   *
   *             • **similarity**: Find visually similar media using reference image
   *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
   *               - media: Reference existing media by UUID
   *               - upload: Reference uploaded image for similarity search
   *               - threshold: Optional cosine distance threshold (lower = more similar)
   *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
   *
   *             • **file/folder**: Path-based filtering on original file locations
   *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
   *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
   *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
   *
   *             • **size**: Dimensional filtering for objects/images (pixel area)
   *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
   *               - value: Pixel area (width × height)
   *               - Example: `{"size": {"op": "gt", "value": 2000}}`
   *
   *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
   *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *               - value: Similarity threshold [0.8-1.0]
   *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
   *
   *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
   *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *               - value: Minimum uniqueness score [0.0-1.0]
   *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
   *
   *             • **custom_metadata**: Filter by user-defined metadata fields
   *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
   *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
   *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
   *
   *             • **created_at**: Filter by media creation timestamp
   *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
   *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
   *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
   *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
   *
   *             **Format Options:**
   *             - JSON Array (recommended): Standard JSON array of filter objects
   *             - RISON String: URL-safe encoded format for query parameters
   *
   *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
   *
   *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
   */
  vql?: string | null;
  cluster_id?: string | null;
  /**
   * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
   */
  flat_response?: boolean | null;
};

export type GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables = {
  body?: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetRequestBody;
  pathParams: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetPathParams;
  queryParams?: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieves a single media item, either image or object, or its cluster if render=CLUSTER.
 */
export const fetchGetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet = (
  variables: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.SimilarityClusterView,
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError,
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetRequestBody,
    {},
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQueryParams,
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/media/{mediaId}/vertex",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves a single media item, either image or object, or its cluster if render=CLUSTER.
 */
export function getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQuery(
  variables: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SimilarityClusterView>;
};

export function getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQuery(
  variables:
    | GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SimilarityClusterView>)
    | reactQuery.SkipToken;
};

export function getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQuery(
  variables:
    | GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/media/{mediaId}/vertex",
      operationId: "getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves a single media item, either image or object, or its cluster if render=CLUSTER.
 */
export const useSuspenseGetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet = <
  TData = Schemas.SimilarityClusterView,
>(
  variables: GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SimilarityClusterView,
      GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SimilarityClusterView,
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError,
    TData
  >({
    ...getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieves a single media item, either image or object, or its cluster if render=CLUSTER.
 */
export const useGetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet = <
  TData = Schemas.SimilarityClusterView,
>(
  variables:
    | GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SimilarityClusterView,
      GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.SimilarityClusterView,
    GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetError,
    TData
  >({
    ...getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetTagsApiV1TagsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetTagsApiV1TagsGetRequestBody = {
  [key: string]: any;
};

export type GetTagsApiV1TagsGetVariables = {
  body?: GetTagsApiV1TagsGetRequestBody;
} & VlContext["fetcherOptions"];

export const fetchGetTagsApiV1TagsGet = (
  variables: GetTagsApiV1TagsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetTagsApiV1TagsGetError,
    GetTagsApiV1TagsGetRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v1/tags", method: "get", ...variables, signal });

export function getTagsApiV1TagsGetQuery(
  variables: GetTagsApiV1TagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getTagsApiV1TagsGetQuery(
  variables: GetTagsApiV1TagsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getTagsApiV1TagsGetQuery(
  variables: GetTagsApiV1TagsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/tags",
      operationId: "getTagsApiV1TagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetTagsApiV1TagsGet(variables, signal),
  };
}

export const useSuspenseGetTagsApiV1TagsGet = <TData = void>(
  variables: GetTagsApiV1TagsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetTagsApiV1TagsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<void, GetTagsApiV1TagsGetError, TData>({
    ...getTagsApiV1TagsGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetTagsApiV1TagsGet = <TData = void>(
  variables: GetTagsApiV1TagsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetTagsApiV1TagsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetTagsApiV1TagsGetError, TData>({
    ...getTagsApiV1TagsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AddTagApiV1TagsPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AddTagApiV1TagsPostRequestBody = {
  [key: string]: any;
};

export type AddTagApiV1TagsPostVariables = {
  body?: AddTagApiV1TagsPostRequestBody;
} & VlContext["fetcherOptions"];

export const fetchAddTagApiV1TagsPost = (
  variables: AddTagApiV1TagsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    AddTagApiV1TagsPostError,
    AddTagApiV1TagsPostRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v1/tags", method: "post", ...variables, signal });

export const useAddTagApiV1TagsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AddTagApiV1TagsPostError,
      AddTagApiV1TagsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AddTagApiV1TagsPostError,
    AddTagApiV1TagsPostVariables
  >({
    mutationFn: (variables: AddTagApiV1TagsPostVariables) =>
      fetchAddTagApiV1TagsPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetPathParams = {
  /**
   * @format uuid
   */
  mediaId: string;
};

export type GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables = {
  pathParams: GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetMediaTagsByMediaIdApiV1MediaMediaIdTagsGet = (
  variables: GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError,
    undefined,
    {},
    {},
    GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetPathParams
  >({
    url: "/api/v1/media/{mediaId}/tags",
    method: "get",
    ...variables,
    signal,
  });

export function getMediaTagsByMediaIdApiV1MediaMediaIdTagsGetQuery(
  variables: GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getMediaTagsByMediaIdApiV1MediaMediaIdTagsGetQuery(
  variables:
    | GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getMediaTagsByMediaIdApiV1MediaMediaIdTagsGetQuery(
  variables:
    | GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/media/{mediaId}/tags",
      operationId: "getMediaTagsByMediaIdApiV1MediaMediaIdTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetMediaTagsByMediaIdApiV1MediaMediaIdTagsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetMediaTagsByMediaIdApiV1MediaMediaIdTagsGet = <
  TData = void,
>(
  variables: GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError,
    TData
  >({
    ...getMediaTagsByMediaIdApiV1MediaMediaIdTagsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetMediaTagsByMediaIdApiV1MediaMediaIdTagsGet = <TData = void>(
  variables:
    | GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetError,
    TData
  >({
    ...getMediaTagsByMediaIdApiV1MediaMediaIdTagsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQueryParams = {
  media_original_uris_filter: string;
};

export type ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables = {
  body?: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetRequestBody;
  pathParams: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetPathParams;
  queryParams: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet = (
  variables: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError,
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetRequestBody,
    {},
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQueryParams,
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/media/tags",
    method: "get",
    ...variables,
    signal,
  });

export function exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQuery(
  variables: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQuery(
  variables:
    | ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQuery(
  variables:
    | ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/media/tags",
      operationId: "exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet = <
  TData = void,
>(
  variables: ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError,
    TData
  >({
    ...exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet = <
  TData = void,
>(
  variables:
    | ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetError,
    TData
  >({
    ...exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostVariables = {
  body: Schemas.BodyAddMediaTagsApiV1DatasetDatasetIdMediaTagsPost;
  pathParams: AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchAddMediaTagsApiV1DatasetDatasetIdMediaTagsPost = (
  variables: AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostError,
    Schemas.BodyAddMediaTagsApiV1DatasetDatasetIdMediaTagsPost,
    {},
    {},
    AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/media/tags",
    method: "post",
    ...variables,
    signal,
  });

export const useAddMediaTagsApiV1DatasetDatasetIdMediaTagsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostError,
      AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostError,
    AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostVariables
  >({
    mutationFn: (
      variables: AddMediaTagsApiV1DatasetDatasetIdMediaTagsPostVariables,
    ) =>
      fetchAddMediaTagsApiV1DatasetDatasetIdMediaTagsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    mediaId: string;
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    tagId: string;
  };

export type DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteVariables =
  {
    body?: DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteRequestBody;
    pathParams: DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchDeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDelete =
  (
    variables: DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteError,
      DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteRequestBody,
      {},
      {},
      DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeletePathParams
    >({
      url: "/api/v1/dataset/{datasetId}/media/{mediaId}/tag/{tagId}",
      method: "delete",
      ...variables,
      signal,
    });

export const useDeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteError,
        DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteError,
      DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteVariables
    >({
      mutationFn: (
        variables: DeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDeleteVariables,
      ) =>
        fetchDeleteMediaTagApiV1DatasetDatasetIdMediaMediaIdTagTagIdDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostPathParams = {
  /**
   * @format uuid
   */
  mediaId: string;
  /**
   * @format uuid
   */
  datasetId: string;
};

export type AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostVariables = {
  body: Schemas.BodyAddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPost;
  pathParams: AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchAddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPost = (
  variables: AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostError,
    Schemas.BodyAddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPost,
    {},
    {},
    AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/media/{mediaId}/tag",
    method: "post",
    ...variables,
    signal,
  });

export const useAddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostError,
      AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostError,
    AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostVariables
  >({
    mutationFn: (
      variables: AddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPostVariables,
    ) =>
      fetchAddMediaTagApiV1DatasetDatasetIdMediaMediaIdTagPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchVariables =
  {
    body: Schemas.BodyRemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatch;
    pathParams: RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchPathParams;
  } & VlContext["fetcherOptions"];

export const fetchRemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatch =
  (
    variables: RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchError,
      Schemas.BodyRemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatch,
      {},
      {},
      RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/tags/remove",
      method: "patch",
      ...variables,
      signal,
    });

export const useRemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatch =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchError,
        RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchError,
      RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchVariables
    >({
      mutationFn: (
        variables: RemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatchVariables,
      ) =>
        fetchRemoveTagFromMediaOrClusterApiV1DatasetDatasetIdTagsRemovePatch(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostVariables = {
  body: Schemas.BodyGetTagsUnionApiV1DatasetDatasetIdTagsUnionPost;
  pathParams: GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetTagsUnionApiV1DatasetDatasetIdTagsUnionPost = (
  variables: GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostError,
    Schemas.BodyGetTagsUnionApiV1DatasetDatasetIdTagsUnionPost,
    {},
    {},
    GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/tags/union",
    method: "post",
    ...variables,
    signal,
  });

export const useGetTagsUnionApiV1DatasetDatasetIdTagsUnionPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostError,
      GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostError,
    GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostVariables
  >({
    mutationFn: (
      variables: GetTagsUnionApiV1DatasetDatasetIdTagsUnionPostVariables,
    ) =>
      fetchGetTagsUnionApiV1DatasetDatasetIdTagsUnionPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetMediaTagsApiV1MediaTagsGetQueryParams = {
  cursor?: string | null;
  /**
   * @format uuid
   */
  dataset_id: string;
};

export type GetMediaTagsApiV1MediaTagsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetMediaTagsApiV1MediaTagsGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetMediaTagsApiV1MediaTagsGetVariables = {
  body?: GetMediaTagsApiV1MediaTagsGetRequestBody;
  queryParams: GetMediaTagsApiV1MediaTagsGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetMediaTagsApiV1MediaTagsGet = (
  variables: GetMediaTagsApiV1MediaTagsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetMediaTagsApiV1MediaTagsGetError,
    GetMediaTagsApiV1MediaTagsGetRequestBody,
    {},
    GetMediaTagsApiV1MediaTagsGetQueryParams,
    {}
  >({ url: "/api/v1/media/tags", method: "get", ...variables, signal });

export function getMediaTagsApiV1MediaTagsGetQuery(
  variables: GetMediaTagsApiV1MediaTagsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getMediaTagsApiV1MediaTagsGetQuery(
  variables: GetMediaTagsApiV1MediaTagsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getMediaTagsApiV1MediaTagsGetQuery(
  variables: GetMediaTagsApiV1MediaTagsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/media/tags",
      operationId: "getMediaTagsApiV1MediaTagsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetMediaTagsApiV1MediaTagsGet(variables, signal),
  };
}

export const useSuspenseGetMediaTagsApiV1MediaTagsGet = <TData = void>(
  variables: GetMediaTagsApiV1MediaTagsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetMediaTagsApiV1MediaTagsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetMediaTagsApiV1MediaTagsGetError,
    TData
  >({
    ...getMediaTagsApiV1MediaTagsGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetMediaTagsApiV1MediaTagsGet = <TData = void>(
  variables: GetMediaTagsApiV1MediaTagsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetMediaTagsApiV1MediaTagsGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetMediaTagsApiV1MediaTagsGetError, TData>({
    ...getMediaTagsApiV1MediaTagsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetTagsApiV1MediaMetadataGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetTagsApiV1MediaMetadataGetRequestBody = {
  [key: string]: any;
};

export type GetTagsApiV1MediaMetadataGetVariables = {
  body?: GetTagsApiV1MediaMetadataGetRequestBody;
} & VlContext["fetcherOptions"];

export const fetchGetTagsApiV1MediaMetadataGet = (
  variables: GetTagsApiV1MediaMetadataGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    GetTagsApiV1MediaMetadataGetError,
    GetTagsApiV1MediaMetadataGetRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v1/media/metadata", method: "get", ...variables, signal });

export function getTagsApiV1MediaMetadataGetQuery(
  variables: GetTagsApiV1MediaMetadataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getTagsApiV1MediaMetadataGetQuery(
  variables: GetTagsApiV1MediaMetadataGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getTagsApiV1MediaMetadataGetQuery(
  variables: GetTagsApiV1MediaMetadataGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/media/metadata",
      operationId: "getTagsApiV1MediaMetadataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetTagsApiV1MediaMetadataGet(variables, signal),
  };
}

export const useSuspenseGetTagsApiV1MediaMetadataGet = <TData = void>(
  variables: GetTagsApiV1MediaMetadataGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetTagsApiV1MediaMetadataGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    GetTagsApiV1MediaMetadataGetError,
    TData
  >({
    ...getTagsApiV1MediaMetadataGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetTagsApiV1MediaMetadataGet = <TData = void>(
  variables: GetTagsApiV1MediaMetadataGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<void, GetTagsApiV1MediaMetadataGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<void, GetTagsApiV1MediaMetadataGetError, TData>({
    ...getTagsApiV1MediaMetadataGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostQueryParams =
  {
    bounding_box?: string | null;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostResponse =
  {
    [key: string]: any;
  };

export type SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostVariables =
  {
    body: Schemas.BodySearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPost;
    pathParams: SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostPathParams;
    queryParams?: SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * New Endpoint, to support similarity compatible experience,
 * this endpoint will return an updated context to be used with existing exploration queries
 */
export const fetchSearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPost =
  (
    variables: SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostResponse,
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostError,
      Schemas.BodySearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPost,
      {},
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostQueryParams,
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/search-image-similarity",
      method: "post",
      ...variables,
      signal,
    });

/**
 * New Endpoint, to support similarity compatible experience,
 * this endpoint will return an updated context to be used with existing exploration queries
 */
export const useSearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostResponse,
        SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostError,
        SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostResponse,
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostError,
      SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostVariables
    >({
      mutationFn: (
        variables: SearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPostVariables,
      ) =>
        fetchSearchImageSimilarityApiV1DatasetDatasetIdSearchImageSimilarityPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostQueryParams =
  {
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostVariables =
  {
    body: Schemas.BodyUploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePost;
    pathParams: UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostPathParams;
    queryParams?: UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Upload a query image for visual similarity search within a dataset.
 *
 * This endpoint accepts an image file and stores it for later embedding generation
 * and similarity search. The image is identified by a deterministic UUID generated
 * from its content hash and dataset ID, enabling deduplication of identical uploads.
 *
 * Args:
 *     dataset_id: UUID of the target dataset
 *     file: Image file to upload (supports common formats: PNG, JPG, etc.)
 *     context: Exploration context containing user and session information
 *     _user: Security dependency that enforces READ access on the dataset
 *
 * Returns:
 *     UploadFullImageResponse containing the query_image_id for subsequent operations
 *
 * Raises:
 *     HTTPException 400: If filename is missing from the upload
 *     HTTPException 403: If user lacks READ access to the dataset (enforced by auth dependency)
 *
 * Example:
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/upload-query-image
 *     Content-Type: multipart/form-data
 *
 *     Response: {"query_image_id": "550e8400-e29b-41d4-a716-446655440000"}
 *
 * Workflow:
 *     1. Upload image via this endpoint to receive a query_image_id
 *     2. Use the query_image_id with the generate-embedding endpoint to create a vector embedding
 *     3. Use the embedding for similarity search operations
 *
 * Note:
 *     Uploading the same image (by content hash) to the same dataset multiple times
 *     will return the same query_image_id without creating duplicate entries.
 */
export const fetchUploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePost =
  (
    variables: UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.UploadFullImageResponse,
      UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostError,
      Schemas.BodyUploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePost,
      {},
      UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostQueryParams,
      UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/search-image-similarity/upload-query-image",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Upload a query image for visual similarity search within a dataset.
 *
 * This endpoint accepts an image file and stores it for later embedding generation
 * and similarity search. The image is identified by a deterministic UUID generated
 * from its content hash and dataset ID, enabling deduplication of identical uploads.
 *
 * Args:
 *     dataset_id: UUID of the target dataset
 *     file: Image file to upload (supports common formats: PNG, JPG, etc.)
 *     context: Exploration context containing user and session information
 *     _user: Security dependency that enforces READ access on the dataset
 *
 * Returns:
 *     UploadFullImageResponse containing the query_image_id for subsequent operations
 *
 * Raises:
 *     HTTPException 400: If filename is missing from the upload
 *     HTTPException 403: If user lacks READ access to the dataset (enforced by auth dependency)
 *
 * Example:
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/upload-query-image
 *     Content-Type: multipart/form-data
 *
 *     Response: {"query_image_id": "550e8400-e29b-41d4-a716-446655440000"}
 *
 * Workflow:
 *     1. Upload image via this endpoint to receive a query_image_id
 *     2. Use the query_image_id with the generate-embedding endpoint to create a vector embedding
 *     3. Use the embedding for similarity search operations
 *
 * Note:
 *     Uploading the same image (by content hash) to the same dataset multiple times
 *     will return the same query_image_id without creating duplicate entries.
 */
export const useUploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.UploadFullImageResponse,
        UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostError,
        UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.UploadFullImageResponse,
      UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostError,
      UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostVariables
    >({
      mutationFn: (
        variables: UploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePostVariables,
      ) =>
        fetchUploadQueryImageApiV1DatasetDatasetIdSearchImageSimilarityUploadQueryImagePost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostQueryParams =
  {
    /**
     * @format uuid
     */
    media_id: string;
    media_type: Schemas.AnchorType;
    bounding_box?: string | null;
    /**
     * UUID of media item used for anchor similarity searches
     */
    anchor_media_id?: string | null;
    /**
     * AnchorType: 'MEDIA' or 'UPLOAD'
     */
    anchor_type?: ("MEDIA" | "UPLOAD") | null;
    /**
     * Additional context for anchor-based similarity searches
     */
    anchor_context?: string | null;
    /**
     * Filter results by caption text (semantic search)
     */
    caption?: string | null;
    /**
     * Filter results by caption text but ignoring label constraints
     */
    caption_only_filter?: string | null;
    /**
     * Filter results by file path. Accepts % as wildcard.
     */
    path_filter?: string | null;
    /**
     * One or multiple cluster types, e.g. 'IMAGES' or 'IMAGES,OBJECTS'
     */
    entity_type?: string | null;
    /**
     * Filter results by tags. e.g. '["tag_uuid", "other_tag_uuid"]'
     */
    tags?: string | null;
    /**
     * SimilarityThreshold as string, e.g. 0, 1, 2, 3, or 4.
     */
    threshold?: string | null;
    /**
     * Page number for pagination
     */
    page_number?: number | null;
    /**
     * Minimum uniqueness_score filter
     */
    uniqueness_score?: number | null;
    /**
     * Relevance threshold for semantic/similarity search (0.0-1.0). Higher values are stricter. Even 0.0 filters out some noise (never goes below model's default threshold).
     */
    semantic_relevance_threshold?: number | null;
    /**
     * Minimum threshold for semantic text similarity search (0.0-1.0)
     */
    textual_similarity_threshold?: number | null;
    /**
     * List of labels to filter by, e.g. '["cat","dog"]' or 'unlabeled'
     *
     * @deprecated true
     */
    labels?: string | null;
    /**
     * JSON array of metadata source IDs to filter by, e.g. '["vl_flywheel_v00"]'
     */
    metadata_sources?: string | null;
    /**
     * Filter results by duplication threshold
     *
     * @deprecated true
     */
    duplicate_threshold?: number | null;
    /**
     * List of issue type IDs as JSON array, e.g. '[1,2,3]'
     *
     * @deprecated true
     */
    issues?: string | null;
    /**
     * Visual Query Language (VQL) for advanced dataset filtering with type-safe composition and automatic validation.
     *
     *             VQL is a structured query language for filtering image datasets with precise syntax validation and SQL generation. Submit queries as JSON array or RISON-encoded string for URL safety.
     *
     *             **Query Structure:** Array of filter objects where each object contains exactly one filter type. Multiple filters are combined with AND logic across the array.
     *
     *             **Filter Type Reference:**
     *
     *             • **entity_type**: Filter by media type
     *               - Syntax: `{"entity_type": {"op": "is|is_not", "value": "IMAGES|OBJECTS"}}`
     *               - Example: `{"entity_type": {"op": "is", "value": "IMAGES"}}`
     *
     *             • **labels**: Filter by classification labels (from ML models)
     *               - Syntax: `{"labels": {"op": "is|is_not|one_of|not_one_of", "value": ["label1", "label2"], "include_unset": false}}`
     *               - Special: Use "unlabeled" in value array to match items without labels
     *               - Example: `{"labels": {"op": "one_of", "value": ["car", "vehicle"]}}`
     *
     *             • **tags**: Filter by user-defined UUID tags
     *               - Syntax: `{"tags": {"op": "is|is_not|one_of|not_one_of", "value": ["uuid1", "uuid2"], "include_unset": false}}`
     *               - Special: Use "untagged" in value array to match items without user tags
     *               - Example: `{"tags": {"op": "is", "value": ["7f034a46-f2b8-11ef-a133-7250fcfff5ad"]}}`
     *
     *             • **issues**: Filter by quality issues detected by analysis pipeline
     *               - Syntax: `{"issues": {"op": "issue", "value": "blur|dark|bright|mislabels|outliers|label_outlier|normal", "confidence_min": 0.8, "confidence_max": 1.0, "mode": "in|out"}}`
     *               - confidence_min/max: Optional range [0.8-1.0] (UI displays as 0.0-1.0 but backend normalizes)
     *               - mode: "in" to include issues, "out" to exclude them
     *               - Example: `{"issues": {"op": "issue", "value": "blur", "mode": "out", "confidence_min": 0.8}}`
     *
     *             • **text**: Full-text or semantic search on captions/descriptions
     *               - Syntax: `{"text": {"op": "fts|semantic", "value": "search text", "threshold": 0.7, "include_labels": true}}`
     *               - fts: Full-text search with stemming and ranking
     *               - semantic: Vector similarity search using embedding models
     *               - threshold: Optional similarity threshold for semantic search
     *               - include_labels: Extend search to include label text
     *               - Example: `{"text": {"op": "semantic", "value": "outdoor landscape", "threshold": 0.7}}`
     *
     *             • **similarity**: Find visually similar media using reference image
     *               - Syntax: `{"similarity": {"op": "media|upload", "value": "reference_uuid", "threshold": 0.8}}`
     *               - media: Reference existing media by UUID
     *               - upload: Reference uploaded image for similarity search
     *               - threshold: Optional cosine distance threshold (lower = more similar)
     *               - Example: `{"similarity": {"op": "media", "value": "7f034a46-f2b8-11ef-a133-7250fcfff5ad", "threshold": 0.8}}`
     *
     *             • **file/folder**: Path-based filtering on original file locations
     *               - file: `{"file": {"op": "starts_with|ends_with|contains|one_of", "value": "pattern" or ["path1", "path2"]}}`
     *               - folder: `{"folder": {"op": "starts_with|ends_with|contains|one_of", "value": "path" or ["path1", "path2"]}}`
     *               - Example: `{"file": {"op": "starts_with", "value": "IMG_"}}`
     *
     *             • **size**: Dimensional filtering for objects/images (pixel area)
     *               - Syntax: `{"size": {"op": "gt|lt|gte|lte", "value": 1000}}`
     *               - value: Pixel area (width × height)
     *               - Example: `{"size": {"op": "gt", "value": 2000}}`
     *
     *             • **duplicates**: Cluster by similarity threshold using precomputed analysis
     *               - Syntax: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *               - value: Similarity threshold [0.8-1.0]
     *               - Example: `{"duplicates": {"op": "duplicates", "value": 0.95}}`
     *
     *             • **uniqueness**: Filter by precomputed uniqueness scores from diversity analysis
     *               - Syntax: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *               - value: Minimum uniqueness score [0.0-1.0]
     *               - Example: `{"uniqueness": {"op": "uniqueness", "value": 0.8}}`
     *
     *             • **custom_metadata**: Filter by user-defined metadata fields
     *               - Syntax: `{"custom_metadata": {"field_id": "uuid", "field_name": "name", "field_type": "string|float|enum|datetime|link", "op": "contains|eq|neq|gt|lt|gte|lte|is|is_not|one_of|not_one_of|between", "value": "any"}}`
     *               - Operators vary by field_type (string: contains, float: gt/lt/eq, enum: one_of, datetime: between)
     *               - Example: `{"custom_metadata": {"field_name": "quality_score", "field_type": "float", "op": "gte", "value": 8.0}}`
     *
     *             • **created_at**: Filter by media creation timestamp
     *               - Syntax: `{"created_at": {"op": "eq|neq|gt|lt|gte|lte|between", "value": "timestamp"}}`
     *               - value: ISO 8601 timestamp string (e.g., "2024-01-15T10:30:00Z") or tuple for 'between'
     *               - Example: `{"created_at": {"op": "gte", "value": "2024-01-01T00:00:00Z"}}`
     *               - Example (between): `{"created_at": {"op": "between", "value": ["2024-01-01T00:00:00Z", "2024-12-31T23:59:59Z"]}}`
     *
     *             **Format Options:**
     *             - JSON Array (recommended): Standard JSON array of filter objects
     *             - RISON String: URL-safe encoded format for query parameters
     *
     *             **Query Semantics:** Multiple filters use AND logic. Each filter object must contain exactly one filter type.
     *
     *             **Performance Notes:** Queries leverage indexed fields (labels, tags, issues) and dataset partitioning for optimal performance on large datasets.
     */
    vql?: string | null;
    cluster_id?: string | null;
    /**
     * Return individual media items instead of aggregated clusters. When true, each response item represents a single media item with n_images=-1 and n_objects=-1.
     */
    flat_response?: boolean | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostRequestBody =
  Schemas.AccessOperation[] | null;

export type GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostVariables =
  {
    body?: GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostRequestBody;
    pathParams: GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostPathParams;
    queryParams: GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Generate a vector embedding for an image or region within an image.
 *
 * This endpoint computes a vector embedding for similarity search. It supports:
 * - Full images from the dataset (media_type=MEDIA)
 * - Previously uploaded query images (media_type=UPLOAD)
 * - Cropped regions via bounding_box parameter
 *
 * Embeddings are cached - calling this endpoint multiple times with the same
 * parameters will detect the existing embedding and return immediately without
 * recomputing.
 *
 * Args:
 *     dataset_id: UUID of the dataset containing the image
 *     media_id: UUID of the image (query_image_id if media_type=UPLOAD, or dataset image_id if media_type=MEDIA)
 *     media_type: Source of the image - 'UPLOAD' for user-uploaded query images, 'MEDIA' for dataset images
 *     bounding_box: Optional crop region as "left,upper,right,lower" (e.g., "100,50,300,200").
 *                  Coordinates are in pixels. If provided, embedding is generated only
 *                  for the specified rectangular region.
 *     context: Exploration context containing embedding configuration and user information
 *     _user: Security dependency that enforces READ access on the dataset
 *
 * Returns:
 *     GenerateEmbeddingResponse containing:
 *         - anchor_media_id: UUID of the generated embedding (can be used with similarity search)
 *         - anchor_type: Always set to UPLOAD (indicates this is a query embedding)
 *
 * Raises:
 *     HTTPException 400: If media_type is invalid or unsupported
 *     HTTPException 404: If the referenced image (MEDIA or UPLOAD) is not found
 *     HTTPException 403: If user lacks READ access to the dataset (enforced by auth dependency)
 *
 * Examples:
 *     # Generate embedding for full uploaded image
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/generate-embedding?media_id=550e8400-...&media_type=UPLOAD
 *
 *     Response: {"anchor_media_id": "660e9500-...", "anchor_type": "UPLOAD"}
 *
 *     # Generate embedding for cropped region from dataset image
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/generate-embedding?media_id=770eA600-...&media_type=MEDIA&bounding_box=10,20,100,200
 *
 *     Response: {"anchor_media_id": "880eB700-...", "anchor_type": "UPLOAD"}
 *
 * Note:
 *     The returned anchor_media_id is a derived UUID based on the source media_id and
 *     bounding_box (if provided), ensuring identical requests return the same embedding ID.
 */
export const fetchGenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPost =
  (
    variables: GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.GenerateEmbeddingResponse,
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostError,
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostRequestBody,
      {},
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostQueryParams,
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/search-image-similarity/generate-embedding",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Generate a vector embedding for an image or region within an image.
 *
 * This endpoint computes a vector embedding for similarity search. It supports:
 * - Full images from the dataset (media_type=MEDIA)
 * - Previously uploaded query images (media_type=UPLOAD)
 * - Cropped regions via bounding_box parameter
 *
 * Embeddings are cached - calling this endpoint multiple times with the same
 * parameters will detect the existing embedding and return immediately without
 * recomputing.
 *
 * Args:
 *     dataset_id: UUID of the dataset containing the image
 *     media_id: UUID of the image (query_image_id if media_type=UPLOAD, or dataset image_id if media_type=MEDIA)
 *     media_type: Source of the image - 'UPLOAD' for user-uploaded query images, 'MEDIA' for dataset images
 *     bounding_box: Optional crop region as "left,upper,right,lower" (e.g., "100,50,300,200").
 *                  Coordinates are in pixels. If provided, embedding is generated only
 *                  for the specified rectangular region.
 *     context: Exploration context containing embedding configuration and user information
 *     _user: Security dependency that enforces READ access on the dataset
 *
 * Returns:
 *     GenerateEmbeddingResponse containing:
 *         - anchor_media_id: UUID of the generated embedding (can be used with similarity search)
 *         - anchor_type: Always set to UPLOAD (indicates this is a query embedding)
 *
 * Raises:
 *     HTTPException 400: If media_type is invalid or unsupported
 *     HTTPException 404: If the referenced image (MEDIA or UPLOAD) is not found
 *     HTTPException 403: If user lacks READ access to the dataset (enforced by auth dependency)
 *
 * Examples:
 *     # Generate embedding for full uploaded image
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/generate-embedding?media_id=550e8400-...&media_type=UPLOAD
 *
 *     Response: {"anchor_media_id": "660e9500-...", "anchor_type": "UPLOAD"}
 *
 *     # Generate embedding for cropped region from dataset image
 *     POST /api/v1/dataset/{dataset_id}/search-image-similarity/generate-embedding?media_id=770eA600-...&media_type=MEDIA&bounding_box=10,20,100,200
 *
 *     Response: {"anchor_media_id": "880eB700-...", "anchor_type": "UPLOAD"}
 *
 * Note:
 *     The returned anchor_media_id is a derived UUID based on the source media_id and
 *     bounding_box (if provided), ensuring identical requests return the same embedding ID.
 */
export const useGenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.GenerateEmbeddingResponse,
        GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostError,
        GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.GenerateEmbeddingResponse,
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostError,
      GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostVariables
    >({
      mutationFn: (
        variables: GenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPostVariables,
      ) =>
        fetchGenerateEmbeddingApiV1DatasetDatasetIdSearchImageSimilarityGenerateEmbeddingPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetQueryParams =
  {
    enrichment_context_id?: string | null;
  };

export type GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables = {
  body?: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetRequestBody;
  pathParams: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetPathParams;
  queryParams?: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetEnrichmentContextApiV1EnrichmentDatasetIdContextGet = (
  variables: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.EnrichmentContextResponse,
    GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError,
    GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetRequestBody,
    {},
    GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetQueryParams,
    GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetPathParams
  >({
    url: "/api/v1/enrichment/{datasetId}/context",
    method: "get",
    ...variables,
    signal,
  });

export function getEnrichmentContextApiV1EnrichmentDatasetIdContextGetQuery(
  variables: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.EnrichmentContextResponse>;
};

export function getEnrichmentContextApiV1EnrichmentDatasetIdContextGetQuery(
  variables:
    | GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.EnrichmentContextResponse>)
    | reactQuery.SkipToken;
};

export function getEnrichmentContextApiV1EnrichmentDatasetIdContextGetQuery(
  variables:
    | GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/enrichment/{datasetId}/context",
      operationId: "getEnrichmentContextApiV1EnrichmentDatasetIdContextGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetEnrichmentContextApiV1EnrichmentDatasetIdContextGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetEnrichmentContextApiV1EnrichmentDatasetIdContextGet =
  <TData = Schemas.EnrichmentContextResponse>(
    variables: GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.EnrichmentContextResponse,
        GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.EnrichmentContextResponse,
      GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError,
      TData
    >({
      ...getEnrichmentContextApiV1EnrichmentDatasetIdContextGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetEnrichmentContextApiV1EnrichmentDatasetIdContextGet = <
  TData = Schemas.EnrichmentContextResponse,
>(
  variables:
    | GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EnrichmentContextResponse,
      GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.EnrichmentContextResponse,
    GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetError,
    TData
  >({
    ...getEnrichmentContextApiV1EnrichmentDatasetIdContextGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetModelsListApiV1EnrichmentDatasetIdListModelsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetModelsListApiV1EnrichmentDatasetIdListModelsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse =
  Schemas.EnrichmentModel[];

export type GetModelsListApiV1EnrichmentDatasetIdListModelsGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables = {
  body?: GetModelsListApiV1EnrichmentDatasetIdListModelsGetRequestBody;
  pathParams: GetModelsListApiV1EnrichmentDatasetIdListModelsGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetModelsListApiV1EnrichmentDatasetIdListModelsGet = (
  variables: GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetError,
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetRequestBody,
    {},
    {},
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetPathParams
  >({
    url: "/api/v1/enrichment/{datasetId}/list_models",
    method: "get",
    ...variables,
    signal,
  });

export function getModelsListApiV1EnrichmentDatasetIdListModelsGetQuery(
  variables: GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse>;
};

export function getModelsListApiV1EnrichmentDatasetIdListModelsGetQuery(
  variables:
    | GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse>)
    | reactQuery.SkipToken;
};

export function getModelsListApiV1EnrichmentDatasetIdListModelsGetQuery(
  variables:
    | GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/enrichment/{datasetId}/list_models",
      operationId: "getModelsListApiV1EnrichmentDatasetIdListModelsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetModelsListApiV1EnrichmentDatasetIdListModelsGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetModelsListApiV1EnrichmentDatasetIdListModelsGet = <
  TData = GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
>(
  variables: GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
      GetModelsListApiV1EnrichmentDatasetIdListModelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetError,
    TData
  >({
    ...getModelsListApiV1EnrichmentDatasetIdListModelsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetModelsListApiV1EnrichmentDatasetIdListModelsGet = <
  TData = GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
>(
  variables:
    | GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
      GetModelsListApiV1EnrichmentDatasetIdListModelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetResponse,
    GetModelsListApiV1EnrichmentDatasetIdListModelsGetError,
    TData
  >({
    ...getModelsListApiV1EnrichmentDatasetIdListModelsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    enrichmentContextId: string;
  };

export type GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostVariables =
  {
    body?: Schemas.EnrichmentConfigInput;
    pathParams: GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchGetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPost =
  (
    variables: GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.EnrichmentResultPreviews,
      GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostError,
      Schemas.EnrichmentConfigInput,
      {},
      {},
      GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostPathParams
    >({
      url: "/api/v1/enrichment/{datasetId}/{enrichmentContextId}/previews_enrichment_result",
      method: "post",
      ...variables,
      signal,
    });

export const useGetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.EnrichmentResultPreviews,
        GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostError,
        GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.EnrichmentResultPreviews,
      GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostError,
      GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostVariables
    >({
      mutationFn: (
        variables: GetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPostVariables,
      ) =>
        fetchGetPreviewsEnrichmentResultApiV1EnrichmentDatasetIdEnrichmentContextIdPreviewsEnrichmentResultPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    enrichmentContextId: string;
  };

export type GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables =
  {
    pathParams: GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchGetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet =
  (
    variables: GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError,
      undefined,
      {},
      {},
      GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetPathParams
    >({
      url: "/api/v1/enrichment/{datasetId}/{enrichmentContextId}/status",
      method: "get",
      ...variables,
      signal,
    });

export function getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetQuery(
  variables: GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetQuery(
  variables:
    | GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetQuery(
  variables:
    | GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/enrichment/{datasetId}/{enrichmentContextId}/status",
      operationId:
        "getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet =
  <TData = void>(
    variables: GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError,
      TData
    >({
      ...getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet =
  <TData = void>(
    variables:
      | GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      void,
      GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetError,
      TData
    >({
      ...getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    enrichmentContextId: string;
  };

export type AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteResponse =
  {
    [key: string]: any;
  };

export type AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteVariables =
  {
    pathParams: AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchAbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDelete =
  (
    variables: AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteResponse,
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteError,
      undefined,
      {},
      {},
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeletePathParams
    >({
      url: "/api/v1/enrichment/{datasetId}/{enrichmentContextId}/abort",
      method: "delete",
      ...variables,
      signal,
    });

export const useAbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteResponse,
        AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteError,
        AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteResponse,
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteError,
      AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteVariables
    >({
      mutationFn: (
        variables: AbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDeleteVariables,
      ) =>
        fetchAbortEnrichmentApiV1EnrichmentDatasetIdEnrichmentContextIdAbortDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type SaveViewApiV1DatasetDatasetIdViewsPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type SaveViewApiV1DatasetDatasetIdViewsPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type SaveViewApiV1DatasetDatasetIdViewsPostVariables = {
  pathParams: SaveViewApiV1DatasetDatasetIdViewsPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchSaveViewApiV1DatasetDatasetIdViewsPost = (
  variables: SaveViewApiV1DatasetDatasetIdViewsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.SavedView,
    SaveViewApiV1DatasetDatasetIdViewsPostError,
    undefined,
    {},
    {},
    SaveViewApiV1DatasetDatasetIdViewsPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/views",
    method: "post",
    ...variables,
    signal,
  });

export const useSaveViewApiV1DatasetDatasetIdViewsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SavedView,
      SaveViewApiV1DatasetDatasetIdViewsPostError,
      SaveViewApiV1DatasetDatasetIdViewsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.SavedView,
    SaveViewApiV1DatasetDatasetIdViewsPostError,
    SaveViewApiV1DatasetDatasetIdViewsPostVariables
  >({
    mutationFn: (variables: SaveViewApiV1DatasetDatasetIdViewsPostVariables) =>
      fetchSaveViewApiV1DatasetDatasetIdViewsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ListViewsApiV1DatasetDatasetIdViewsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ListViewsApiV1DatasetDatasetIdViewsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListViewsApiV1DatasetDatasetIdViewsGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ListViewsApiV1DatasetDatasetIdViewsGetVariables = {
  body?: ListViewsApiV1DatasetDatasetIdViewsGetRequestBody;
  pathParams: ListViewsApiV1DatasetDatasetIdViewsGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchListViewsApiV1DatasetDatasetIdViewsGet = (
  variables: ListViewsApiV1DatasetDatasetIdViewsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListViewsResponse,
    ListViewsApiV1DatasetDatasetIdViewsGetError,
    ListViewsApiV1DatasetDatasetIdViewsGetRequestBody,
    {},
    {},
    ListViewsApiV1DatasetDatasetIdViewsGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/views",
    method: "get",
    ...variables,
    signal,
  });

export function listViewsApiV1DatasetDatasetIdViewsGetQuery(
  variables: ListViewsApiV1DatasetDatasetIdViewsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListViewsResponse>;
};

export function listViewsApiV1DatasetDatasetIdViewsGetQuery(
  variables:
    | ListViewsApiV1DatasetDatasetIdViewsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListViewsResponse>)
    | reactQuery.SkipToken;
};

export function listViewsApiV1DatasetDatasetIdViewsGetQuery(
  variables:
    | ListViewsApiV1DatasetDatasetIdViewsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/views",
      operationId: "listViewsApiV1DatasetDatasetIdViewsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListViewsApiV1DatasetDatasetIdViewsGet(variables, signal),
  };
}

export const useSuspenseListViewsApiV1DatasetDatasetIdViewsGet = <
  TData = Schemas.ListViewsResponse,
>(
  variables: ListViewsApiV1DatasetDatasetIdViewsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListViewsResponse,
      ListViewsApiV1DatasetDatasetIdViewsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListViewsResponse,
    ListViewsApiV1DatasetDatasetIdViewsGetError,
    TData
  >({
    ...listViewsApiV1DatasetDatasetIdViewsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListViewsApiV1DatasetDatasetIdViewsGet = <
  TData = Schemas.ListViewsResponse,
>(
  variables:
    | ListViewsApiV1DatasetDatasetIdViewsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListViewsResponse,
      ListViewsApiV1DatasetDatasetIdViewsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListViewsResponse,
    ListViewsApiV1DatasetDatasetIdViewsGetError,
    TData
  >({
    ...listViewsApiV1DatasetDatasetIdViewsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DeleteViewApiV1DatasetDatasetIdViewsViewIdDeletePathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  viewId: string;
};

export type DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteVariables = {
  body?: DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteRequestBody;
  pathParams: DeleteViewApiV1DatasetDatasetIdViewsViewIdDeletePathParams;
} & VlContext["fetcherOptions"];

export const fetchDeleteViewApiV1DatasetDatasetIdViewsViewIdDelete = (
  variables: DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteError,
    DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteRequestBody,
    {},
    {},
    DeleteViewApiV1DatasetDatasetIdViewsViewIdDeletePathParams
  >({
    url: "/api/v1/dataset/{datasetId}/views/{viewId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteViewApiV1DatasetDatasetIdViewsViewIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteError,
      DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteError,
    DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteViewApiV1DatasetDatasetIdViewsViewIdDeleteVariables,
    ) =>
      fetchDeleteViewApiV1DatasetDatasetIdViewsViewIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  viewId: string;
};

export type GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables = {
  body?: GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetRequestBody;
  pathParams: GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get trend data for a monitored view.
 */
export const fetchGetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet = (
  variables: GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ViewTrendResponse,
    GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError,
    GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetRequestBody,
    {},
    {},
    GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/views/{viewId}/trend",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get trend data for a monitored view.
 */
export function getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetQuery(
  variables: GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ViewTrendResponse>;
};

export function getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetQuery(
  variables:
    | GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ViewTrendResponse>)
    | reactQuery.SkipToken;
};

export function getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetQuery(
  variables:
    | GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/views/{viewId}/trend",
      operationId: "getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get trend data for a monitored view.
 */
export const useSuspenseGetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet = <
  TData = Schemas.ViewTrendResponse,
>(
  variables: GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ViewTrendResponse,
      GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ViewTrendResponse,
    GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError,
    TData
  >({
    ...getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get trend data for a monitored view.
 */
export const useGetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet = <
  TData = Schemas.ViewTrendResponse,
>(
  variables:
    | GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ViewTrendResponse,
      GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ViewTrendResponse,
    GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetError,
    TData
  >({
    ...getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    viewId: string;
  };

export type SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostVariables =
  {
    body: Schemas.BodySetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPost;
    pathParams: SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Enable or disable alerting for a monitored view.
 */
export const fetchSetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPost =
  (
    variables: SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.AlertingResponse,
      SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostError,
      Schemas.BodySetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPost,
      {},
      {},
      SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/views/{viewId}/alerting",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Enable or disable alerting for a monitored view.
 */
export const useSetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AlertingResponse,
      SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostError,
      SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.AlertingResponse,
    SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostError,
    SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostVariables
  >({
    mutationFn: (
      variables: SetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPostVariables,
    ) =>
      fetchSetViewAlertingApiV1DatasetDatasetIdViewsViewIdAlertingPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ReportBugApiV1ReportBugPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ReportBugApiV1ReportBugPostVariables = VlContext["fetcherOptions"];

/**
 * Internal endpoint to report bugs to Slack and JIRA (future)
 * This endpoint is only available to Visual Layer employees
 */
export const fetchReportBugApiV1ReportBugPost = (
  variables: ReportBugApiV1ReportBugPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<void, ReportBugApiV1ReportBugPostError, undefined, {}, {}, {}>({
    url: "/api/v1/report_bug",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Internal endpoint to report bugs to Slack and JIRA (future)
 * This endpoint is only available to Visual Layer employees
 */
export const useReportBugApiV1ReportBugPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ReportBugApiV1ReportBugPostError,
      ReportBugApiV1ReportBugPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ReportBugApiV1ReportBugPostError,
    ReportBugApiV1ReportBugPostVariables
  >({
    mutationFn: (variables: ReportBugApiV1ReportBugPostVariables) =>
      fetchReportBugApiV1ReportBugPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostVariables =
  {
    body: Schemas.CustomMetadataFieldDefinition;
    pathParams: DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchDeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPost =
  (
    variables: DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.DeclareAttributeResp,
      DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostError,
      Schemas.CustomMetadataFieldDefinition,
      {},
      {},
      DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/custom_metadata/tasks",
      method: "post",
      ...variables,
      signal,
    });

export const useDeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.DeclareAttributeResp,
        DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostError,
        DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.DeclareAttributeResp,
      DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostError,
      DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostVariables
    >({
      mutationFn: (
        variables: DeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPostVariables,
      ) =>
        fetchDeclareAttributeApiV1DatasetsDatasetIdCustomMetadataTasksPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    taskId: string;
  };

export type UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostVariables =
  {
    body: Schemas.BodyUploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPost;
    pathParams: UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchUploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPost =
  (
    variables: UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostError,
      Schemas.BodyUploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPost,
      {},
      {},
      UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/custom_metadata/tasks/{taskId}",
      method: "post",
      ...variables,
      signal,
    });

export const useUploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostError,
        UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostError,
      UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostVariables
    >({
      mutationFn: (
        variables: UploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPostVariables,
      ) =>
        fetchUploadMetadataFileApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    taskId: string;
  };

export type CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetRequestBody =
  Schemas.AccessOperation[] | null;

export type CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables =
  {
    body?: CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetRequestBody;
    pathParams: CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchCheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet =
  (
    variables: CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.TaskStatusOutput,
      CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError,
      CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetRequestBody,
      {},
      {},
      CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/custom_metadata/tasks/{taskId}/status",
      method: "get",
      ...variables,
      signal,
    });

export function checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetQuery(
  variables: CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.TaskStatusOutput>;
};

export function checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetQuery(
  variables:
    | CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.TaskStatusOutput>)
    | reactQuery.SkipToken;
};

export function checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetQuery(
  variables:
    | CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/custom_metadata/tasks/{taskId}/status",
      operationId:
        "checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchCheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseCheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet =
  <TData = Schemas.TaskStatusOutput>(
    variables: CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.TaskStatusOutput,
        CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.TaskStatusOutput,
      CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError,
      TData
    >({
      ...checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useCheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet =
  <TData = Schemas.TaskStatusOutput>(
    variables:
      | CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.TaskStatusOutput,
        CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      Schemas.TaskStatusOutput,
      CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetError,
      TData
    >({
      ...checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse =
  Schemas.CustomMetadataField[];

export type ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetRequestBody =
  Schemas.AccessOperation[] | null;

export type ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables =
  {
    body?: ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetRequestBody;
    pathParams: ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet =
  (
    variables: ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError,
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetRequestBody,
      {},
      {},
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/custom_metadata/schema",
      method: "get",
      ...variables,
      signal,
    });

export function listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetQuery(
  variables: ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse>;
};

export function listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetQuery(
  variables:
    | ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse>)
    | reactQuery.SkipToken;
};

export function listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetQuery(
  variables:
    | ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/custom_metadata/schema",
      operationId:
        "listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet =
  <
    TData = ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
  >(
    variables: ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
        ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError,
      TData
    >({
      ...listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet =
  <
    TData = ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
  >(
    variables:
      | ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
        ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetResponse,
      ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetError,
      TData
    >({
      ...listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    imageId: string;
  };

export type RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse =
  Schemas.CustomMetadataItem[];

export type RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetRequestBody =
  Schemas.AccessOperation[] | null;

export type RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables =
  {
    body?: RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetRequestBody;
    pathParams: RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Return all custom-metadata key/value pairs for a given image in a dataset.
 */
export const fetchRetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet =
  (
    variables: RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError,
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetRequestBody,
      {},
      {},
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/image/{imageId}/custom_metadata",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Return all custom-metadata key/value pairs for a given image in a dataset.
 */
export function retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetQuery(
  variables: RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse>;
};

export function retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetQuery(
  variables:
    | RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse>)
    | reactQuery.SkipToken;
};

export function retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetQuery(
  variables:
    | RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/image/{imageId}/custom_metadata",
      operationId:
        "retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet(
              variables,
              signal,
            ),
  };
}

/**
 * Return all custom-metadata key/value pairs for a given image in a dataset.
 */
export const useSuspenseRetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet =
  <
    TData = RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
  >(
    variables: RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
        RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError,
      TData
    >({
      ...retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Return all custom-metadata key/value pairs for a given image in a dataset.
 */
export const useRetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet =
  <
    TData = RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
  >(
    variables:
      | RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
        RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetResponse,
      RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetError,
      TData
    >({
      ...retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    fieldId: string;
  };

export type GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse =
  string[];

export type GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetRequestBody =
  Schemas.AccessOperation[] | null;

export type GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables =
  {
    body?: GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetRequestBody;
    pathParams: GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Get all unique text values for string/link fields (used for link filtering dropdowns)
 */
export const fetchGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet =
  (
    variables: GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError,
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetRequestBody,
      {},
      {},
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetPathParams
    >({
      url: "/api/v1/datasets/{datasetId}/custom_metadata/fields/{fieldId}/unique_values",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Get all unique text values for string/link fields (used for link filtering dropdowns)
 */
export function getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetQuery(
  variables: GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse>;
};

export function getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetQuery(
  variables:
    | GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse>)
    | reactQuery.SkipToken;
};

export function getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetQuery(
  variables:
    | GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/custom_metadata/fields/{fieldId}/unique_values",
      operationId:
        "getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get all unique text values for string/link fields (used for link filtering dropdowns)
 */
export const useSuspenseGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet =
  <
    TData = GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
  >(
    variables: GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
        GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError,
      TData
    >({
      ...getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get all unique text values for string/link fields (used for link filtering dropdowns)
 */
export const useGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet =
  <
    TData = GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
  >(
    variables:
      | GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
        GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetResponse,
      GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetError,
      TData
    >({
      ...getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetLabelCategoryApiV1LabelCategoryDatasetIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetLabelCategoryApiV1LabelCategoryDatasetIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse = {
  [key: string]: string;
};

export type GetLabelCategoryApiV1LabelCategoryDatasetIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables = {
  body?: GetLabelCategoryApiV1LabelCategoryDatasetIdGetRequestBody;
  pathParams: GetLabelCategoryApiV1LabelCategoryDatasetIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetLabelCategoryApiV1LabelCategoryDatasetIdGet = (
  variables: GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetError,
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetRequestBody,
    {},
    {},
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetPathParams
  >({
    url: "/api/v1/label_category/{datasetId}",
    method: "get",
    ...variables,
    signal,
  });

export function getLabelCategoryApiV1LabelCategoryDatasetIdGetQuery(
  variables: GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse>;
};

export function getLabelCategoryApiV1LabelCategoryDatasetIdGetQuery(
  variables:
    | GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse>)
    | reactQuery.SkipToken;
};

export function getLabelCategoryApiV1LabelCategoryDatasetIdGetQuery(
  variables:
    | GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/label_category/{datasetId}",
      operationId: "getLabelCategoryApiV1LabelCategoryDatasetIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetLabelCategoryApiV1LabelCategoryDatasetIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetLabelCategoryApiV1LabelCategoryDatasetIdGet = <
  TData = GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
>(
  variables: GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
      GetLabelCategoryApiV1LabelCategoryDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetError,
    TData
  >({
    ...getLabelCategoryApiV1LabelCategoryDatasetIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetLabelCategoryApiV1LabelCategoryDatasetIdGet = <
  TData = GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
>(
  variables:
    | GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
      GetLabelCategoryApiV1LabelCategoryDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetResponse,
    GetLabelCategoryApiV1LabelCategoryDatasetIdGetError,
    TData
  >({
    ...getLabelCategoryApiV1LabelCategoryDatasetIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AddLabelCategoryApiV1LabelCategoryDatasetIdPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type AddLabelCategoryApiV1LabelCategoryDatasetIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddLabelCategoryApiV1LabelCategoryDatasetIdPostResponse = {
  [key: string]: string;
};

export type AddLabelCategoryApiV1LabelCategoryDatasetIdPostVariables = {
  body: Schemas.BodyAddLabelCategoryApiV1LabelCategoryDatasetIdPost;
  pathParams: AddLabelCategoryApiV1LabelCategoryDatasetIdPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchAddLabelCategoryApiV1LabelCategoryDatasetIdPost = (
  variables: AddLabelCategoryApiV1LabelCategoryDatasetIdPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostResponse,
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostError,
    Schemas.BodyAddLabelCategoryApiV1LabelCategoryDatasetIdPost,
    {},
    {},
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostPathParams
  >({
    url: "/api/v1/label_category/{datasetId}",
    method: "post",
    ...variables,
    signal,
  });

export const useAddLabelCategoryApiV1LabelCategoryDatasetIdPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AddLabelCategoryApiV1LabelCategoryDatasetIdPostResponse,
      AddLabelCategoryApiV1LabelCategoryDatasetIdPostError,
      AddLabelCategoryApiV1LabelCategoryDatasetIdPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostResponse,
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostError,
    AddLabelCategoryApiV1LabelCategoryDatasetIdPostVariables
  >({
    mutationFn: (
      variables: AddLabelCategoryApiV1LabelCategoryDatasetIdPostVariables,
    ) =>
      fetchAddLabelCategoryApiV1LabelCategoryDatasetIdPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type CreateLpSeedApiV1FlywheelDatasetIdSeedPutPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type CreateLpSeedApiV1FlywheelDatasetIdSeedPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CreateLpSeedApiV1FlywheelDatasetIdSeedPutRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type CreateLpSeedApiV1FlywheelDatasetIdSeedPutVariables = {
  body?: CreateLpSeedApiV1FlywheelDatasetIdSeedPutRequestBody;
  pathParams: CreateLpSeedApiV1FlywheelDatasetIdSeedPutPathParams;
} & VlContext["fetcherOptions"];

export const fetchCreateLpSeedApiV1FlywheelDatasetIdSeedPut = (
  variables: CreateLpSeedApiV1FlywheelDatasetIdSeedPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    CreateLpSeedApiV1FlywheelDatasetIdSeedPutError,
    CreateLpSeedApiV1FlywheelDatasetIdSeedPutRequestBody,
    {},
    {},
    CreateLpSeedApiV1FlywheelDatasetIdSeedPutPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/seed",
    method: "put",
    ...variables,
    signal,
  });

export const useCreateLpSeedApiV1FlywheelDatasetIdSeedPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      CreateLpSeedApiV1FlywheelDatasetIdSeedPutError,
      CreateLpSeedApiV1FlywheelDatasetIdSeedPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    CreateLpSeedApiV1FlywheelDatasetIdSeedPutError,
    CreateLpSeedApiV1FlywheelDatasetIdSeedPutVariables
  >({
    mutationFn: (
      variables: CreateLpSeedApiV1FlywheelDatasetIdSeedPutVariables,
    ) =>
      fetchCreateLpSeedApiV1FlywheelDatasetIdSeedPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    seedId: string;
  };

export type AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutVariables =
  {
    body?: Schemas.BodyAddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPut;
    pathParams: AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutPathParams;
  } & VlContext["fetcherOptions"];

export const fetchAddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPut =
  (
    variables: AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutError,
      Schemas.BodyAddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPut,
      {},
      {},
      AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/seed/{seedId}/label_category_id",
      method: "put",
      ...variables,
      signal,
    });

export const useAddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPut =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutError,
        AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutError,
      AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutVariables
    >({
      mutationFn: (
        variables: AddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPutVariables,
      ) =>
        fetchAddClassToSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdPut(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    labelCategoryId: string;
    /**
     * @format uuid
     */
    seedId: string;
    /**
     * @format uuid
     */
    mediaId: string;
  };

export type AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutRequestBody =
  Schemas.AccessOperation[] | null;

export type AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutVariables =
  {
    body?: AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutRequestBody;
    pathParams: AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutPathParams;
  } & VlContext["fetcherOptions"];

export const fetchAddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPut =
  (
    variables: AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.SeedResponse,
      AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutError,
      AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutRequestBody,
      {},
      {},
      AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/seed/{seedId}/{labelCategoryId}/{mediaId}",
      method: "put",
      ...variables,
      signal,
    });

export const useAddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPut =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.SeedResponse,
        AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutError,
        AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.SeedResponse,
      AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutError,
      AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutVariables
    >({
      mutationFn: (
        variables: AddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPutVariables,
      ) =>
        fetchAddSampleToLpSeedApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdMediaIdPut(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    labelCategoryId: string;
    /**
     * @format uuid
     */
    seedId: string;
  };

export type DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteVariables =
  {
    body?: DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteRequestBody;
    pathParams: DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchDeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDelete =
  (
    variables: DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteError,
      DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteRequestBody,
      {},
      {},
      DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeletePathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/seed/{seedId}/{labelCategoryId}",
      method: "delete",
      ...variables,
      signal,
    });

export const useDeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteError,
        DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteError,
      DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteVariables
    >({
      mutationFn: (
        variables: DeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDeleteVariables,
      ) =>
        fetchDeleteSamplesByLabelApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    labelCategoryId: string;
    /**
     * @format uuid
     */
    seedId: string;
    /**
     * @format uuid
     */
    sampleId: string;
  };

export type DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteVariables =
  {
    body?: DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteRequestBody;
    pathParams: DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchDeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDelete =
  (
    variables: DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteError,
      DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteRequestBody,
      {},
      {},
      DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeletePathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/seed/{seedId}/{labelCategoryId}/{sampleId}",
      method: "delete",
      ...variables,
      signal,
    });

export const useDeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteError,
        DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteError,
      DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteVariables
    >({
      mutationFn: (
        variables: DeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDeleteVariables,
      ) =>
        fetchDeleteSamplesByIdApiV1FlywheelDatasetIdSeedSeedIdLabelCategoryIdSampleIdDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    seedId: string;
  };

export type AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostVariables =
  {
    body: Schemas.BodyAddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPost;
    pathParams: AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchAddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPost =
  (
    variables: AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.SeedResponse,
      AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostError,
      Schemas.BodyAddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPost,
      {},
      {},
      AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/seed/{seedId}",
      method: "post",
      ...variables,
      signal,
    });

export const useAddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.SeedResponse,
        AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostError,
        AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.SeedResponse,
      AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostError,
      AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostVariables
    >({
      mutationFn: (
        variables: AddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPostVariables,
      ) =>
        fetchAddSampleToLpSeedShoppingCartApiV1FlywheelDatasetIdSeedSeedIdPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  seedId: string;
};

export type GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables = {
  body?: GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetRequestBody;
  pathParams: GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetSeedApiV1FlywheelDatasetIdSeedSeedIdGet = (
  variables: GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.SeedResponse,
    GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError,
    GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetRequestBody,
    {},
    {},
    GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/seed/{seedId}",
    method: "get",
    ...variables,
    signal,
  });

export function getSeedApiV1FlywheelDatasetIdSeedSeedIdGetQuery(
  variables: GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SeedResponse>;
};

export function getSeedApiV1FlywheelDatasetIdSeedSeedIdGetQuery(
  variables:
    | GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SeedResponse>)
    | reactQuery.SkipToken;
};

export function getSeedApiV1FlywheelDatasetIdSeedSeedIdGetQuery(
  variables:
    | GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/seed/{seedId}",
      operationId: "getSeedApiV1FlywheelDatasetIdSeedSeedIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSeedApiV1FlywheelDatasetIdSeedSeedIdGet(variables, signal),
  };
}

export const useSuspenseGetSeedApiV1FlywheelDatasetIdSeedSeedIdGet = <
  TData = Schemas.SeedResponse,
>(
  variables: GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SeedResponse,
      GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SeedResponse,
    GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError,
    TData
  >({
    ...getSeedApiV1FlywheelDatasetIdSeedSeedIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetSeedApiV1FlywheelDatasetIdSeedSeedIdGet = <
  TData = Schemas.SeedResponse,
>(
  variables:
    | GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SeedResponse,
      GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.SeedResponse,
    GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetError,
    TData
  >({
    ...getSeedApiV1FlywheelDatasetIdSeedSeedIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  flowId: string;
};

export type GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse =
  Schemas.ReviewSamplesCluster[];

export type GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables = {
  body?: GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetRequestBody;
  pathParams: GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet = (
  variables: GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError,
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetRequestBody,
    {},
    {},
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/review/{flowId}",
    method: "get",
    ...variables,
    signal,
  });

export function getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetQuery(
  variables: GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse>;
};

export function getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetQuery(
  variables:
    | GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse>)
    | reactQuery.SkipToken;
};

export function getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetQuery(
  variables:
    | GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/review/{flowId}",
      operationId: "getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet =
  <TData = GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse>(
    variables: GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
        GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
      GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError,
      TData
    >({
      ...getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet = <
  TData = GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
>(
  variables:
    | GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
      GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetResponse,
    GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetError,
    TData
  >({
    ...getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    flowId: string;
  };

export type BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutQueryParams =
  {
    review_result: Schemas.ReviewResult;
    label_category_id?: string | null;
  };

export type BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutVariables =
  {
    body?: Schemas.BodyBulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPut;
    pathParams: BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutPathParams;
    queryParams: BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchBulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPut =
  (
    variables: BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutError,
      Schemas.BodyBulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPut,
      {},
      BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutQueryParams,
      BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/review/{flowId}",
      method: "put",
      ...variables,
      signal,
    });

export const useBulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutError,
      BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutError,
    BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutVariables
  >({
    mutationFn: (
      variables: BulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPutVariables,
    ) =>
      fetchBulkSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    flowId: string;
    /**
     * @format uuid
     */
    labelCategoryId: string;
  };

export type GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse =
  Schemas.ReviewSamplesCluster | null;

export type GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetRequestBody =
  Schemas.AccessOperation[] | null;

export type GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables =
  {
    body?: GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetRequestBody;
    pathParams: GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchGetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet =
  (
    variables: GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError,
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetRequestBody,
      {},
      {},
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/review/{flowId}/{labelCategoryId}",
      method: "get",
      ...variables,
      signal,
    });

export function getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetQuery(
  variables: GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse>;
};

export function getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetQuery(
  variables:
    | GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse>)
    | reactQuery.SkipToken;
};

export function getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetQuery(
  variables:
    | GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/review/{flowId}/{labelCategoryId}",
      operationId:
        "getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet =
  <
    TData = GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
  >(
    variables: GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
        GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError,
      TData
    >({
      ...getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet =
  <
    TData = GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
  >(
    variables:
      | GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
        GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetResponse,
      GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetError,
      TData
    >({
      ...getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    flowId: string;
    /**
     * @format uuid
     */
    sampleId: string;
  };

export type SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutQueryParams =
  {
    review_result: Schemas.ReviewResult;
    label_category_id?: string | null;
  };

export type SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutRequestBody =
  Schemas.AccessOperation[] | null;

export type SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutVariables =
  {
    body?: SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutRequestBody;
    pathParams: SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutPathParams;
    queryParams: SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPut =
  (
    variables: SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutError,
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutRequestBody,
      {},
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutQueryParams,
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/review/{flowId}/{sampleId}",
      method: "put",
      ...variables,
      signal,
    });

export const useSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPut =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutError,
        SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutError,
      SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutVariables
    >({
      mutationFn: (
        variables: SubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPutVariables,
      ) =>
        fetchSubmitSampleReviewApiV1FlywheelDatasetIdReviewFlowIdSampleIdPut(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  seedId: string;
};

export type StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutVariables = {
  body?: Schemas.BodyStartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPut;
  pathParams: StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutPathParams;
} & VlContext["fetcherOptions"];

export const fetchStartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPut = (
  variables: StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlyWheelRunStatus,
    StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutError,
    Schemas.BodyStartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPut,
    {},
    {},
    StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/start/{seedId}",
    method: "put",
    ...variables,
    signal,
  });

export const useStartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FlyWheelRunStatus,
      StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutError,
      StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.FlyWheelRunStatus,
    StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutError,
    StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutVariables
  >({
    mutationFn: (
      variables: StartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPutVariables,
    ) =>
      fetchStartFlywheelRunApiV1FlywheelDatasetIdStartSeedIdPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  flowId: string;
};

export type FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables = {
  body?: FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetRequestBody;
  pathParams: FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchFlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet = (
  variables: FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlyWheelRunStatus,
    FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError,
    FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetRequestBody,
    {},
    {},
    FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/cycle/{flowId}",
    method: "get",
    ...variables,
    signal,
  });

export function flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetQuery(
  variables: FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.FlyWheelRunStatus>;
};

export function flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetQuery(
  variables:
    | FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.FlyWheelRunStatus>)
    | reactQuery.SkipToken;
};

export function flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetQuery(
  variables:
    | FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/cycle/{flowId}",
      operationId: "flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchFlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseFlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet = <
  TData = Schemas.FlyWheelRunStatus,
>(
  variables: FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FlyWheelRunStatus,
      FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.FlyWheelRunStatus,
    FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError,
    TData
  >({
    ...flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useFlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet = <
  TData = Schemas.FlyWheelRunStatus,
>(
  variables:
    | FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FlyWheelRunStatus,
      FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.FlyWheelRunStatus,
    FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetError,
    TData
  >({
    ...flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  flowId: string;
};

export type FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQueryParams =
  {
    /**
     * @default false
     */
    wait?: boolean;
    etag?: string | null;
  };

export type FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables = {
  body?: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetRequestBody;
  pathParams: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetPathParams;
  queryParams?: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchFlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet = (
  variables: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError,
    FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetRequestBody,
    {},
    FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQueryParams,
    FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/status/{flowId}",
    method: "get",
    ...variables,
    signal,
  });

export function flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQuery(
  variables: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQuery(
  variables:
    | FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQuery(
  variables:
    | FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/status/{flowId}",
      operationId: "flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchFlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseFlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet =
  <TData = void>(
    variables: FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError,
      TData
    >({
      ...flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useFlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet = <
  TData = void,
>(
  variables:
    | FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetError,
    TData
  >({
    ...flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    flowId: string;
  };

export type FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteVariables = {
  body?: FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteRequestBody;
  pathParams: FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeletePathParams;
} & VlContext["fetcherOptions"];

export const fetchFlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDelete = (
  variables: FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlyWheelRunStatus,
    FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteError,
    FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteRequestBody,
    {},
    {},
    FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeletePathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/abort/{flowId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useFlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FlyWheelRunStatus,
      FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteError,
      FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.FlyWheelRunStatus,
    FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteError,
    FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteVariables
  >({
    mutationFn: (
      variables: FlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDeleteVariables,
    ) =>
      fetchFlywheelRunAbortApiV1FlywheelDatasetIdAbortFlowIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
  /**
   * @format uuid
   */
  flowId: string;
};

export type FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables = {
  body?: FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetRequestBody;
  pathParams: FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchFlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet = (
  variables: FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlyWheelRunStats,
    FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError,
    FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetRequestBody,
    {},
    {},
    FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/stats/{flowId}",
    method: "get",
    ...variables,
    signal,
  });

export function flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetQuery(
  variables: FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.FlyWheelRunStats>;
};

export function flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetQuery(
  variables:
    | FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.FlyWheelRunStats>)
    | reactQuery.SkipToken;
};

export function flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetQuery(
  variables:
    | FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/stats/{flowId}",
      operationId: "flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchFlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseFlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet = <
  TData = Schemas.FlyWheelRunStats,
>(
  variables: FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FlyWheelRunStats,
      FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.FlyWheelRunStats,
    FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError,
    TData
  >({
    ...flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useFlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet = <
  TData = Schemas.FlyWheelRunStats,
>(
  variables:
    | FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FlyWheelRunStats,
      FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.FlyWheelRunStats,
    FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetError,
    TData
  >({
    ...flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables = {
  body?: FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetRequestBody;
  pathParams: FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet = (
  variables: FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlywheelDatasetStatus,
    FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError,
    FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetRequestBody,
    {},
    {},
    FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}",
    method: "get",
    ...variables,
    signal,
  });

export function flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetQuery(
  variables: FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.FlywheelDatasetStatus>;
};

export function flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetQuery(
  variables:
    | FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.FlywheelDatasetStatus>)
    | reactQuery.SkipToken;
};

export function flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetQuery(
  variables:
    | FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}",
      operationId: "flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet =
  <TData = Schemas.FlywheelDatasetStatus>(
    variables: FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.FlywheelDatasetStatus,
        FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.FlywheelDatasetStatus,
      FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError,
      TData
    >({
      ...flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet = <
  TData = Schemas.FlywheelDatasetStatus,
>(
  variables:
    | FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FlywheelDatasetStatus,
      FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.FlywheelDatasetStatus,
    FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetError,
    TData
  >({
    ...flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    flowId: string;
  };

export type FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutRequestBody =
  Schemas.AccessOperation[] | null;

export type FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutVariables =
  {
    body?: FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutRequestBody;
    pathParams: FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutPathParams;
  } & VlContext["fetcherOptions"];

export const fetchFlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPut = (
  variables: FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.FlyWheelRunStatus,
    FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutError,
    FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutRequestBody,
    {},
    {},
    FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutPathParams
  >({
    url: "/api/v1/flywheel/{datasetId}/apply/{flowId}",
    method: "put",
    ...variables,
    signal,
  });

export const useFlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FlyWheelRunStatus,
      FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutError,
      FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.FlyWheelRunStatus,
    FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutError,
    FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutVariables
  >({
    mutationFn: (
      variables: FlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPutVariables,
    ) =>
      fetchFlywheelApplyResultsApiV1FlywheelDatasetIdApplyFlowIdPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetRequestBody =
  Schemas.AccessOperation[] | null;

export type GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables =
  {
    body?: GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetRequestBody;
    pathParams: GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchGetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet =
  (
    variables: GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.FlywheelAnnotationsExportResponse,
      GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError,
      GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetRequestBody,
      {},
      {},
      GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/annotations/latest",
      method: "get",
      ...variables,
      signal,
    });

export function getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetQuery(
  variables: GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.FlywheelAnnotationsExportResponse>;
};

export function getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetQuery(
  variables:
    | GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.FlywheelAnnotationsExportResponse>)
    | reactQuery.SkipToken;
};

export function getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetQuery(
  variables:
    | GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/flywheel/{datasetId}/annotations/latest",
      operationId:
        "getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet =
  <TData = Schemas.FlywheelAnnotationsExportResponse>(
    variables: GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.FlywheelAnnotationsExportResponse,
        GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.FlywheelAnnotationsExportResponse,
      GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError,
      TData
    >({
      ...getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useGetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet =
  <TData = Schemas.FlywheelAnnotationsExportResponse>(
    variables:
      | GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.FlywheelAnnotationsExportResponse,
        GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      Schemas.FlywheelAnnotationsExportResponse,
      GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetError,
      TData
    >({
      ...getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostVariables =
  {
    body?: Schemas.BodyPostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPost;
    pathParams: PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchPostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPost =
  (
    variables: PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.ExportTask,
      PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostError,
      Schemas.BodyPostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPost,
      {},
      {},
      PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostPathParams
    >({
      url: "/api/v1/flywheel/{datasetId}/eval_report_html_async",
      method: "post",
      ...variables,
      signal,
    });

export const usePostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.ExportTask,
        PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostError,
        PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.ExportTask,
      PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostError,
      PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostVariables
    >({
      mutationFn: (
        variables: PostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPostVariables,
      ) =>
        fetchPostFlywheelEvalReportHtmlAsyncApiV1FlywheelDatasetIdEvalReportHtmlAsyncPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type CsvExportApiV1DatasetsDatasetIdExportCsvGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type CsvExportApiV1DatasetsDatasetIdExportCsvGetQueryParams = {
  /**
   * @default false
   */
  allow_deleted?: boolean;
};

export type CsvExportApiV1DatasetsDatasetIdExportCsvGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables = {
  pathParams: CsvExportApiV1DatasetsDatasetIdExportCsvGetPathParams;
  queryParams?: CsvExportApiV1DatasetsDatasetIdExportCsvGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchCsvExportApiV1DatasetsDatasetIdExportCsvGet = (
  variables: CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    CsvExportApiV1DatasetsDatasetIdExportCsvGetError,
    undefined,
    {},
    CsvExportApiV1DatasetsDatasetIdExportCsvGetQueryParams,
    CsvExportApiV1DatasetsDatasetIdExportCsvGetPathParams
  >({
    url: "/api/v1/datasets/{datasetId}/export_csv",
    method: "get",
    ...variables,
    signal,
  });

export function csvExportApiV1DatasetsDatasetIdExportCsvGetQuery(
  variables: CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function csvExportApiV1DatasetsDatasetIdExportCsvGetQuery(
  variables:
    | CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function csvExportApiV1DatasetsDatasetIdExportCsvGetQuery(
  variables:
    | CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/export_csv",
      operationId: "csvExportApiV1DatasetsDatasetIdExportCsvGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchCsvExportApiV1DatasetsDatasetIdExportCsvGet(variables, signal),
  };
}

export const useSuspenseCsvExportApiV1DatasetsDatasetIdExportCsvGet = <
  TData = void,
>(
  variables: CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      CsvExportApiV1DatasetsDatasetIdExportCsvGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    CsvExportApiV1DatasetsDatasetIdExportCsvGetError,
    TData
  >({
    ...csvExportApiV1DatasetsDatasetIdExportCsvGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useCsvExportApiV1DatasetsDatasetIdExportCsvGet = <TData = void>(
  variables:
    | CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      CsvExportApiV1DatasetsDatasetIdExportCsvGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    CsvExportApiV1DatasetsDatasetIdExportCsvGetError,
    TData
  >({
    ...csvExportApiV1DatasetsDatasetIdExportCsvGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListModelsApiV1TrainingModelsGetError =
  Fetcher.ErrorWrapper<undefined>;

export type ListModelsApiV1TrainingModelsGetVariables =
  VlContext["fetcherOptions"];

export const fetchListModelsApiV1TrainingModelsGet = (
  variables: ListModelsApiV1TrainingModelsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
    ListModelsApiV1TrainingModelsGetError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/training/models", method: "get", ...variables, signal });

export function listModelsApiV1TrainingModelsGetQuery(
  variables: ListModelsApiV1TrainingModelsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse>;
};

export function listModelsApiV1TrainingModelsGetQuery(
  variables: ListModelsApiV1TrainingModelsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse>)
    | reactQuery.SkipToken;
};

export function listModelsApiV1TrainingModelsGetQuery(
  variables: ListModelsApiV1TrainingModelsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/training/models",
      operationId: "listModelsApiV1TrainingModelsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListModelsApiV1TrainingModelsGet(variables, signal),
  };
}

export const useSuspenseListModelsApiV1TrainingModelsGet = <
  TData = Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
>(
  variables: ListModelsApiV1TrainingModelsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
      ListModelsApiV1TrainingModelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
    ListModelsApiV1TrainingModelsGetError,
    TData
  >({
    ...listModelsApiV1TrainingModelsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListModelsApiV1TrainingModelsGet = <
  TData = Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
>(
  variables: ListModelsApiV1TrainingModelsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
      ListModelsApiV1TrainingModelsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ClustplorerClustplorerModelsDatasetModelTrainingListModelsResponse,
    ListModelsApiV1TrainingModelsGetError,
    TData
  >({
    ...listModelsApiV1TrainingModelsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetTrainingTasksApiV1TrainingTasksGetQueryParams = {
  dataset_id?: string | null;
};

export type GetTrainingTasksApiV1TrainingTasksGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetTrainingTasksApiV1TrainingTasksGetVariables = {
  queryParams?: GetTrainingTasksApiV1TrainingTasksGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetTrainingTasksApiV1TrainingTasksGet = (
  variables: GetTrainingTasksApiV1TrainingTasksGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.GetTasksResponse,
    GetTrainingTasksApiV1TrainingTasksGetError,
    undefined,
    {},
    GetTrainingTasksApiV1TrainingTasksGetQueryParams,
    {}
  >({ url: "/api/v1/training/tasks", method: "get", ...variables, signal });

export function getTrainingTasksApiV1TrainingTasksGetQuery(
  variables: GetTrainingTasksApiV1TrainingTasksGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.GetTasksResponse>;
};

export function getTrainingTasksApiV1TrainingTasksGetQuery(
  variables:
    | GetTrainingTasksApiV1TrainingTasksGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.GetTasksResponse>)
    | reactQuery.SkipToken;
};

export function getTrainingTasksApiV1TrainingTasksGetQuery(
  variables:
    | GetTrainingTasksApiV1TrainingTasksGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/training/tasks",
      operationId: "getTrainingTasksApiV1TrainingTasksGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetTrainingTasksApiV1TrainingTasksGet(variables, signal),
  };
}

export const useSuspenseGetTrainingTasksApiV1TrainingTasksGet = <
  TData = Schemas.GetTasksResponse,
>(
  variables: GetTrainingTasksApiV1TrainingTasksGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTasksResponse,
      GetTrainingTasksApiV1TrainingTasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetTasksResponse,
    GetTrainingTasksApiV1TrainingTasksGetError,
    TData
  >({
    ...getTrainingTasksApiV1TrainingTasksGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetTrainingTasksApiV1TrainingTasksGet = <
  TData = Schemas.GetTasksResponse,
>(
  variables:
    | GetTrainingTasksApiV1TrainingTasksGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTasksResponse,
      GetTrainingTasksApiV1TrainingTasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.GetTasksResponse,
    GetTrainingTasksApiV1TrainingTasksGetError,
    TData
  >({
    ...getTrainingTasksApiV1TrainingTasksGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type TriggerTrainingApiV1TrainingPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type TriggerTrainingApiV1TrainingPostVariables = {
  body: Schemas.TrainingTriggerRequest;
} & VlContext["fetcherOptions"];

export const fetchTriggerTrainingApiV1TrainingPost = (
  variables: TriggerTrainingApiV1TrainingPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TriggerTrainingResponse,
    TriggerTrainingApiV1TrainingPostError,
    Schemas.TrainingTriggerRequest,
    {},
    {},
    {}
  >({ url: "/api/v1/training", method: "post", ...variables, signal });

export const useTriggerTrainingApiV1TrainingPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TriggerTrainingResponse,
      TriggerTrainingApiV1TrainingPostError,
      TriggerTrainingApiV1TrainingPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.TriggerTrainingResponse,
    TriggerTrainingApiV1TrainingPostError,
    TriggerTrainingApiV1TrainingPostVariables
  >({
    mutationFn: (variables: TriggerTrainingApiV1TrainingPostVariables) =>
      fetchTriggerTrainingApiV1TrainingPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchPathParams =
  {
    /**
     * @format uuid
     */
    trainingTaskId: string;
  };

export type ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchQueryParams =
  {
    /**
     * @default CANCEL
     */
    action?: string;
  };

export type ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchVariables =
  {
    pathParams: ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchPathParams;
    queryParams?: ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch = (
  variables: ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TrainingTask,
    ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchError,
    undefined,
    {},
    ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchQueryParams,
    ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchPathParams
  >({
    url: "/api/v1/training/tasks/{trainingTaskId}",
    method: "patch",
    ...variables,
    signal,
  });

export const useModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TrainingTask,
      ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchError,
      ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.TrainingTask,
    ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchError,
    ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchVariables
  >({
    mutationFn: (
      variables: ModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatchVariables,
    ) =>
      fetchModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetPathParams = {
  /**
   * @format uuid
   */
  trainingTaskId: string;
};

export type GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables = {
  pathParams: GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetSingleTaskApiV1TrainingTasksTrainingTaskIdGet = (
  variables: GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TrainingTask,
    GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError,
    undefined,
    {},
    {},
    GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetPathParams
  >({
    url: "/api/v1/training/tasks/{trainingTaskId}",
    method: "get",
    ...variables,
    signal,
  });

export function getSingleTaskApiV1TrainingTasksTrainingTaskIdGetQuery(
  variables: GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.TrainingTask>;
};

export function getSingleTaskApiV1TrainingTasksTrainingTaskIdGetQuery(
  variables:
    | GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.TrainingTask>)
    | reactQuery.SkipToken;
};

export function getSingleTaskApiV1TrainingTasksTrainingTaskIdGetQuery(
  variables:
    | GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/training/tasks/{trainingTaskId}",
      operationId: "getSingleTaskApiV1TrainingTasksTrainingTaskIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSingleTaskApiV1TrainingTasksTrainingTaskIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetSingleTaskApiV1TrainingTasksTrainingTaskIdGet = <
  TData = Schemas.TrainingTask,
>(
  variables: GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TrainingTask,
      GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.TrainingTask,
    GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError,
    TData
  >({
    ...getSingleTaskApiV1TrainingTasksTrainingTaskIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetSingleTaskApiV1TrainingTasksTrainingTaskIdGet = <
  TData = Schemas.TrainingTask,
>(
  variables:
    | GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TrainingTask,
      GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.TrainingTask,
    GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetError,
    TData
  >({
    ...getSingleTaskApiV1TrainingTasksTrainingTaskIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetModelApiV1ModelsCatalogModelsModelIdGetPathParams = {
  /**
   * @format uuid
   */
  modelId: string;
};

export type GetModelApiV1ModelsCatalogModelsModelIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetModelApiV1ModelsCatalogModelsModelIdGetVariables = {
  pathParams: GetModelApiV1ModelsCatalogModelsModelIdGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get a single model by ID.
 *
 * Returns 404 if model doesn't exist or user doesn't have access to the dataset.
 */
export const fetchGetModelApiV1ModelsCatalogModelsModelIdGet = (
  variables: GetModelApiV1ModelsCatalogModelsModelIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ModelCatalog,
    GetModelApiV1ModelsCatalogModelsModelIdGetError,
    undefined,
    {},
    {},
    GetModelApiV1ModelsCatalogModelsModelIdGetPathParams
  >({
    url: "/api/v1/models_catalog/models/{modelId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get a single model by ID.
 *
 * Returns 404 if model doesn't exist or user doesn't have access to the dataset.
 */
export function getModelApiV1ModelsCatalogModelsModelIdGetQuery(
  variables: GetModelApiV1ModelsCatalogModelsModelIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ModelCatalog>;
};

export function getModelApiV1ModelsCatalogModelsModelIdGetQuery(
  variables:
    | GetModelApiV1ModelsCatalogModelsModelIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ModelCatalog>)
    | reactQuery.SkipToken;
};

export function getModelApiV1ModelsCatalogModelsModelIdGetQuery(
  variables:
    | GetModelApiV1ModelsCatalogModelsModelIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog/models/{modelId}",
      operationId: "getModelApiV1ModelsCatalogModelsModelIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetModelApiV1ModelsCatalogModelsModelIdGet(variables, signal),
  };
}

/**
 * Get a single model by ID.
 *
 * Returns 404 if model doesn't exist or user doesn't have access to the dataset.
 */
export const useSuspenseGetModelApiV1ModelsCatalogModelsModelIdGet = <
  TData = Schemas.ModelCatalog,
>(
  variables: GetModelApiV1ModelsCatalogModelsModelIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ModelCatalog,
      GetModelApiV1ModelsCatalogModelsModelIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ModelCatalog,
    GetModelApiV1ModelsCatalogModelsModelIdGetError,
    TData
  >({
    ...getModelApiV1ModelsCatalogModelsModelIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get a single model by ID.
 *
 * Returns 404 if model doesn't exist or user doesn't have access to the dataset.
 */
export const useGetModelApiV1ModelsCatalogModelsModelIdGet = <
  TData = Schemas.ModelCatalog,
>(
  variables:
    | GetModelApiV1ModelsCatalogModelsModelIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ModelCatalog,
      GetModelApiV1ModelsCatalogModelsModelIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ModelCatalog,
    GetModelApiV1ModelsCatalogModelsModelIdGetError,
    TData
  >({
    ...getModelApiV1ModelsCatalogModelsModelIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateModelApiV1ModelsCatalogModelsModelIdPatchPathParams = {
  /**
   * @format uuid
   */
  modelId: string;
};

export type UpdateModelApiV1ModelsCatalogModelsModelIdPatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateModelApiV1ModelsCatalogModelsModelIdPatchVariables = {
  body: Schemas.UpdateModelRequest;
  pathParams: UpdateModelApiV1ModelsCatalogModelsModelIdPatchPathParams;
} & VlContext["fetcherOptions"];

/**
 * Update a model's production status.
 *
 * Returns 404 if model doesn't exist or user doesn't have access.
 */
export const fetchUpdateModelApiV1ModelsCatalogModelsModelIdPatch = (
  variables: UpdateModelApiV1ModelsCatalogModelsModelIdPatchVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ModelCatalog,
    UpdateModelApiV1ModelsCatalogModelsModelIdPatchError,
    Schemas.UpdateModelRequest,
    {},
    {},
    UpdateModelApiV1ModelsCatalogModelsModelIdPatchPathParams
  >({
    url: "/api/v1/models_catalog/models/{modelId}",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update a model's production status.
 *
 * Returns 404 if model doesn't exist or user doesn't have access.
 */
export const useUpdateModelApiV1ModelsCatalogModelsModelIdPatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ModelCatalog,
      UpdateModelApiV1ModelsCatalogModelsModelIdPatchError,
      UpdateModelApiV1ModelsCatalogModelsModelIdPatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.ModelCatalog,
    UpdateModelApiV1ModelsCatalogModelsModelIdPatchError,
    UpdateModelApiV1ModelsCatalogModelsModelIdPatchVariables
  >({
    mutationFn: (
      variables: UpdateModelApiV1ModelsCatalogModelsModelIdPatchVariables,
    ) =>
      fetchUpdateModelApiV1ModelsCatalogModelsModelIdPatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DeleteModelApiV1ModelsCatalogModelsModelIdDeletePathParams = {
  /**
   * @format uuid
   */
  modelId: string;
};

export type DeleteModelApiV1ModelsCatalogModelsModelIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteModelApiV1ModelsCatalogModelsModelIdDeleteVariables = {
  pathParams: DeleteModelApiV1ModelsCatalogModelsModelIdDeletePathParams;
} & VlContext["fetcherOptions"];

/**
 * Delete a model.
 *
 * Only workspace admins can delete models.
 * Returns 404 if model doesn't exist or user doesn't have access.
 */
export const fetchDeleteModelApiV1ModelsCatalogModelsModelIdDelete = (
  variables: DeleteModelApiV1ModelsCatalogModelsModelIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DeleteModelApiV1ModelsCatalogModelsModelIdDeleteError,
    undefined,
    {},
    {},
    DeleteModelApiV1ModelsCatalogModelsModelIdDeletePathParams
  >({
    url: "/api/v1/models_catalog/models/{modelId}",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a model.
 *
 * Only workspace admins can delete models.
 * Returns 404 if model doesn't exist or user doesn't have access.
 */
export const useDeleteModelApiV1ModelsCatalogModelsModelIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteModelApiV1ModelsCatalogModelsModelIdDeleteError,
      DeleteModelApiV1ModelsCatalogModelsModelIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteModelApiV1ModelsCatalogModelsModelIdDeleteError,
    DeleteModelApiV1ModelsCatalogModelsModelIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteModelApiV1ModelsCatalogModelsModelIdDeleteVariables,
    ) =>
      fetchDeleteModelApiV1ModelsCatalogModelsModelIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError =
  Fetcher.ErrorWrapper<undefined>;

export type GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables =
  VlContext["fetcherOptions"];

/**
 * Get available filter options for models catalog.
 */
export const fetchGetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet = (
  variables: GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ModelCatalogFilterOptionsResponse,
    GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v1/models_catalog/filters",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get available filter options for models catalog.
 */
export function getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetQuery(
  variables: GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ModelCatalogFilterOptionsResponse>;
};

export function getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetQuery(
  variables:
    | GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.ModelCatalogFilterOptionsResponse>)
    | reactQuery.SkipToken;
};

export function getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetQuery(
  variables:
    | GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog/filters",
      operationId: "getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get available filter options for models catalog.
 */
export const useSuspenseGetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet =
  <TData = Schemas.ModelCatalogFilterOptionsResponse>(
    variables: GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.ModelCatalogFilterOptionsResponse,
        GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.ModelCatalogFilterOptionsResponse,
      GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError,
      TData
    >({
      ...getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get available filter options for models catalog.
 */
export const useGetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet = <
  TData = Schemas.ModelCatalogFilterOptionsResponse,
>(
  variables:
    | GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ModelCatalogFilterOptionsResponse,
      GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ModelCatalogFilterOptionsResponse,
    GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetError,
    TData
  >({
    ...getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListModelsApiV1ModelsCatalogGetQueryParams = {
  dataset_id?: string | null;
  model_id?: string | null;
  model_name?: string | null;
  dataset_name?: string | null;
  type?: string | null;
  source?: string | null;
  is_production?: boolean | null;
  metadata?: string | null;
  supported_dataset_id?: string | null;
  job_name?: string | string[] | null;
  setup_name?: string | string[] | null;
  recipes?: string[] | null;
  tool_list?: string[] | null;
  page?: number | null;
  page_size?: number | null;
  /**
   * Field to sort by
   */
  sort_by?: Schemas.ModelCatalogSortField | null;
  sort_order?: Schemas.SortOrder;
};

export type ListModelsApiV1ModelsCatalogGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListModelsApiV1ModelsCatalogGetVariables = {
  queryParams?: ListModelsApiV1ModelsCatalogGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * List models with optional filters.
 *
 * Only returns models from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by specific model ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - type: Filter by model type (exact match)
 * - source: Filter by model source (exact match)
 * - is_production: Filter by production status
 * - metadata: Metadata filters in JSON format {"version":"1.0"} or RSON format (version:1.0,type:detection)
 * - supported_dataset_id: Filter models trained on datasets with same classes as this dataset
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const fetchListModelsApiV1ModelsCatalogGet = (
  variables: ListModelsApiV1ModelsCatalogGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
    ListModelsApiV1ModelsCatalogGetError,
    undefined,
    {},
    ListModelsApiV1ModelsCatalogGetQueryParams,
    {}
  >({ url: "/api/v1/models_catalog", method: "get", ...variables, signal });

/**
 * List models with optional filters.
 *
 * Only returns models from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by specific model ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - type: Filter by model type (exact match)
 * - source: Filter by model source (exact match)
 * - is_production: Filter by production status
 * - metadata: Metadata filters in JSON format {"version":"1.0"} or RSON format (version:1.0,type:detection)
 * - supported_dataset_id: Filter models trained on datasets with same classes as this dataset
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export function listModelsApiV1ModelsCatalogGetQuery(
  variables: ListModelsApiV1ModelsCatalogGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse>;
};

export function listModelsApiV1ModelsCatalogGetQuery(
  variables: ListModelsApiV1ModelsCatalogGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse>)
    | reactQuery.SkipToken;
};

export function listModelsApiV1ModelsCatalogGetQuery(
  variables: ListModelsApiV1ModelsCatalogGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog",
      operationId: "listModelsApiV1ModelsCatalogGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListModelsApiV1ModelsCatalogGet(variables, signal),
  };
}

/**
 * List models with optional filters.
 *
 * Only returns models from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by specific model ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - type: Filter by model type (exact match)
 * - source: Filter by model source (exact match)
 * - is_production: Filter by production status
 * - metadata: Metadata filters in JSON format {"version":"1.0"} or RSON format (version:1.0,type:detection)
 * - supported_dataset_id: Filter models trained on datasets with same classes as this dataset
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const useSuspenseListModelsApiV1ModelsCatalogGet = <
  TData = Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
>(
  variables: ListModelsApiV1ModelsCatalogGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
      ListModelsApiV1ModelsCatalogGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
    ListModelsApiV1ModelsCatalogGetError,
    TData
  >({
    ...listModelsApiV1ModelsCatalogGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List models with optional filters.
 *
 * Only returns models from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by specific model ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - type: Filter by model type (exact match)
 * - source: Filter by model source (exact match)
 * - is_production: Filter by production status
 * - metadata: Metadata filters in JSON format {"version":"1.0"} or RSON format (version:1.0,type:detection)
 * - supported_dataset_id: Filter models trained on datasets with same classes as this dataset
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const useListModelsApiV1ModelsCatalogGet = <
  TData = Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
>(
  variables: ListModelsApiV1ModelsCatalogGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
      ListModelsApiV1ModelsCatalogGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ClustplorerClustplorerModelsModelsCatalogListModelsResponse,
    ListModelsApiV1ModelsCatalogGetError,
    TData
  >({
    ...listModelsApiV1ModelsCatalogGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostPathParams =
  {
    /**
     * @format uuid
     */
    modelId: string;
  };

export type ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostVariables =
  {
    pathParams: ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Export model results as a downloadable zip archive.
 *
 * This endpoint supports multiple execution modes for handling large exports (20-30GiB+):
 * 1. Ray: Distributed processing when Ray is available (preferred)
 * 2. Argo: Kubernetes workflow when Argo is available (fallback)
 * 3. BackgroundTasks: FastAPI background tasks (local development)
 *
 * The execution mode is automatically selected based on environment.
 */
export const fetchModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPost =
  (
    variables: ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.ExportTask,
      ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostError,
      undefined,
      {},
      {},
      ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostPathParams
    >({
      url: "/api/v1/models_catalog/models/{modelId}/export",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Export model results as a downloadable zip archive.
 *
 * This endpoint supports multiple execution modes for handling large exports (20-30GiB+):
 * 1. Ray: Distributed processing when Ray is available (preferred)
 * 2. Argo: Kubernetes workflow when Argo is available (fallback)
 * 3. BackgroundTasks: FastAPI background tasks (local development)
 *
 * The execution mode is automatically selected based on environment.
 */
export const useModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.ExportTask,
        ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostError,
        ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.ExportTask,
      ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostError,
      ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostVariables
    >({
      mutationFn: (
        variables: ModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPostVariables,
      ) =>
        fetchModelsCatalogExportPostApiV1ModelsCatalogModelsModelIdExportPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type CreateValidationApiV1ModelValidationPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CreateValidationApiV1ModelValidationPostVariables = {
  body: Schemas.CreateValidationRequest;
} & VlContext["fetcherOptions"];

/**
 * Trigger a new model validation task.
 *
 * Creates a validation task and triggers the validation pipeline.
 * Returns 202 Accepted with the task_id for async processing.
 *
 * Requires ENRICH access to the dataset (editor/owner).
 */
export const fetchCreateValidationApiV1ModelValidationPost = (
  variables: CreateValidationApiV1ModelValidationPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    CreateValidationApiV1ModelValidationPostError,
    Schemas.CreateValidationRequest,
    {},
    {},
    {}
  >({ url: "/api/v1/model-validation", method: "post", ...variables, signal });

/**
 * Trigger a new model validation task.
 *
 * Creates a validation task and triggers the validation pipeline.
 * Returns 202 Accepted with the task_id for async processing.
 *
 * Requires ENRICH access to the dataset (editor/owner).
 */
export const useCreateValidationApiV1ModelValidationPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      CreateValidationApiV1ModelValidationPostError,
      CreateValidationApiV1ModelValidationPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    CreateValidationApiV1ModelValidationPostError,
    CreateValidationApiV1ModelValidationPostVariables
  >({
    mutationFn: (
      variables: CreateValidationApiV1ModelValidationPostVariables,
    ) =>
      fetchCreateValidationApiV1ModelValidationPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetValidationTasksApiV1ModelValidationTasksGetQueryParams = {
  dataset_id?: string | null;
  model_id?: string | null;
};

export type GetValidationTasksApiV1ModelValidationTasksGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetValidationTasksApiV1ModelValidationTasksGetVariables = {
  queryParams?: GetValidationTasksApiV1ModelValidationTasksGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Get validation tasks for the current user.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by model
 */
export const fetchGetValidationTasksApiV1ModelValidationTasksGet = (
  variables: GetValidationTasksApiV1ModelValidationTasksGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.GetValidationTasksResponse,
    GetValidationTasksApiV1ModelValidationTasksGetError,
    undefined,
    {},
    GetValidationTasksApiV1ModelValidationTasksGetQueryParams,
    {}
  >({
    url: "/api/v1/model-validation/tasks",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get validation tasks for the current user.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by model
 */
export function getValidationTasksApiV1ModelValidationTasksGetQuery(
  variables: GetValidationTasksApiV1ModelValidationTasksGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetValidationTasksResponse>;
};

export function getValidationTasksApiV1ModelValidationTasksGetQuery(
  variables:
    | GetValidationTasksApiV1ModelValidationTasksGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.GetValidationTasksResponse>)
    | reactQuery.SkipToken;
};

export function getValidationTasksApiV1ModelValidationTasksGetQuery(
  variables:
    | GetValidationTasksApiV1ModelValidationTasksGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/model-validation/tasks",
      operationId: "getValidationTasksApiV1ModelValidationTasksGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetValidationTasksApiV1ModelValidationTasksGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get validation tasks for the current user.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by model
 */
export const useSuspenseGetValidationTasksApiV1ModelValidationTasksGet = <
  TData = Schemas.GetValidationTasksResponse,
>(
  variables: GetValidationTasksApiV1ModelValidationTasksGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetValidationTasksResponse,
      GetValidationTasksApiV1ModelValidationTasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetValidationTasksResponse,
    GetValidationTasksApiV1ModelValidationTasksGetError,
    TData
  >({
    ...getValidationTasksApiV1ModelValidationTasksGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get validation tasks for the current user.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by model
 */
export const useGetValidationTasksApiV1ModelValidationTasksGet = <
  TData = Schemas.GetValidationTasksResponse,
>(
  variables:
    | GetValidationTasksApiV1ModelValidationTasksGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetValidationTasksResponse,
      GetValidationTasksApiV1ModelValidationTasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.GetValidationTasksResponse,
    GetValidationTasksApiV1ModelValidationTasksGetError,
    TData
  >({
    ...getValidationTasksApiV1ModelValidationTasksGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetValidationTaskApiV1ModelValidationTasksTaskIdGetPathParams = {
  /**
   * @format uuid
   */
  taskId: string;
};

export type GetValidationTaskApiV1ModelValidationTasksTaskIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables = {
  pathParams: GetValidationTaskApiV1ModelValidationTasksTaskIdGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get a single validation task by ID.
 */
export const fetchGetValidationTaskApiV1ModelValidationTasksTaskIdGet = (
  variables: GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ValidationTaskResponse,
    GetValidationTaskApiV1ModelValidationTasksTaskIdGetError,
    undefined,
    {},
    {},
    GetValidationTaskApiV1ModelValidationTasksTaskIdGetPathParams
  >({
    url: "/api/v1/model-validation/tasks/{taskId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get a single validation task by ID.
 */
export function getValidationTaskApiV1ModelValidationTasksTaskIdGetQuery(
  variables: GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ValidationTaskResponse>;
};

export function getValidationTaskApiV1ModelValidationTasksTaskIdGetQuery(
  variables:
    | GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ValidationTaskResponse>)
    | reactQuery.SkipToken;
};

export function getValidationTaskApiV1ModelValidationTasksTaskIdGetQuery(
  variables:
    | GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/model-validation/tasks/{taskId}",
      operationId: "getValidationTaskApiV1ModelValidationTasksTaskIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetValidationTaskApiV1ModelValidationTasksTaskIdGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get a single validation task by ID.
 */
export const useSuspenseGetValidationTaskApiV1ModelValidationTasksTaskIdGet = <
  TData = Schemas.ValidationTaskResponse,
>(
  variables: GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ValidationTaskResponse,
      GetValidationTaskApiV1ModelValidationTasksTaskIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ValidationTaskResponse,
    GetValidationTaskApiV1ModelValidationTasksTaskIdGetError,
    TData
  >({
    ...getValidationTaskApiV1ModelValidationTasksTaskIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get a single validation task by ID.
 */
export const useGetValidationTaskApiV1ModelValidationTasksTaskIdGet = <
  TData = Schemas.ValidationTaskResponse,
>(
  variables:
    | GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ValidationTaskResponse,
      GetValidationTaskApiV1ModelValidationTasksTaskIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ValidationTaskResponse,
    GetValidationTaskApiV1ModelValidationTasksTaskIdGetError,
    TData
  >({
    ...getValidationTaskApiV1ModelValidationTasksTaskIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchPathParams =
  {
    /**
     * @format uuid
     */
    taskId: string;
  };

export type ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchQueryParams =
  {
    /**
     * @default CANCEL
     */
    action?: string;
  };

export type ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchVariables =
  {
    pathParams: ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchPathParams;
    queryParams?: ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Perform an action on a validation task.
 *
 * Query parameters:
 * - action: Action to perform (CANCEL)
 */
export const fetchValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatch =
  (
    variables: ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.ValidationTaskResponse,
      ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchError,
      undefined,
      {},
      ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchQueryParams,
      ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchPathParams
    >({
      url: "/api/v1/model-validation/tasks/{taskId}",
      method: "patch",
      ...variables,
      signal,
    });

/**
 * Perform an action on a validation task.
 *
 * Query parameters:
 * - action: Action to perform (CANCEL)
 */
export const useValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatch =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.ValidationTaskResponse,
        ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchError,
        ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.ValidationTaskResponse,
      ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchError,
      ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchVariables
    >({
      mutationFn: (
        variables: ValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatchVariables,
      ) =>
        fetchValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatch(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError =
  Fetcher.ErrorWrapper<undefined>;

export type GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables =
  VlContext["fetcherOptions"];

/**
 * Get available filter options for validations catalog.
 */
export const fetchGetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet =
  (
    variables: GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.ValidationCatalogFilterOptionsResponse,
      GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError,
      undefined,
      {},
      {},
      {}
    >({
      url: "/api/v1/models_catalog/validations/filters",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Get available filter options for validations catalog.
 */
export function getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetQuery(
  variables: GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ValidationCatalogFilterOptionsResponse>;
};

export function getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetQuery(
  variables:
    | GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.ValidationCatalogFilterOptionsResponse>)
    | reactQuery.SkipToken;
};

export function getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetQuery(
  variables:
    | GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog/validations/filters",
      operationId:
        "getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get available filter options for validations catalog.
 */
export const useSuspenseGetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet =
  <TData = Schemas.ValidationCatalogFilterOptionsResponse>(
    variables: GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.ValidationCatalogFilterOptionsResponse,
        GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.ValidationCatalogFilterOptionsResponse,
      GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError,
      TData
    >({
      ...getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get available filter options for validations catalog.
 */
export const useGetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet =
  <TData = Schemas.ValidationCatalogFilterOptionsResponse>(
    variables:
      | GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.ValidationCatalogFilterOptionsResponse,
        GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      Schemas.ValidationCatalogFilterOptionsResponse,
      GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetError,
      TData
    >({
      ...getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type GetValidationApiV1ModelsCatalogValidationsValidationIdGetPathParams =
  {
    /**
     * @format uuid
     */
    validationId: string;
  };

export type GetValidationApiV1ModelsCatalogValidationsValidationIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables =
  {
    pathParams: GetValidationApiV1ModelsCatalogValidationsValidationIdGetPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Get a single validation by ID.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access to the dataset.
 */
export const fetchGetValidationApiV1ModelsCatalogValidationsValidationIdGet = (
  variables: GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ValidationCatalog,
    GetValidationApiV1ModelsCatalogValidationsValidationIdGetError,
    undefined,
    {},
    {},
    GetValidationApiV1ModelsCatalogValidationsValidationIdGetPathParams
  >({
    url: "/api/v1/models_catalog/validations/{validationId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get a single validation by ID.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access to the dataset.
 */
export function getValidationApiV1ModelsCatalogValidationsValidationIdGetQuery(
  variables: GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ValidationCatalog>;
};

export function getValidationApiV1ModelsCatalogValidationsValidationIdGetQuery(
  variables:
    | GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ValidationCatalog>)
    | reactQuery.SkipToken;
};

export function getValidationApiV1ModelsCatalogValidationsValidationIdGetQuery(
  variables:
    | GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog/validations/{validationId}",
      operationId: "getValidationApiV1ModelsCatalogValidationsValidationIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetValidationApiV1ModelsCatalogValidationsValidationIdGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get a single validation by ID.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access to the dataset.
 */
export const useSuspenseGetValidationApiV1ModelsCatalogValidationsValidationIdGet =
  <TData = Schemas.ValidationCatalog>(
    variables: GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.ValidationCatalog,
        GetValidationApiV1ModelsCatalogValidationsValidationIdGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.ValidationCatalog,
      GetValidationApiV1ModelsCatalogValidationsValidationIdGetError,
      TData
    >({
      ...getValidationApiV1ModelsCatalogValidationsValidationIdGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get a single validation by ID.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access to the dataset.
 */
export const useGetValidationApiV1ModelsCatalogValidationsValidationIdGet = <
  TData = Schemas.ValidationCatalog,
>(
  variables:
    | GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ValidationCatalog,
      GetValidationApiV1ModelsCatalogValidationsValidationIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ValidationCatalog,
    GetValidationApiV1ModelsCatalogValidationsValidationIdGetError,
    TData
  >({
    ...getValidationApiV1ModelsCatalogValidationsValidationIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    validationId: string;
  };

export type DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteVariables =
  {
    pathParams: DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeletePathParams;
  } & VlContext["fetcherOptions"];

/**
 * Delete a validation.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access.
 */
export const fetchDeleteValidationApiV1ModelsCatalogValidationsValidationIdDelete =
  (
    variables: DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteError,
      undefined,
      {},
      {},
      DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeletePathParams
    >({
      url: "/api/v1/models_catalog/validations/{validationId}",
      method: "delete",
      ...variables,
      signal,
    });

/**
 * Delete a validation.
 *
 * Returns 404 if validation doesn't exist or user doesn't have access.
 */
export const useDeleteValidationApiV1ModelsCatalogValidationsValidationIdDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteError,
        DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteError,
      DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteVariables
    >({
      mutationFn: (
        variables: DeleteValidationApiV1ModelsCatalogValidationsValidationIdDeleteVariables,
      ) =>
        fetchDeleteValidationApiV1ModelsCatalogValidationsValidationIdDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ListValidationsApiV1ModelsCatalogValidationsGetQueryParams = {
  dataset_id?: string | null;
  model_id?: string | null;
  validation_id?: string | null;
  model_name?: string | null;
  dataset_name?: string | null;
  source?: string | null;
  gt_source?: string | null;
  metadata?: string | null;
  job_name?: string | string[] | null;
  setup_name?: string | string[] | null;
  recipes?: string[] | null;
  tool_list?: string[] | null;
  page?: number | null;
  page_size?: number | null;
  /**
   * Field to sort by
   */
  sort_by?: Schemas.ModelCatalogSortField | null;
  sort_order?: Schemas.SortOrder;
};

export type ListValidationsApiV1ModelsCatalogValidationsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ListValidationsApiV1ModelsCatalogValidationsGetVariables = {
  queryParams?: ListValidationsApiV1ModelsCatalogValidationsGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * List validations with optional filters.
 *
 * Only returns validations from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by parent model ID (the trained model being validated)
 * - validation_id: Filter by specific validation ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - source: Filter by model source (exact match)
 * - gt_source: Filter by ground truth source (LP, USER, NONE)
 * - metadata: Metadata filters in JSON or RSON format
 * - job_name: Filter by dataset's camtek Job Name
 * - setup_name: Filter by dataset's camtek Setup Name
 * - recipes: Filter by dataset's camtek Recipes Name
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const fetchListValidationsApiV1ModelsCatalogValidationsGet = (
  variables: ListValidationsApiV1ModelsCatalogValidationsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListValidationsResponse,
    ListValidationsApiV1ModelsCatalogValidationsGetError,
    undefined,
    {},
    ListValidationsApiV1ModelsCatalogValidationsGetQueryParams,
    {}
  >({
    url: "/api/v1/models_catalog/validations",
    method: "get",
    ...variables,
    signal,
  });

/**
 * List validations with optional filters.
 *
 * Only returns validations from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by parent model ID (the trained model being validated)
 * - validation_id: Filter by specific validation ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - source: Filter by model source (exact match)
 * - gt_source: Filter by ground truth source (LP, USER, NONE)
 * - metadata: Metadata filters in JSON or RSON format
 * - job_name: Filter by dataset's camtek Job Name
 * - setup_name: Filter by dataset's camtek Setup Name
 * - recipes: Filter by dataset's camtek Recipes Name
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export function listValidationsApiV1ModelsCatalogValidationsGetQuery(
  variables: ListValidationsApiV1ModelsCatalogValidationsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ListValidationsResponse>;
};

export function listValidationsApiV1ModelsCatalogValidationsGetQuery(
  variables:
    | ListValidationsApiV1ModelsCatalogValidationsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListValidationsResponse>)
    | reactQuery.SkipToken;
};

export function listValidationsApiV1ModelsCatalogValidationsGetQuery(
  variables:
    | ListValidationsApiV1ModelsCatalogValidationsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/models_catalog/validations",
      operationId: "listValidationsApiV1ModelsCatalogValidationsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListValidationsApiV1ModelsCatalogValidationsGet(
              variables,
              signal,
            ),
  };
}

/**
 * List validations with optional filters.
 *
 * Only returns validations from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by parent model ID (the trained model being validated)
 * - validation_id: Filter by specific validation ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - source: Filter by model source (exact match)
 * - gt_source: Filter by ground truth source (LP, USER, NONE)
 * - metadata: Metadata filters in JSON or RSON format
 * - job_name: Filter by dataset's camtek Job Name
 * - setup_name: Filter by dataset's camtek Setup Name
 * - recipes: Filter by dataset's camtek Recipes Name
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const useSuspenseListValidationsApiV1ModelsCatalogValidationsGet = <
  TData = Schemas.ListValidationsResponse,
>(
  variables: ListValidationsApiV1ModelsCatalogValidationsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListValidationsResponse,
      ListValidationsApiV1ModelsCatalogValidationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListValidationsResponse,
    ListValidationsApiV1ModelsCatalogValidationsGetError,
    TData
  >({
    ...listValidationsApiV1ModelsCatalogValidationsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List validations with optional filters.
 *
 * Only returns validations from datasets the user has READ access to.
 *
 * Query parameters:
 * - dataset_id: Filter by dataset
 * - model_id: Filter by parent model ID (the trained model being validated)
 * - validation_id: Filter by specific validation ID
 * - model_name: Filter by model name (case-insensitive partial match)
 * - dataset_name: Filter by dataset name (case-insensitive partial match)
 * - source: Filter by model source (exact match)
 * - gt_source: Filter by ground truth source (LP, USER, NONE)
 * - metadata: Metadata filters in JSON or RSON format
 * - job_name: Filter by dataset's camtek Job Name
 * - setup_name: Filter by dataset's camtek Setup Name
 * - recipes: Filter by dataset's camtek Recipes Name
 * - tool_list: Filter by dataset's Tool List metadata (overlap match)
 * - page: Page number (1-indexed, enables pagination)
 * - page_size: Number of results per page (used with page, max 100)
 * - sort_by: Field to sort by (model_name, last_updated, created_at, dataset_name, type, is_production)
 * - sort_order: Sort direction (asc or desc, default desc)
 */
export const useListValidationsApiV1ModelsCatalogValidationsGet = <
  TData = Schemas.ListValidationsResponse,
>(
  variables:
    | ListValidationsApiV1ModelsCatalogValidationsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListValidationsResponse,
      ListValidationsApiV1ModelsCatalogValidationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListValidationsResponse,
    ListValidationsApiV1ModelsCatalogValidationsGetError,
    TData
  >({
    ...listValidationsApiV1ModelsCatalogValidationsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListUsersApiV1KeycloakAdminUsersGetQueryParams = {
  /**
   * Search by username or name
   */
  search?: string | null;
  /**
   * Maximum number of results
   *
   * @maximum 1000
   * @minimum 1
   * @default 100
   */
  max_results?: number;
  /**
   * Offset for pagination
   *
   * @minimum 0
   * @default 0
   */
  first?: number;
};

export type ListUsersApiV1KeycloakAdminUsersGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListUsersApiV1KeycloakAdminUsersGetVariables = {
  queryParams?: ListUsersApiV1KeycloakAdminUsersGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * List Keycloak users.
 *
 * Requires realm-management view-users role.
 */
export const fetchListUsersApiV1KeycloakAdminUsersGet = (
  variables: ListUsersApiV1KeycloakAdminUsersGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListUsersResponse,
    ListUsersApiV1KeycloakAdminUsersGetError,
    undefined,
    {},
    ListUsersApiV1KeycloakAdminUsersGetQueryParams,
    {}
  >({
    url: "/api/v1/keycloak/admin/users",
    method: "get",
    ...variables,
    signal,
  });

/**
 * List Keycloak users.
 *
 * Requires realm-management view-users role.
 */
export function listUsersApiV1KeycloakAdminUsersGetQuery(
  variables: ListUsersApiV1KeycloakAdminUsersGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListUsersResponse>;
};

export function listUsersApiV1KeycloakAdminUsersGetQuery(
  variables:
    | ListUsersApiV1KeycloakAdminUsersGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListUsersResponse>)
    | reactQuery.SkipToken;
};

export function listUsersApiV1KeycloakAdminUsersGetQuery(
  variables:
    | ListUsersApiV1KeycloakAdminUsersGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/keycloak/admin/users",
      operationId: "listUsersApiV1KeycloakAdminUsersGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListUsersApiV1KeycloakAdminUsersGet(variables, signal),
  };
}

/**
 * List Keycloak users.
 *
 * Requires realm-management view-users role.
 */
export const useSuspenseListUsersApiV1KeycloakAdminUsersGet = <
  TData = Schemas.ListUsersResponse,
>(
  variables: ListUsersApiV1KeycloakAdminUsersGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListUsersResponse,
      ListUsersApiV1KeycloakAdminUsersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListUsersResponse,
    ListUsersApiV1KeycloakAdminUsersGetError,
    TData
  >({
    ...listUsersApiV1KeycloakAdminUsersGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List Keycloak users.
 *
 * Requires realm-management view-users role.
 */
export const useListUsersApiV1KeycloakAdminUsersGet = <
  TData = Schemas.ListUsersResponse,
>(
  variables:
    | ListUsersApiV1KeycloakAdminUsersGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListUsersResponse,
      ListUsersApiV1KeycloakAdminUsersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListUsersResponse,
    ListUsersApiV1KeycloakAdminUsersGetError,
    TData
  >({
    ...listUsersApiV1KeycloakAdminUsersGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type CreateUserApiV1KeycloakAdminUsersPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateUserApiV1KeycloakAdminUsersPostVariables = {
  body: Schemas.CreateUserRequest;
} & VlContext["fetcherOptions"];

/**
 * Create a new Keycloak user.
 *
 * Atomically creates user in Keycloak and Visual Layer's database.
 * If PG shadow user creation fails, Keycloak user is compensated (deleted).
 * Uses service account token for Keycloak Admin API operations to avoid issuer mismatch issues.
 */
export const fetchCreateUserApiV1KeycloakAdminUsersPost = (
  variables: CreateUserApiV1KeycloakAdminUsersPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.KeycloakUser,
    CreateUserApiV1KeycloakAdminUsersPostError,
    Schemas.CreateUserRequest,
    {},
    {},
    {}
  >({
    url: "/api/v1/keycloak/admin/users",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a new Keycloak user.
 *
 * Atomically creates user in Keycloak and Visual Layer's database.
 * If PG shadow user creation fails, Keycloak user is compensated (deleted).
 * Uses service account token for Keycloak Admin API operations to avoid issuer mismatch issues.
 */
export const useCreateUserApiV1KeycloakAdminUsersPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.KeycloakUser,
      CreateUserApiV1KeycloakAdminUsersPostError,
      CreateUserApiV1KeycloakAdminUsersPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.KeycloakUser,
    CreateUserApiV1KeycloakAdminUsersPostError,
    CreateUserApiV1KeycloakAdminUsersPostVariables
  >({
    mutationFn: (variables: CreateUserApiV1KeycloakAdminUsersPostVariables) =>
      fetchCreateUserApiV1KeycloakAdminUsersPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetUserApiV1KeycloakAdminUsersUserIdGetPathParams = {
  /**
   * Keycloak user ID or VL user ID
   */
  userId: string;
};

export type GetUserApiV1KeycloakAdminUsersUserIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetUserApiV1KeycloakAdminUsersUserIdGetVariables = {
  pathParams: GetUserApiV1KeycloakAdminUsersUserIdGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get a single Keycloak user by ID.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const fetchGetUserApiV1KeycloakAdminUsersUserIdGet = (
  variables: GetUserApiV1KeycloakAdminUsersUserIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.KeycloakUser,
    GetUserApiV1KeycloakAdminUsersUserIdGetError,
    undefined,
    {},
    {},
    GetUserApiV1KeycloakAdminUsersUserIdGetPathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get a single Keycloak user by ID.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export function getUserApiV1KeycloakAdminUsersUserIdGetQuery(
  variables: GetUserApiV1KeycloakAdminUsersUserIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.KeycloakUser>;
};

export function getUserApiV1KeycloakAdminUsersUserIdGetQuery(
  variables:
    | GetUserApiV1KeycloakAdminUsersUserIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.KeycloakUser>)
    | reactQuery.SkipToken;
};

export function getUserApiV1KeycloakAdminUsersUserIdGetQuery(
  variables:
    | GetUserApiV1KeycloakAdminUsersUserIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/keycloak/admin/users/{userId}",
      operationId: "getUserApiV1KeycloakAdminUsersUserIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUserApiV1KeycloakAdminUsersUserIdGet(variables, signal),
  };
}

/**
 * Get a single Keycloak user by ID.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const useSuspenseGetUserApiV1KeycloakAdminUsersUserIdGet = <
  TData = Schemas.KeycloakUser,
>(
  variables: GetUserApiV1KeycloakAdminUsersUserIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.KeycloakUser,
      GetUserApiV1KeycloakAdminUsersUserIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.KeycloakUser,
    GetUserApiV1KeycloakAdminUsersUserIdGetError,
    TData
  >({
    ...getUserApiV1KeycloakAdminUsersUserIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get a single Keycloak user by ID.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const useGetUserApiV1KeycloakAdminUsersUserIdGet = <
  TData = Schemas.KeycloakUser,
>(
  variables:
    | GetUserApiV1KeycloakAdminUsersUserIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.KeycloakUser,
      GetUserApiV1KeycloakAdminUsersUserIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.KeycloakUser,
    GetUserApiV1KeycloakAdminUsersUserIdGetError,
    TData
  >({
    ...getUserApiV1KeycloakAdminUsersUserIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateUserApiV1KeycloakAdminUsersUserIdPatchPathParams = {
  /**
   * Keycloak user ID or VL user ID
   */
  userId: string;
};

export type UpdateUserApiV1KeycloakAdminUsersUserIdPatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateUserApiV1KeycloakAdminUsersUserIdPatchVariables = {
  body?: Schemas.UpdateUserRequest;
  pathParams: UpdateUserApiV1KeycloakAdminUsersUserIdPatchPathParams;
} & VlContext["fetcherOptions"];

/**
 * Update a Keycloak user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Uses service account token for Keycloak Admin API operations.
 */
export const fetchUpdateUserApiV1KeycloakAdminUsersUserIdPatch = (
  variables: UpdateUserApiV1KeycloakAdminUsersUserIdPatchVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.KeycloakUser,
    UpdateUserApiV1KeycloakAdminUsersUserIdPatchError,
    Schemas.UpdateUserRequest,
    {},
    {},
    UpdateUserApiV1KeycloakAdminUsersUserIdPatchPathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update a Keycloak user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Uses service account token for Keycloak Admin API operations.
 */
export const useUpdateUserApiV1KeycloakAdminUsersUserIdPatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.KeycloakUser,
      UpdateUserApiV1KeycloakAdminUsersUserIdPatchError,
      UpdateUserApiV1KeycloakAdminUsersUserIdPatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.KeycloakUser,
    UpdateUserApiV1KeycloakAdminUsersUserIdPatchError,
    UpdateUserApiV1KeycloakAdminUsersUserIdPatchVariables
  >({
    mutationFn: (
      variables: UpdateUserApiV1KeycloakAdminUsersUserIdPatchVariables,
    ) =>
      fetchUpdateUserApiV1KeycloakAdminUsersUserIdPatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DeleteUserApiV1KeycloakAdminUsersUserIdDeletePathParams = {
  /**
   * Keycloak user ID or VL user ID
   */
  userId: string;
};

export type DeleteUserApiV1KeycloakAdminUsersUserIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteUserApiV1KeycloakAdminUsersUserIdDeleteVariables = {
  pathParams: DeleteUserApiV1KeycloakAdminUsersUserIdDeletePathParams;
} & VlContext["fetcherOptions"];

/**
 * Delete a Keycloak user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * If a VL user ID is provided, it will be resolved to the Keycloak user ID.
 *
 * Atomically handles: dataset ownership transfer (per-workspace with OpenFGA sync),
 * workspace tuple cleanup, Keycloak deletion, and PG shadow user deletion.
 * If dataset ownership transfer fails, the user is NOT deleted.
 *
 * Uses service account token for Keycloak Admin API operations.
 */
export const fetchDeleteUserApiV1KeycloakAdminUsersUserIdDelete = (
  variables: DeleteUserApiV1KeycloakAdminUsersUserIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.MessageResponse,
    DeleteUserApiV1KeycloakAdminUsersUserIdDeleteError,
    undefined,
    {},
    {},
    DeleteUserApiV1KeycloakAdminUsersUserIdDeletePathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a Keycloak user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * If a VL user ID is provided, it will be resolved to the Keycloak user ID.
 *
 * Atomically handles: dataset ownership transfer (per-workspace with OpenFGA sync),
 * workspace tuple cleanup, Keycloak deletion, and PG shadow user deletion.
 * If dataset ownership transfer fails, the user is NOT deleted.
 *
 * Uses service account token for Keycloak Admin API operations.
 */
export const useDeleteUserApiV1KeycloakAdminUsersUserIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      DeleteUserApiV1KeycloakAdminUsersUserIdDeleteError,
      DeleteUserApiV1KeycloakAdminUsersUserIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    DeleteUserApiV1KeycloakAdminUsersUserIdDeleteError,
    DeleteUserApiV1KeycloakAdminUsersUserIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteUserApiV1KeycloakAdminUsersUserIdDeleteVariables,
    ) =>
      fetchDeleteUserApiV1KeycloakAdminUsersUserIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostPathParams =
  {
    /**
     * Keycloak user ID or VL user ID
     */
    userId: string;
  };

export type ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostVariables =
  {
    body: Schemas.ResetPasswordRequest;
    pathParams: ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Reset a user's password.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * If a VL user ID is provided, it will be resolved to the Keycloak user ID.
 *
 * Uses service account token for Keycloak Admin API operations.
 */
export const fetchResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPost =
  (
    variables: ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.MessageResponse,
      ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostError,
      Schemas.ResetPasswordRequest,
      {},
      {},
      ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostPathParams
    >({
      url: "/api/v1/keycloak/admin/users/{userId}/reset-password",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Reset a user's password.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * If a VL user ID is provided, it will be resolved to the Keycloak user ID.
 *
 * Uses service account token for Keycloak Admin API operations.
 */
export const useResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostError,
      ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostError,
    ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostVariables
  >({
    mutationFn: (
      variables: ResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPostVariables,
    ) =>
      fetchResetPasswordApiV1KeycloakAdminUsersUserIdResetPasswordPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostPathParams = {
  /**
   * Keycloak user ID or VL user ID
   */
  userId: string;
};

export type LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostVariables = {
  pathParams: LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Logout a user by terminating all their Keycloak sessions.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * This revokes all active sessions and tokens for the user.
 * Uses service account token for Keycloak Admin API operations.
 */
export const fetchLogoutUserApiV1KeycloakAdminUsersUserIdLogoutPost = (
  variables: LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.MessageResponse,
    LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostError,
    undefined,
    {},
    {},
    LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostPathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}/logout",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Logout a user by terminating all their Keycloak sessions.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * This revokes all active sessions and tokens for the user.
 * Uses service account token for Keycloak Admin API operations.
 */
export const useLogoutUserApiV1KeycloakAdminUsersUserIdLogoutPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostError,
      LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostError,
    LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostVariables
  >({
    mutationFn: (
      variables: LogoutUserApiV1KeycloakAdminUsersUserIdLogoutPostVariables,
    ) =>
      fetchLogoutUserApiV1KeycloakAdminUsersUserIdLogoutPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetPathParams =
  {
    /**
     * Keycloak user ID or VL user ID
     */
    userId: string;
  };

export type GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables = {
  pathParams: GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get active sessions for a user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const fetchGetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet = (
  variables: GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListSessionsResponse,
    GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError,
    undefined,
    {},
    {},
    GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetPathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}/sessions",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get active sessions for a user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export function getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetQuery(
  variables: GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListSessionsResponse>;
};

export function getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetQuery(
  variables:
    | GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListSessionsResponse>)
    | reactQuery.SkipToken;
};

export function getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetQuery(
  variables:
    | GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/keycloak/admin/users/{userId}/sessions",
      operationId: "getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get active sessions for a user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const useSuspenseGetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet =
  <TData = Schemas.ListSessionsResponse>(
    variables: GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.ListSessionsResponse,
        GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.ListSessionsResponse,
      GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError,
      TData
    >({
      ...getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get active sessions for a user.
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Requires realm-management view-users role.
 */
export const useGetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet = <
  TData = Schemas.ListSessionsResponse,
>(
  variables:
    | GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListSessionsResponse,
      GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListSessionsResponse,
    GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetError,
    TData
  >({
    ...getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutPathParams = {
  /**
   * Keycloak user ID or VL user ID
   */
  userId: string;
};

export type UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutVariables = {
  body: Schemas.UpdateRolesRequest;
  pathParams: UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutPathParams;
} & VlContext["fetcherOptions"];

/**
 * Update a user's realm roles (replaces all existing roles).
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Uses service account token for Keycloak Admin API operations.
 */
export const fetchUpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPut = (
  variables: UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.KeycloakUser,
    UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutError,
    Schemas.UpdateRolesRequest,
    {},
    {},
    UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutPathParams
  >({
    url: "/api/v1/keycloak/admin/users/{userId}/roles",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update a user's realm roles (replaces all existing roles).
 *
 * Accepts either a Keycloak user ID or a VL database user ID.
 * Uses service account token for Keycloak Admin API operations.
 */
export const useUpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.KeycloakUser,
      UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutError,
      UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.KeycloakUser,
    UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutError,
    UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutVariables
  >({
    mutationFn: (
      variables: UpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPutVariables,
    ) =>
      fetchUpdateUserRolesApiV1KeycloakAdminUsersUserIdRolesPut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetSettingApiV1AdminSettingsGetQueryParams = {
  key: string;
};

export type GetSettingApiV1AdminSettingsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetSettingApiV1AdminSettingsGetResponse = {
  [key: string]: any;
};

export type GetSettingApiV1AdminSettingsGetVariables = {
  queryParams: GetSettingApiV1AdminSettingsGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Get current value of a system setting.
 * Returns the current value from the database, or the default from Settings if not set.
 */
export const fetchGetSettingApiV1AdminSettingsGet = (
  variables: GetSettingApiV1AdminSettingsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetSettingApiV1AdminSettingsGetResponse,
    GetSettingApiV1AdminSettingsGetError,
    undefined,
    {},
    GetSettingApiV1AdminSettingsGetQueryParams,
    {}
  >({ url: "/api/v1/admin/settings", method: "get", ...variables, signal });

/**
 * Get current value of a system setting.
 * Returns the current value from the database, or the default from Settings if not set.
 */
export function getSettingApiV1AdminSettingsGetQuery(
  variables: GetSettingApiV1AdminSettingsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetSettingApiV1AdminSettingsGetResponse>;
};

export function getSettingApiV1AdminSettingsGetQuery(
  variables: GetSettingApiV1AdminSettingsGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetSettingApiV1AdminSettingsGetResponse>)
    | reactQuery.SkipToken;
};

export function getSettingApiV1AdminSettingsGetQuery(
  variables: GetSettingApiV1AdminSettingsGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/admin/settings",
      operationId: "getSettingApiV1AdminSettingsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetSettingApiV1AdminSettingsGet(variables, signal),
  };
}

/**
 * Get current value of a system setting.
 * Returns the current value from the database, or the default from Settings if not set.
 */
export const useSuspenseGetSettingApiV1AdminSettingsGet = <
  TData = GetSettingApiV1AdminSettingsGetResponse,
>(
  variables: GetSettingApiV1AdminSettingsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSettingApiV1AdminSettingsGetResponse,
      GetSettingApiV1AdminSettingsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    GetSettingApiV1AdminSettingsGetResponse,
    GetSettingApiV1AdminSettingsGetError,
    TData
  >({
    ...getSettingApiV1AdminSettingsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get current value of a system setting.
 * Returns the current value from the database, or the default from Settings if not set.
 */
export const useGetSettingApiV1AdminSettingsGet = <
  TData = GetSettingApiV1AdminSettingsGetResponse,
>(
  variables: GetSettingApiV1AdminSettingsGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSettingApiV1AdminSettingsGetResponse,
      GetSettingApiV1AdminSettingsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetSettingApiV1AdminSettingsGetResponse,
    GetSettingApiV1AdminSettingsGetError,
    TData
  >({
    ...getSettingApiV1AdminSettingsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateSettingApiV1AdminSettingsPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateSettingApiV1AdminSettingsPostResponse = {
  [key: string]: any;
};

export type UpdateSettingApiV1AdminSettingsPostVariables = {
  body: Schemas.UpdateSettingRequest;
} & VlContext["fetcherOptions"];

/**
 * Update a system setting.
 */
export const fetchUpdateSettingApiV1AdminSettingsPost = (
  variables: UpdateSettingApiV1AdminSettingsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    UpdateSettingApiV1AdminSettingsPostResponse,
    UpdateSettingApiV1AdminSettingsPostError,
    Schemas.UpdateSettingRequest,
    {},
    {},
    {}
  >({ url: "/api/v1/admin/settings", method: "post", ...variables, signal });

/**
 * Update a system setting.
 */
export const useUpdateSettingApiV1AdminSettingsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateSettingApiV1AdminSettingsPostResponse,
      UpdateSettingApiV1AdminSettingsPostError,
      UpdateSettingApiV1AdminSettingsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    UpdateSettingApiV1AdminSettingsPostResponse,
    UpdateSettingApiV1AdminSettingsPostError,
    UpdateSettingApiV1AdminSettingsPostVariables
  >({
    mutationFn: (variables: UpdateSettingApiV1AdminSettingsPostVariables) =>
      fetchUpdateSettingApiV1AdminSettingsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ListSettingsApiV1InternalRuntimeConfigSettingsGetError =
  Fetcher.ErrorWrapper<undefined>;

export type ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables =
  VlContext["fetcherOptions"];

/**
 * List all settings. Changeable settings show values; non-changeable show key only.
 */
export const fetchListSettingsApiV1InternalRuntimeConfigSettingsGet = (
  variables: ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListSettingsResponse,
    ListSettingsApiV1InternalRuntimeConfigSettingsGetError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v1/internal/runtime-config/settings",
    method: "get",
    ...variables,
    signal,
  });

/**
 * List all settings. Changeable settings show values; non-changeable show key only.
 */
export function listSettingsApiV1InternalRuntimeConfigSettingsGetQuery(
  variables: ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListSettingsResponse>;
};

export function listSettingsApiV1InternalRuntimeConfigSettingsGetQuery(
  variables:
    | ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListSettingsResponse>)
    | reactQuery.SkipToken;
};

export function listSettingsApiV1InternalRuntimeConfigSettingsGetQuery(
  variables:
    | ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/internal/runtime-config/settings",
      operationId: "listSettingsApiV1InternalRuntimeConfigSettingsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListSettingsApiV1InternalRuntimeConfigSettingsGet(
              variables,
              signal,
            ),
  };
}

/**
 * List all settings. Changeable settings show values; non-changeable show key only.
 */
export const useSuspenseListSettingsApiV1InternalRuntimeConfigSettingsGet = <
  TData = Schemas.ListSettingsResponse,
>(
  variables: ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListSettingsResponse,
      ListSettingsApiV1InternalRuntimeConfigSettingsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListSettingsResponse,
    ListSettingsApiV1InternalRuntimeConfigSettingsGetError,
    TData
  >({
    ...listSettingsApiV1InternalRuntimeConfigSettingsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List all settings. Changeable settings show values; non-changeable show key only.
 */
export const useListSettingsApiV1InternalRuntimeConfigSettingsGet = <
  TData = Schemas.ListSettingsResponse,
>(
  variables:
    | ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListSettingsResponse,
      ListSettingsApiV1InternalRuntimeConfigSettingsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListSettingsResponse,
    ListSettingsApiV1InternalRuntimeConfigSettingsGetError,
    TData
  >({
    ...listSettingsApiV1InternalRuntimeConfigSettingsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteError =
  Fetcher.ErrorWrapper<undefined>;

export type RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteVariables =
  VlContext["fetcherOptions"];

/**
 * Revert all active runtime overrides.
 */
export const fetchRevertAllOverridesApiV1InternalRuntimeConfigSettingsDelete = (
  variables: RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.RevertAllResponse,
    RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v1/internal/runtime-config/settings",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Revert all active runtime overrides.
 */
export const useRevertAllOverridesApiV1InternalRuntimeConfigSettingsDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RevertAllResponse,
      RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteError,
      RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.RevertAllResponse,
    RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteError,
    RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteVariables
  >({
    mutationFn: (
      variables: RevertAllOverridesApiV1InternalRuntimeConfigSettingsDeleteVariables,
    ) =>
      fetchRevertAllOverridesApiV1InternalRuntimeConfigSettingsDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostPathParams = {
  key: string;
};

export type ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostVariables = {
  body: Schemas.ApplyOverrideRequest;
  pathParams: ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Apply a runtime override to a single setting.
 */
export const fetchApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPost = (
  variables: ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ApplyOverrideResponse,
    ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostError,
    Schemas.ApplyOverrideRequest,
    {},
    {},
    ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostPathParams
  >({
    url: "/api/v1/internal/runtime-config/settings/{key}",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Apply a runtime override to a single setting.
 */
export const useApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplyOverrideResponse,
      ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostError,
      ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.ApplyOverrideResponse,
    ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostError,
    ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostVariables
  >({
    mutationFn: (
      variables: ApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPostVariables,
    ) =>
      fetchApplyOverrideApiV1InternalRuntimeConfigSettingsKeyPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeletePathParams =
  {
    key: string;
  };

export type RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteVariables =
  {
    pathParams: RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeletePathParams;
  } & VlContext["fetcherOptions"];

/**
 * Revert a single setting to its pre-override value.
 */
export const fetchRevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDelete =
  (
    variables: RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.RevertResponse,
      RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteError,
      undefined,
      {},
      {},
      RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeletePathParams
    >({
      url: "/api/v1/internal/runtime-config/settings/{key}",
      method: "delete",
      ...variables,
      signal,
    });

/**
 * Revert a single setting to its pre-override value.
 */
export const useRevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDelete =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.RevertResponse,
        RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteError,
        RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      Schemas.RevertResponse,
      RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteError,
      RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteVariables
    >({
      mutationFn: (
        variables: RevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDeleteVariables,
      ) =>
        fetchRevertSingleOverrideApiV1InternalRuntimeConfigSettingsKeyDelete(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type GetTasksApiV1TasksGetQueryParams = {
  /**
   * @default false
   */
  wait?: boolean;
  etag?: string | null;
  dataset_id?: string | string[] | null;
  dataset_name?: string | string[] | null;
  task_type?: Schemas.TaskType | Schemas.TaskType[] | null;
  task_status?: Schemas.TaskStatusInput | Schemas.TaskStatusInput[] | null;
  job_name?: string | string[] | null;
  setup_name?: string | string[] | null;
  recipes?: string[] | null;
  created_by?: string | string[] | null;
  start_time_from?: string | null;
  start_time_to?: string | null;
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @maximum 50
   * @minimum 5
   * @default 20
   */
  page_size?: number;
  /**
   * Field to sort by
   */
  sort_by?: Schemas.TaskSortField | null;
  sort_order?: Schemas.SortOrder;
};

export type GetTasksApiV1TasksGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetTasksApiV1TasksGetVariables = {
  queryParams?: GetTasksApiV1TasksGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetTasksApiV1TasksGet = (
  variables: GetTasksApiV1TasksGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.PaginatedTasksResponse,
    GetTasksApiV1TasksGetError,
    undefined,
    {},
    GetTasksApiV1TasksGetQueryParams,
    {}
  >({ url: "/api/v1/tasks", method: "get", ...variables, signal });

export function getTasksApiV1TasksGetQuery(
  variables: GetTasksApiV1TasksGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PaginatedTasksResponse>;
};

export function getTasksApiV1TasksGetQuery(
  variables: GetTasksApiV1TasksGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.PaginatedTasksResponse>)
    | reactQuery.SkipToken;
};

export function getTasksApiV1TasksGetQuery(
  variables: GetTasksApiV1TasksGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/tasks",
      operationId: "getTasksApiV1TasksGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetTasksApiV1TasksGet(variables, signal),
  };
}

export const useSuspenseGetTasksApiV1TasksGet = <
  TData = Schemas.PaginatedTasksResponse,
>(
  variables: GetTasksApiV1TasksGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedTasksResponse,
      GetTasksApiV1TasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.PaginatedTasksResponse,
    GetTasksApiV1TasksGetError,
    TData
  >({
    ...getTasksApiV1TasksGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useGetTasksApiV1TasksGet = <
  TData = Schemas.PaginatedTasksResponse,
>(
  variables: GetTasksApiV1TasksGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedTasksResponse,
      GetTasksApiV1TasksGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedTasksResponse,
    GetTasksApiV1TasksGetError,
    TData
  >({
    ...getTasksApiV1TasksGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetTaskFilterOptionsApiV1TasksFiltersGetQueryParams = {
  /**
   * Filter tasks from this start time
   */
  start_time_from?: string | null;
  /**
   * Filter tasks until this start time
   */
  start_time_to?: string | null;
};

export type GetTaskFilterOptionsApiV1TasksFiltersGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetTaskFilterOptionsApiV1TasksFiltersGetVariables = {
  queryParams?: GetTaskFilterOptionsApiV1TasksFiltersGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchGetTaskFilterOptionsApiV1TasksFiltersGet = (
  variables: GetTaskFilterOptionsApiV1TasksFiltersGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TaskFilterOptionsResponse,
    GetTaskFilterOptionsApiV1TasksFiltersGetError,
    undefined,
    {},
    GetTaskFilterOptionsApiV1TasksFiltersGetQueryParams,
    {}
  >({ url: "/api/v1/tasks/filters", method: "get", ...variables, signal });

export function getTaskFilterOptionsApiV1TasksFiltersGetQuery(
  variables: GetTaskFilterOptionsApiV1TasksFiltersGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.TaskFilterOptionsResponse>;
};

export function getTaskFilterOptionsApiV1TasksFiltersGetQuery(
  variables:
    | GetTaskFilterOptionsApiV1TasksFiltersGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.TaskFilterOptionsResponse>)
    | reactQuery.SkipToken;
};

export function getTaskFilterOptionsApiV1TasksFiltersGetQuery(
  variables:
    | GetTaskFilterOptionsApiV1TasksFiltersGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/tasks/filters",
      operationId: "getTaskFilterOptionsApiV1TasksFiltersGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetTaskFilterOptionsApiV1TasksFiltersGet(variables, signal),
  };
}

export const useSuspenseGetTaskFilterOptionsApiV1TasksFiltersGet = <
  TData = Schemas.TaskFilterOptionsResponse,
>(
  variables: GetTaskFilterOptionsApiV1TasksFiltersGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TaskFilterOptionsResponse,
      GetTaskFilterOptionsApiV1TasksFiltersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.TaskFilterOptionsResponse,
    GetTaskFilterOptionsApiV1TasksFiltersGetError,
    TData
  >({
    ...getTaskFilterOptionsApiV1TasksFiltersGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetTaskFilterOptionsApiV1TasksFiltersGet = <
  TData = Schemas.TaskFilterOptionsResponse,
>(
  variables:
    | GetTaskFilterOptionsApiV1TasksFiltersGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TaskFilterOptionsResponse,
      GetTaskFilterOptionsApiV1TasksFiltersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.TaskFilterOptionsResponse,
    GetTaskFilterOptionsApiV1TasksFiltersGetError,
    TData
  >({
    ...getTaskFilterOptionsApiV1TasksFiltersGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AbortTaskApiV1TasksTaskIdAbortPostPathParams = {
  /**
   * @format uuid
   */
  taskId: string;
};

export type AbortTaskApiV1TasksTaskIdAbortPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AbortTaskApiV1TasksTaskIdAbortPostVariables = {
  pathParams: AbortTaskApiV1TasksTaskIdAbortPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchAbortTaskApiV1TasksTaskIdAbortPost = (
  variables: AbortTaskApiV1TasksTaskIdAbortPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TaskDTO,
    AbortTaskApiV1TasksTaskIdAbortPostError,
    undefined,
    {},
    {},
    AbortTaskApiV1TasksTaskIdAbortPostPathParams
  >({
    url: "/api/v1/tasks/{taskId}/abort",
    method: "post",
    ...variables,
    signal,
  });

export const useAbortTaskApiV1TasksTaskIdAbortPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TaskDTO,
      AbortTaskApiV1TasksTaskIdAbortPostError,
      AbortTaskApiV1TasksTaskIdAbortPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.TaskDTO,
    AbortTaskApiV1TasksTaskIdAbortPostError,
    AbortTaskApiV1TasksTaskIdAbortPostVariables
  >({
    mutationFn: (variables: AbortTaskApiV1TasksTaskIdAbortPostVariables) =>
      fetchAbortTaskApiV1TasksTaskIdAbortPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RetryTaskApiV1TasksTaskIdRetryPostPathParams = {
  /**
   * @format uuid
   */
  taskId: string;
};

export type RetryTaskApiV1TasksTaskIdRetryPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type RetryTaskApiV1TasksTaskIdRetryPostVariables = {
  pathParams: RetryTaskApiV1TasksTaskIdRetryPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Retry a failed or aborted dataset creation task.
 *
 * This endpoint will:
 * 1. Validate the task is in a retryable state (FAILED or ABORTED)
 * 2. Reset task status to INITIALIZING
 * 3. Re-trigger the pipeline with the same configuration
 *
 * Returns:
 *     The updated task with INITIALIZING status (pipeline triggered)
 *
 * Raises:
 *     404: Task, dataset, or user not found
 *     400: Task not in retryable state (not FAILED/ABORTED)
 *     500: Pipeline trigger failure
 */
export const fetchRetryTaskApiV1TasksTaskIdRetryPost = (
  variables: RetryTaskApiV1TasksTaskIdRetryPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.TaskDTO,
    RetryTaskApiV1TasksTaskIdRetryPostError,
    undefined,
    {},
    {},
    RetryTaskApiV1TasksTaskIdRetryPostPathParams
  >({
    url: "/api/v1/tasks/{taskId}/retry",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Retry a failed or aborted dataset creation task.
 *
 * This endpoint will:
 * 1. Validate the task is in a retryable state (FAILED or ABORTED)
 * 2. Reset task status to INITIALIZING
 * 3. Re-trigger the pipeline with the same configuration
 *
 * Returns:
 *     The updated task with INITIALIZING status (pipeline triggered)
 *
 * Raises:
 *     404: Task, dataset, or user not found
 *     400: Task not in retryable state (not FAILED/ABORTED)
 *     500: Pipeline trigger failure
 */
export const useRetryTaskApiV1TasksTaskIdRetryPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TaskDTO,
      RetryTaskApiV1TasksTaskIdRetryPostError,
      RetryTaskApiV1TasksTaskIdRetryPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.TaskDTO,
    RetryTaskApiV1TasksTaskIdRetryPostError,
    RetryTaskApiV1TasksTaskIdRetryPostVariables
  >({
    mutationFn: (variables: RetryTaskApiV1TasksTaskIdRetryPostVariables) =>
      fetchRetryTaskApiV1TasksTaskIdRetryPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type WorkflowCallbackApiV1InternalWorkflowCallbackPostHeaders = {
  ["x-callback-token"]: string;
};

export type WorkflowCallbackApiV1InternalWorkflowCallbackPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type WorkflowCallbackApiV1InternalWorkflowCallbackPostVariables = {
  body: Schemas.WorkflowCallbackRequest;
  headers: WorkflowCallbackApiV1InternalWorkflowCallbackPostHeaders;
} & VlContext["fetcherOptions"];

/**
 * Called by Argo exit handler when a workflow reaches a terminal state.
 *
 * Idempotent: safe to call multiple times for the same workflow.
 * Only updates tasks that are still in a non-terminal status.
 */
export const fetchWorkflowCallbackApiV1InternalWorkflowCallbackPost = (
  variables: WorkflowCallbackApiV1InternalWorkflowCallbackPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.WorkflowCallbackResponse,
    WorkflowCallbackApiV1InternalWorkflowCallbackPostError,
    Schemas.WorkflowCallbackRequest,
    WorkflowCallbackApiV1InternalWorkflowCallbackPostHeaders,
    {},
    {}
  >({
    url: "/api/v1/internal/workflow-callback",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Called by Argo exit handler when a workflow reaches a terminal state.
 *
 * Idempotent: safe to call multiple times for the same workflow.
 * Only updates tasks that are still in a non-terminal status.
 */
export const useWorkflowCallbackApiV1InternalWorkflowCallbackPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.WorkflowCallbackResponse,
      WorkflowCallbackApiV1InternalWorkflowCallbackPostError,
      WorkflowCallbackApiV1InternalWorkflowCallbackPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.WorkflowCallbackResponse,
    WorkflowCallbackApiV1InternalWorkflowCallbackPostError,
    WorkflowCallbackApiV1InternalWorkflowCallbackPostVariables
  >({
    mutationFn: (
      variables: WorkflowCallbackApiV1InternalWorkflowCallbackPostVariables,
    ) =>
      fetchWorkflowCallbackApiV1InternalWorkflowCallbackPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * Video ID from frame metadata
     */
    videoId: string;
  };

export type GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQueryParams =
  {
    /**
     * VQL filter string
     */
    vql?: string | null;
    /**
     * Filter frames by cluster ID
     */
    cluster_id?: string | null;
    /**
     * @default false
     */
    allow_deleted?: boolean;
  };

export type GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse =
  Schemas.VideoFramesResponse | null;

export type GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables =
  {
    pathParams: GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetPathParams;
    queryParams?: GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Retrieves all frames for a specific video.
 *
 * Returns video metadata (width, height, frame_count, etc.) and all frames
 * ordered by frame_timestamp.
 *
 * Parameters:
 * - video_id: The video_id from frame metadata (UUID string)
 */
export const fetchGetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet = (
  variables: GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError,
    undefined,
    {},
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQueryParams,
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetPathParams
  >({
    url: "/api/v1/explore/{datasetId}/video/{videoId}/frames",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Retrieves all frames for a specific video.
 *
 * Returns video metadata (width, height, frame_count, etc.) and all frames
 * ordered by frame_timestamp.
 *
 * Parameters:
 * - video_id: The video_id from frame metadata (UUID string)
 */
export function getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQuery(
  variables: GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse>;
};

export function getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQuery(
  variables:
    | GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse>)
    | reactQuery.SkipToken;
};

export function getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQuery(
  variables:
    | GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/explore/{datasetId}/video/{videoId}/frames",
      operationId: "getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet(
              variables,
              signal,
            ),
  };
}

/**
 * Retrieves all frames for a specific video.
 *
 * Returns video metadata (width, height, frame_count, etc.) and all frames
 * ordered by frame_timestamp.
 *
 * Parameters:
 * - video_id: The video_id from frame metadata (UUID string)
 */
export const useSuspenseGetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet =
  <TData = GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse>(
    variables: GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
        GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
      GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError,
      TData
    >({
      ...getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Retrieves all frames for a specific video.
 *
 * Returns video metadata (width, height, frame_count, etc.) and all frames
 * ordered by frame_timestamp.
 *
 * Parameters:
 * - video_id: The video_id from frame metadata (UUID string)
 */
export const useGetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet = <
  TData = GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
>(
  variables:
    | GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
      GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetResponse,
    GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetError,
    TData
  >({
    ...getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type CreateSnapshotApiV1DatasetDatasetIdSnapshotPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type CreateSnapshotApiV1DatasetDatasetIdSnapshotPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CreateSnapshotApiV1DatasetDatasetIdSnapshotPostVariables = {
  body?: Schemas.BodyCreateSnapshotApiV1DatasetDatasetIdSnapshotPost;
  pathParams: CreateSnapshotApiV1DatasetDatasetIdSnapshotPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Create a manual snapshot of the dataset's current revision.
 */
export const fetchCreateSnapshotApiV1DatasetDatasetIdSnapshotPost = (
  variables: CreateSnapshotApiV1DatasetDatasetIdSnapshotPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetSnapshotMetadata,
    CreateSnapshotApiV1DatasetDatasetIdSnapshotPostError,
    Schemas.BodyCreateSnapshotApiV1DatasetDatasetIdSnapshotPost,
    {},
    {},
    CreateSnapshotApiV1DatasetDatasetIdSnapshotPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/snapshot",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a manual snapshot of the dataset's current revision.
 */
export const useCreateSnapshotApiV1DatasetDatasetIdSnapshotPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DatasetSnapshotMetadata,
      CreateSnapshotApiV1DatasetDatasetIdSnapshotPostError,
      CreateSnapshotApiV1DatasetDatasetIdSnapshotPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.DatasetSnapshotMetadata,
    CreateSnapshotApiV1DatasetDatasetIdSnapshotPostError,
    CreateSnapshotApiV1DatasetDatasetIdSnapshotPostVariables
  >({
    mutationFn: (
      variables: CreateSnapshotApiV1DatasetDatasetIdSnapshotPostVariables,
    ) =>
      fetchCreateSnapshotApiV1DatasetDatasetIdSnapshotPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ListSnapshotsApiV1DatasetDatasetIdSnapshotGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse =
  Schemas.DatasetSnapshotMetadata[];

export type ListSnapshotsApiV1DatasetDatasetIdSnapshotGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables = {
  body?: ListSnapshotsApiV1DatasetDatasetIdSnapshotGetRequestBody;
  pathParams: ListSnapshotsApiV1DatasetDatasetIdSnapshotGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * List all snapshots (revisions) for a dataset.
 */
export const fetchListSnapshotsApiV1DatasetDatasetIdSnapshotGet = (
  variables: ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError,
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetRequestBody,
    {},
    {},
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/snapshot",
    method: "get",
    ...variables,
    signal,
  });

/**
 * List all snapshots (revisions) for a dataset.
 */
export function listSnapshotsApiV1DatasetDatasetIdSnapshotGetQuery(
  variables: ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse>;
};

export function listSnapshotsApiV1DatasetDatasetIdSnapshotGetQuery(
  variables:
    | ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse>)
    | reactQuery.SkipToken;
};

export function listSnapshotsApiV1DatasetDatasetIdSnapshotGetQuery(
  variables:
    | ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/snapshot",
      operationId: "listSnapshotsApiV1DatasetDatasetIdSnapshotGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListSnapshotsApiV1DatasetDatasetIdSnapshotGet(
              variables,
              signal,
            ),
  };
}

/**
 * List all snapshots (revisions) for a dataset.
 */
export const useSuspenseListSnapshotsApiV1DatasetDatasetIdSnapshotGet = <
  TData = ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
>(
  variables: ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
      ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError,
    TData
  >({
    ...listSnapshotsApiV1DatasetDatasetIdSnapshotGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List all snapshots (revisions) for a dataset.
 */
export const useListSnapshotsApiV1DatasetDatasetIdSnapshotGet = <
  TData = ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
>(
  variables:
    | ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
      ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetResponse,
    ListSnapshotsApiV1DatasetDatasetIdSnapshotGetError,
    TData
  >({
    ...listSnapshotsApiV1DatasetDatasetIdSnapshotGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    snapshotId: string;
  };

export type UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchVariables =
  {
    body?: Schemas.BodyUpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatch;
    pathParams: UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Update snapshot name and/or description.
 */
export const fetchUpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatch = (
  variables: UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetSnapshotMetadata,
    UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchError,
    Schemas.BodyUpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatch,
    {},
    {},
    UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/snapshot/{snapshotId}",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update snapshot name and/or description.
 */
export const useUpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DatasetSnapshotMetadata,
      UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchError,
      UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.DatasetSnapshotMetadata,
    UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchError,
    UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchVariables
  >({
    mutationFn: (
      variables: UpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatchVariables,
    ) =>
      fetchUpdateSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdPatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    snapshotId: string;
  };

export type DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteVariables =
  {
    body?: DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteRequestBody;
    pathParams: DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeletePathParams;
  } & VlContext["fetcherOptions"];

/**
 * Delete a snapshot (soft delete - marks as deleted without removing from DB)
 */
export const fetchDeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDelete =
  (
    variables: DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteError,
      DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteRequestBody,
      {},
      {},
      DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeletePathParams
    >({
      url: "/api/v1/dataset/{datasetId}/snapshot/{snapshotId}",
      method: "delete",
      ...variables,
      signal,
    });

/**
 * Delete a snapshot (soft delete - marks as deleted without removing from DB)
 */
export const useDeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteError,
      DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteError,
    DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDeleteVariables,
    ) =>
      fetchDeleteSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    snapshotId: string | string;
  };

export type RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostRequestBody =
  Schemas.AccessOperation[] | null;

export type RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostVariables =
  {
    body?: RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostRequestBody;
    pathParams: RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Restore dataset to snapshot state (in-place)
 */
export const fetchRestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePost =
  (
    variables: RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostError,
      RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostRequestBody,
      {},
      {},
      RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/snapshot/{snapshotId}/restore",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Restore dataset to snapshot state (in-place)
 */
export const useRestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostError,
        RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostError,
      RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostVariables
    >({
      mutationFn: (
        variables: RestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePostVariables,
      ) =>
        fetchRestoreSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdRestorePost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    snapshotId: string;
  };

export type CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostRequestBody =
  Schemas.AccessOperation[] | null;

export type CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostVariables =
  {
    body?: CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostRequestBody;
    pathParams: CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Clone snapshot to a new virtual dataset
 */
export const fetchCloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePost =
  (
    variables: CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostError,
      CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostRequestBody,
      {},
      {},
      CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/snapshot/{snapshotId}/clone",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Clone snapshot to a new virtual dataset
 */
export const useCloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostError,
        CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostError,
      CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostVariables
    >({
      mutationFn: (
        variables: CloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePostVariables,
      ) =>
        fetchCloneFromSnapshotApiV1DatasetDatasetIdSnapshotSnapshotIdClonePost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ListOrganizationsApiV1OrganizationsGetError =
  Fetcher.ErrorWrapper<undefined>;

export type ListOrganizationsApiV1OrganizationsGetVariables =
  VlContext["fetcherOptions"];

export const fetchListOrganizationsApiV1OrganizationsGet = (
  variables: ListOrganizationsApiV1OrganizationsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListOrganizationsResponse,
    ListOrganizationsApiV1OrganizationsGetError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/organizations", method: "get", ...variables, signal });

export function listOrganizationsApiV1OrganizationsGetQuery(
  variables: ListOrganizationsApiV1OrganizationsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ListOrganizationsResponse>;
};

export function listOrganizationsApiV1OrganizationsGetQuery(
  variables:
    | ListOrganizationsApiV1OrganizationsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListOrganizationsResponse>)
    | reactQuery.SkipToken;
};

export function listOrganizationsApiV1OrganizationsGetQuery(
  variables:
    | ListOrganizationsApiV1OrganizationsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/organizations",
      operationId: "listOrganizationsApiV1OrganizationsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListOrganizationsApiV1OrganizationsGet(variables, signal),
  };
}

export const useSuspenseListOrganizationsApiV1OrganizationsGet = <
  TData = Schemas.ListOrganizationsResponse,
>(
  variables: ListOrganizationsApiV1OrganizationsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListOrganizationsResponse,
      ListOrganizationsApiV1OrganizationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListOrganizationsResponse,
    ListOrganizationsApiV1OrganizationsGetError,
    TData
  >({
    ...listOrganizationsApiV1OrganizationsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListOrganizationsApiV1OrganizationsGet = <
  TData = Schemas.ListOrganizationsResponse,
>(
  variables:
    | ListOrganizationsApiV1OrganizationsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListOrganizationsResponse,
      ListOrganizationsApiV1OrganizationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListOrganizationsResponse,
    ListOrganizationsApiV1OrganizationsGetError,
    TData
  >({
    ...listOrganizationsApiV1OrganizationsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetOrganizationApiV1OrganizationsOrganizationIdGetPathParams = {
  /**
   * @format uuid
   */
  organizationId: string;
};

export type GetOrganizationApiV1OrganizationsOrganizationIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetOrganizationApiV1OrganizationsOrganizationIdGetVariables = {
  pathParams: GetOrganizationApiV1OrganizationsOrganizationIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetOrganizationApiV1OrganizationsOrganizationIdGet = (
  variables: GetOrganizationApiV1OrganizationsOrganizationIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.Organization,
    GetOrganizationApiV1OrganizationsOrganizationIdGetError,
    undefined,
    {},
    {},
    GetOrganizationApiV1OrganizationsOrganizationIdGetPathParams
  >({
    url: "/api/v1/organizations/{organizationId}",
    method: "get",
    ...variables,
    signal,
  });

export function getOrganizationApiV1OrganizationsOrganizationIdGetQuery(
  variables: GetOrganizationApiV1OrganizationsOrganizationIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.Organization>;
};

export function getOrganizationApiV1OrganizationsOrganizationIdGetQuery(
  variables:
    | GetOrganizationApiV1OrganizationsOrganizationIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.Organization>)
    | reactQuery.SkipToken;
};

export function getOrganizationApiV1OrganizationsOrganizationIdGetQuery(
  variables:
    | GetOrganizationApiV1OrganizationsOrganizationIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/organizations/{organizationId}",
      operationId: "getOrganizationApiV1OrganizationsOrganizationIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetOrganizationApiV1OrganizationsOrganizationIdGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseGetOrganizationApiV1OrganizationsOrganizationIdGet = <
  TData = Schemas.Organization,
>(
  variables: GetOrganizationApiV1OrganizationsOrganizationIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Organization,
      GetOrganizationApiV1OrganizationsOrganizationIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.Organization,
    GetOrganizationApiV1OrganizationsOrganizationIdGetError,
    TData
  >({
    ...getOrganizationApiV1OrganizationsOrganizationIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetOrganizationApiV1OrganizationsOrganizationIdGet = <
  TData = Schemas.Organization,
>(
  variables:
    | GetOrganizationApiV1OrganizationsOrganizationIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Organization,
      GetOrganizationApiV1OrganizationsOrganizationIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.Organization,
    GetOrganizationApiV1OrganizationsOrganizationIdGetError,
    TData
  >({
    ...getOrganizationApiV1OrganizationsOrganizationIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListWorkspacesApiV1WorkspacesGetQueryParams = {
  /**
   * Filter by organization ID
   */
  organization_id?: string | null;
};

export type ListWorkspacesApiV1WorkspacesGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListWorkspacesApiV1WorkspacesGetVariables = {
  queryParams?: ListWorkspacesApiV1WorkspacesGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchListWorkspacesApiV1WorkspacesGet = (
  variables: ListWorkspacesApiV1WorkspacesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListWorkspacesResponse,
    ListWorkspacesApiV1WorkspacesGetError,
    undefined,
    {},
    ListWorkspacesApiV1WorkspacesGetQueryParams,
    {}
  >({ url: "/api/v1/workspaces", method: "get", ...variables, signal });

export function listWorkspacesApiV1WorkspacesGetQuery(
  variables: ListWorkspacesApiV1WorkspacesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListWorkspacesResponse>;
};

export function listWorkspacesApiV1WorkspacesGetQuery(
  variables: ListWorkspacesApiV1WorkspacesGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListWorkspacesResponse>)
    | reactQuery.SkipToken;
};

export function listWorkspacesApiV1WorkspacesGetQuery(
  variables: ListWorkspacesApiV1WorkspacesGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/workspaces",
      operationId: "listWorkspacesApiV1WorkspacesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListWorkspacesApiV1WorkspacesGet(variables, signal),
  };
}

export const useSuspenseListWorkspacesApiV1WorkspacesGet = <
  TData = Schemas.ListWorkspacesResponse,
>(
  variables: ListWorkspacesApiV1WorkspacesGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListWorkspacesResponse,
      ListWorkspacesApiV1WorkspacesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListWorkspacesResponse,
    ListWorkspacesApiV1WorkspacesGetError,
    TData
  >({
    ...listWorkspacesApiV1WorkspacesGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListWorkspacesApiV1WorkspacesGet = <
  TData = Schemas.ListWorkspacesResponse,
>(
  variables: ListWorkspacesApiV1WorkspacesGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListWorkspacesResponse,
      ListWorkspacesApiV1WorkspacesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListWorkspacesResponse,
    ListWorkspacesApiV1WorkspacesGetError,
    TData
  >({
    ...listWorkspacesApiV1WorkspacesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetWorkspaceApiV1WorkspacesWorkspaceIdGetPathParams = {
  /**
   * @format uuid
   */
  workspaceId: string;
};

export type GetWorkspaceApiV1WorkspacesWorkspaceIdGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables = {
  pathParams: GetWorkspaceApiV1WorkspacesWorkspaceIdGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchGetWorkspaceApiV1WorkspacesWorkspaceIdGet = (
  variables: GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.Workspace,
    GetWorkspaceApiV1WorkspacesWorkspaceIdGetError,
    undefined,
    {},
    {},
    GetWorkspaceApiV1WorkspacesWorkspaceIdGetPathParams
  >({
    url: "/api/v1/workspaces/{workspaceId}",
    method: "get",
    ...variables,
    signal,
  });

export function getWorkspaceApiV1WorkspacesWorkspaceIdGetQuery(
  variables: GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.Workspace>;
};

export function getWorkspaceApiV1WorkspacesWorkspaceIdGetQuery(
  variables:
    | GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.Workspace>)
    | reactQuery.SkipToken;
};

export function getWorkspaceApiV1WorkspacesWorkspaceIdGetQuery(
  variables:
    | GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/workspaces/{workspaceId}",
      operationId: "getWorkspaceApiV1WorkspacesWorkspaceIdGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetWorkspaceApiV1WorkspacesWorkspaceIdGet(variables, signal),
  };
}

export const useSuspenseGetWorkspaceApiV1WorkspacesWorkspaceIdGet = <
  TData = Schemas.Workspace,
>(
  variables: GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Workspace,
      GetWorkspaceApiV1WorkspacesWorkspaceIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.Workspace,
    GetWorkspaceApiV1WorkspacesWorkspaceIdGetError,
    TData
  >({
    ...getWorkspaceApiV1WorkspacesWorkspaceIdGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetWorkspaceApiV1WorkspacesWorkspaceIdGet = <
  TData = Schemas.Workspace,
>(
  variables:
    | GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Workspace,
      GetWorkspaceApiV1WorkspacesWorkspaceIdGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.Workspace,
    GetWorkspaceApiV1WorkspacesWorkspaceIdGetError,
    TData
  >({
    ...getWorkspaceApiV1WorkspacesWorkspaceIdGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListWorkspaceMembersApiV1WorkspaceMembersGetQueryParams = {
  /**
   * Workspace ID. Defaults to user's default workspace.
   */
  workspace_id?: string | null;
};

export type ListWorkspaceMembersApiV1WorkspaceMembersGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ListWorkspaceMembersApiV1WorkspaceMembersGetVariables = {
  queryParams?: ListWorkspaceMembersApiV1WorkspaceMembersGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * List all members of a workspace with their roles.
 *
 * If workspace_id is not provided, defaults to the user's default workspace.
 * Roles are fetched from OpenFGA (admin, editor, viewer).
 *
 * Any workspace member can view the members list (read-only).
 */
export const fetchListWorkspaceMembersApiV1WorkspaceMembersGet = (
  variables: ListWorkspaceMembersApiV1WorkspaceMembersGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.ListMembersResponse,
    ListWorkspaceMembersApiV1WorkspaceMembersGetError,
    undefined,
    {},
    ListWorkspaceMembersApiV1WorkspaceMembersGetQueryParams,
    {}
  >({ url: "/api/v1/workspace/members", method: "get", ...variables, signal });

/**
 * List all members of a workspace with their roles.
 *
 * If workspace_id is not provided, defaults to the user's default workspace.
 * Roles are fetched from OpenFGA (admin, editor, viewer).
 *
 * Any workspace member can view the members list (read-only).
 */
export function listWorkspaceMembersApiV1WorkspaceMembersGetQuery(
  variables: ListWorkspaceMembersApiV1WorkspaceMembersGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ListMembersResponse>;
};

export function listWorkspaceMembersApiV1WorkspaceMembersGetQuery(
  variables:
    | ListWorkspaceMembersApiV1WorkspaceMembersGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ListMembersResponse>)
    | reactQuery.SkipToken;
};

export function listWorkspaceMembersApiV1WorkspaceMembersGetQuery(
  variables:
    | ListWorkspaceMembersApiV1WorkspaceMembersGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/workspace/members",
      operationId: "listWorkspaceMembersApiV1WorkspaceMembersGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListWorkspaceMembersApiV1WorkspaceMembersGet(
              variables,
              signal,
            ),
  };
}

/**
 * List all members of a workspace with their roles.
 *
 * If workspace_id is not provided, defaults to the user's default workspace.
 * Roles are fetched from OpenFGA (admin, editor, viewer).
 *
 * Any workspace member can view the members list (read-only).
 */
export const useSuspenseListWorkspaceMembersApiV1WorkspaceMembersGet = <
  TData = Schemas.ListMembersResponse,
>(
  variables: ListWorkspaceMembersApiV1WorkspaceMembersGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListMembersResponse,
      ListWorkspaceMembersApiV1WorkspaceMembersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ListMembersResponse,
    ListWorkspaceMembersApiV1WorkspaceMembersGetError,
    TData
  >({
    ...listWorkspaceMembersApiV1WorkspaceMembersGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List all members of a workspace with their roles.
 *
 * If workspace_id is not provided, defaults to the user's default workspace.
 * Roles are fetched from OpenFGA (admin, editor, viewer).
 *
 * Any workspace member can view the members list (read-only).
 */
export const useListWorkspaceMembersApiV1WorkspaceMembersGet = <
  TData = Schemas.ListMembersResponse,
>(
  variables:
    | ListWorkspaceMembersApiV1WorkspaceMembersGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListMembersResponse,
      ListWorkspaceMembersApiV1WorkspaceMembersGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.ListMembersResponse,
    ListWorkspaceMembersApiV1WorkspaceMembersGetError,
    TData
  >({
    ...listWorkspaceMembersApiV1WorkspaceMembersGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutPathParams =
  {
    /**
     * User ID of the member to update
     *
     * @format uuid
     */
    memberUserId: string;
  };

export type UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutVariables =
  {
    body: Schemas.ClustplorerClustplorerModelsWorkspaceMembersUpdateRoleRequest;
    pathParams: UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Update a workspace member's role.
 *
 * When promoting to admin:
 * - There can only be ONE admin per workspace
 * - The current admin is demoted to editor (workspace) and member (org)
 * - The new admin gets admin (workspace), system_admin (org), and Keycloak admin roles
 *
 * Requires 'can_manage_members' permission on the workspace (admin or org system_admin).
 * If workspace_id is not provided in the request body, defaults to the user's default workspace.
 */
export const fetchUpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePut = (
  variables: UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.WorkspaceMember,
    UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutError,
    Schemas.ClustplorerClustplorerModelsWorkspaceMembersUpdateRoleRequest,
    {},
    {},
    UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutPathParams
  >({
    url: "/api/v1/workspace/members/{memberUserId}/role",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update a workspace member's role.
 *
 * When promoting to admin:
 * - There can only be ONE admin per workspace
 * - The current admin is demoted to editor (workspace) and member (org)
 * - The new admin gets admin (workspace), system_admin (org), and Keycloak admin roles
 *
 * Requires 'can_manage_members' permission on the workspace (admin or org system_admin).
 * If workspace_id is not provided in the request body, defaults to the user's default workspace.
 */
export const useUpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.WorkspaceMember,
      UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutError,
      UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.WorkspaceMember,
    UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutError,
    UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutVariables
  >({
    mutationFn: (
      variables: UpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePutVariables,
    ) =>
      fetchUpdateMemberRoleApiV1WorkspaceMembersMemberUserIdRolePut(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQueryParams =
  {
    /**
     * Workspace ID. Defaults to user's default workspace.
     */
    workspace_id?: string | null;
  };

export type CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse =
  {
    [key: string]: any;
  };

export type CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables =
  {
    queryParams?: CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Check if the current user can access workspace settings.
 *
 * Any workspace member can access settings (read-only view).
 * Only admins can manage (create users, change roles, etc.).
 *
 * Returns:
 *     {"can_access": bool, "can_manage": bool, "role": str | None}
 */
export const fetchCheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet =
  (
    variables: CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError,
      undefined,
      {},
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQueryParams,
      {}
    >({
      url: "/api/v1/workspace/settings/access",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Check if the current user can access workspace settings.
 *
 * Any workspace member can access settings (read-only view).
 * Only admins can manage (create users, change roles, etc.).
 *
 * Returns:
 *     {"can_access": bool, "can_manage": bool, "role": str | None}
 */
export function checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQuery(
  variables: CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse>;
};

export function checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQuery(
  variables:
    | CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse>)
    | reactQuery.SkipToken;
};

export function checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQuery(
  variables:
    | CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/workspace/settings/access",
      operationId:
        "checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchCheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet(
              variables,
              signal,
            ),
  };
}

/**
 * Check if the current user can access workspace settings.
 *
 * Any workspace member can access settings (read-only view).
 * Only admins can manage (create users, change roles, etc.).
 *
 * Returns:
 *     {"can_access": bool, "can_manage": bool, "role": str | None}
 */
export const useSuspenseCheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet =
  <TData = CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse>(
    variables: CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
        CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError,
      TData
    >({
      ...checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Check if the current user can access workspace settings.
 *
 * Any workspace member can access settings (read-only view).
 * Only admins can manage (create users, change roles, etc.).
 *
 * Returns:
 *     {"can_access": bool, "can_manage": bool, "role": str | None}
 */
export const useCheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet = <
  TData = CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
>(
  variables:
    | CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
      CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetResponse,
    CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetError,
    TData
  >({
    ...checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ListNotificationsApiV1NotificationsGetQueryParams = {
  /**
   * @maximum 100
   * @minimum 1
   * @default 20
   */
  limit?: number;
  /**
   * @minimum 0
   * @default 0
   */
  offset?: number;
  /**
   * @default false
   */
  unread_only?: boolean;
  dataset_id?: string | null;
};

export type ListNotificationsApiV1NotificationsGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ListNotificationsApiV1NotificationsGetVariables = {
  queryParams?: ListNotificationsApiV1NotificationsGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * List notifications for the current user with pagination.
 *
 * Args:
 *     limit: Maximum number of notifications to return (1-100)
 *     offset: Number of notifications to skip
 *     unread_only: If true, only return unread notifications
 *     dataset_id: If provided, only return notifications for this dataset
 */
export const fetchListNotificationsApiV1NotificationsGet = (
  variables: ListNotificationsApiV1NotificationsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.NotificationListResponse,
    ListNotificationsApiV1NotificationsGetError,
    undefined,
    {},
    ListNotificationsApiV1NotificationsGetQueryParams,
    {}
  >({ url: "/api/v1/notifications", method: "get", ...variables, signal });

/**
 * List notifications for the current user with pagination.
 *
 * Args:
 *     limit: Maximum number of notifications to return (1-100)
 *     offset: Number of notifications to skip
 *     unread_only: If true, only return unread notifications
 *     dataset_id: If provided, only return notifications for this dataset
 */
export function listNotificationsApiV1NotificationsGetQuery(
  variables: ListNotificationsApiV1NotificationsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.NotificationListResponse>;
};

export function listNotificationsApiV1NotificationsGetQuery(
  variables:
    | ListNotificationsApiV1NotificationsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.NotificationListResponse>)
    | reactQuery.SkipToken;
};

export function listNotificationsApiV1NotificationsGetQuery(
  variables:
    | ListNotificationsApiV1NotificationsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/notifications",
      operationId: "listNotificationsApiV1NotificationsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListNotificationsApiV1NotificationsGet(variables, signal),
  };
}

/**
 * List notifications for the current user with pagination.
 *
 * Args:
 *     limit: Maximum number of notifications to return (1-100)
 *     offset: Number of notifications to skip
 *     unread_only: If true, only return unread notifications
 *     dataset_id: If provided, only return notifications for this dataset
 */
export const useSuspenseListNotificationsApiV1NotificationsGet = <
  TData = Schemas.NotificationListResponse,
>(
  variables: ListNotificationsApiV1NotificationsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.NotificationListResponse,
      ListNotificationsApiV1NotificationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.NotificationListResponse,
    ListNotificationsApiV1NotificationsGetError,
    TData
  >({
    ...listNotificationsApiV1NotificationsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * List notifications for the current user with pagination.
 *
 * Args:
 *     limit: Maximum number of notifications to return (1-100)
 *     offset: Number of notifications to skip
 *     unread_only: If true, only return unread notifications
 *     dataset_id: If provided, only return notifications for this dataset
 */
export const useListNotificationsApiV1NotificationsGet = <
  TData = Schemas.NotificationListResponse,
>(
  variables:
    | ListNotificationsApiV1NotificationsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.NotificationListResponse,
      ListNotificationsApiV1NotificationsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.NotificationListResponse,
    ListNotificationsApiV1NotificationsGetError,
    TData
  >({
    ...listNotificationsApiV1NotificationsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetUnreadCountApiV1NotificationsUnreadCountGetQueryParams = {
  dataset_id?: string | null;
};

export type GetUnreadCountApiV1NotificationsUnreadCountGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetUnreadCountApiV1NotificationsUnreadCountGetVariables = {
  queryParams?: GetUnreadCountApiV1NotificationsUnreadCountGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Get the count of unread notifications for the current user.
 */
export const fetchGetUnreadCountApiV1NotificationsUnreadCountGet = (
  variables: GetUnreadCountApiV1NotificationsUnreadCountGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.UnreadCountResponse,
    GetUnreadCountApiV1NotificationsUnreadCountGetError,
    undefined,
    {},
    GetUnreadCountApiV1NotificationsUnreadCountGetQueryParams,
    {}
  >({
    url: "/api/v1/notifications/unread-count",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get the count of unread notifications for the current user.
 */
export function getUnreadCountApiV1NotificationsUnreadCountGetQuery(
  variables: GetUnreadCountApiV1NotificationsUnreadCountGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.UnreadCountResponse>;
};

export function getUnreadCountApiV1NotificationsUnreadCountGetQuery(
  variables:
    | GetUnreadCountApiV1NotificationsUnreadCountGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.UnreadCountResponse>)
    | reactQuery.SkipToken;
};

export function getUnreadCountApiV1NotificationsUnreadCountGetQuery(
  variables:
    | GetUnreadCountApiV1NotificationsUnreadCountGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/notifications/unread-count",
      operationId: "getUnreadCountApiV1NotificationsUnreadCountGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUnreadCountApiV1NotificationsUnreadCountGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get the count of unread notifications for the current user.
 */
export const useSuspenseGetUnreadCountApiV1NotificationsUnreadCountGet = <
  TData = Schemas.UnreadCountResponse,
>(
  variables: GetUnreadCountApiV1NotificationsUnreadCountGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UnreadCountResponse,
      GetUnreadCountApiV1NotificationsUnreadCountGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.UnreadCountResponse,
    GetUnreadCountApiV1NotificationsUnreadCountGetError,
    TData
  >({
    ...getUnreadCountApiV1NotificationsUnreadCountGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get the count of unread notifications for the current user.
 */
export const useGetUnreadCountApiV1NotificationsUnreadCountGet = <
  TData = Schemas.UnreadCountResponse,
>(
  variables:
    | GetUnreadCountApiV1NotificationsUnreadCountGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UnreadCountResponse,
      GetUnreadCountApiV1NotificationsUnreadCountGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.UnreadCountResponse,
    GetUnreadCountApiV1NotificationsUnreadCountGetError,
    TData
  >({
    ...getUnreadCountApiV1NotificationsUnreadCountGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type MarkNotificationReadApiV1NotificationsNotificationIdReadPostPathParams =
  {
    /**
     * @format uuid
     */
    notificationId: string;
  };

export type MarkNotificationReadApiV1NotificationsNotificationIdReadPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponse =
  {
    [key: string]: any;
  };

export type MarkNotificationReadApiV1NotificationsNotificationIdReadPostVariables =
  {
    pathParams: MarkNotificationReadApiV1NotificationsNotificationIdReadPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Mark a single notification as read.
 */
export const fetchMarkNotificationReadApiV1NotificationsNotificationIdReadPost =
  (
    variables: MarkNotificationReadApiV1NotificationsNotificationIdReadPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponse,
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostError,
      undefined,
      {},
      {},
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostPathParams
    >({
      url: "/api/v1/notifications/{notificationId}/read",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Mark a single notification as read.
 */
export const useMarkNotificationReadApiV1NotificationsNotificationIdReadPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponse,
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostError,
      MarkNotificationReadApiV1NotificationsNotificationIdReadPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponse,
    MarkNotificationReadApiV1NotificationsNotificationIdReadPostError,
    MarkNotificationReadApiV1NotificationsNotificationIdReadPostVariables
  >({
    mutationFn: (
      variables: MarkNotificationReadApiV1NotificationsNotificationIdReadPostVariables,
    ) =>
      fetchMarkNotificationReadApiV1NotificationsNotificationIdReadPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type MarkAllReadApiV1NotificationsReadAllPostQueryParams = {
  dataset_id?: string | null;
};

export type MarkAllReadApiV1NotificationsReadAllPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type MarkAllReadApiV1NotificationsReadAllPostResponse = {
  [key: string]: any;
};

export type MarkAllReadApiV1NotificationsReadAllPostVariables = {
  queryParams?: MarkAllReadApiV1NotificationsReadAllPostQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Mark all notifications as read for the current user.
 */
export const fetchMarkAllReadApiV1NotificationsReadAllPost = (
  variables: MarkAllReadApiV1NotificationsReadAllPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    MarkAllReadApiV1NotificationsReadAllPostResponse,
    MarkAllReadApiV1NotificationsReadAllPostError,
    undefined,
    {},
    MarkAllReadApiV1NotificationsReadAllPostQueryParams,
    {}
  >({
    url: "/api/v1/notifications/read-all",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Mark all notifications as read for the current user.
 */
export const useMarkAllReadApiV1NotificationsReadAllPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      MarkAllReadApiV1NotificationsReadAllPostResponse,
      MarkAllReadApiV1NotificationsReadAllPostError,
      MarkAllReadApiV1NotificationsReadAllPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    MarkAllReadApiV1NotificationsReadAllPostResponse,
    MarkAllReadApiV1NotificationsReadAllPostError,
    MarkAllReadApiV1NotificationsReadAllPostVariables
  >({
    mutationFn: (
      variables: MarkAllReadApiV1NotificationsReadAllPostVariables,
    ) =>
      fetchMarkAllReadApiV1NotificationsReadAllPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type NotificationStreamApiV1NotificationsStreamGetQueryParams = {
  dataset_id?: string | null;
};

export type NotificationStreamApiV1NotificationsStreamGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type NotificationStreamApiV1NotificationsStreamGetVariables = {
  queryParams?: NotificationStreamApiV1NotificationsStreamGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Server-Sent Events endpoint for real-time notifications.
 *
 * Opens a long-lived connection that streams notifications as they become available.
 * The connection polls the database every 3 seconds and sends:
 * - `notification` events with notification data
 * - `ping` events as keepalives
 *
 * Args:
 *     dataset_id: If provided, only stream notifications for this dataset
 *
 * Example usage in JavaScript:
 * ```js
 * const eventSource = new EventSource('/api/v1/notifications/stream');
 * eventSource.addEventListener('notification', (e) => {
 *     const notification = JSON.parse(e.data);
 *     console.log('New notification:', notification);
 * });
 * ```
 */
export const fetchNotificationStreamApiV1NotificationsStreamGet = (
  variables: NotificationStreamApiV1NotificationsStreamGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    NotificationStreamApiV1NotificationsStreamGetError,
    undefined,
    {},
    NotificationStreamApiV1NotificationsStreamGetQueryParams,
    {}
  >({
    url: "/api/v1/notifications/stream",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Server-Sent Events endpoint for real-time notifications.
 *
 * Opens a long-lived connection that streams notifications as they become available.
 * The connection polls the database every 3 seconds and sends:
 * - `notification` events with notification data
 * - `ping` events as keepalives
 *
 * Args:
 *     dataset_id: If provided, only stream notifications for this dataset
 *
 * Example usage in JavaScript:
 * ```js
 * const eventSource = new EventSource('/api/v1/notifications/stream');
 * eventSource.addEventListener('notification', (e) => {
 *     const notification = JSON.parse(e.data);
 *     console.log('New notification:', notification);
 * });
 * ```
 */
export function notificationStreamApiV1NotificationsStreamGetQuery(
  variables: NotificationStreamApiV1NotificationsStreamGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function notificationStreamApiV1NotificationsStreamGetQuery(
  variables:
    | NotificationStreamApiV1NotificationsStreamGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function notificationStreamApiV1NotificationsStreamGetQuery(
  variables:
    | NotificationStreamApiV1NotificationsStreamGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/notifications/stream",
      operationId: "notificationStreamApiV1NotificationsStreamGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchNotificationStreamApiV1NotificationsStreamGet(
              variables,
              signal,
            ),
  };
}

/**
 * Server-Sent Events endpoint for real-time notifications.
 *
 * Opens a long-lived connection that streams notifications as they become available.
 * The connection polls the database every 3 seconds and sends:
 * - `notification` events with notification data
 * - `ping` events as keepalives
 *
 * Args:
 *     dataset_id: If provided, only stream notifications for this dataset
 *
 * Example usage in JavaScript:
 * ```js
 * const eventSource = new EventSource('/api/v1/notifications/stream');
 * eventSource.addEventListener('notification', (e) => {
 *     const notification = JSON.parse(e.data);
 *     console.log('New notification:', notification);
 * });
 * ```
 */
export const useSuspenseNotificationStreamApiV1NotificationsStreamGet = <
  TData = void,
>(
  variables: NotificationStreamApiV1NotificationsStreamGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      NotificationStreamApiV1NotificationsStreamGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    NotificationStreamApiV1NotificationsStreamGetError,
    TData
  >({
    ...notificationStreamApiV1NotificationsStreamGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Server-Sent Events endpoint for real-time notifications.
 *
 * Opens a long-lived connection that streams notifications as they become available.
 * The connection polls the database every 3 seconds and sends:
 * - `notification` events with notification data
 * - `ping` events as keepalives
 *
 * Args:
 *     dataset_id: If provided, only stream notifications for this dataset
 *
 * Example usage in JavaScript:
 * ```js
 * const eventSource = new EventSource('/api/v1/notifications/stream');
 * eventSource.addEventListener('notification', (e) => {
 *     const notification = JSON.parse(e.data);
 *     console.log('New notification:', notification);
 * });
 * ```
 */
export const useNotificationStreamApiV1NotificationsStreamGet = <TData = void>(
  variables:
    | NotificationStreamApiV1NotificationsStreamGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      NotificationStreamApiV1NotificationsStreamGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    NotificationStreamApiV1NotificationsStreamGetError,
    TData
  >({
    ...notificationStreamApiV1NotificationsStreamGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ChatStreamEndpointApiVlChatStreamPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ChatStreamEndpointApiVlChatStreamPostVariables = {
  body: Schemas.ChatRequest;
} & VlContext["fetcherOptions"];

/**
 * Streaming chat endpoint using assistant-stream.
 *
 * Accepts messages in assistant-ui format and streams back responses
 * using Server-Sent Events (SSE) via DataStreamResponse.
 */
export const fetchChatStreamEndpointApiVlChatStreamPost = (
  variables: ChatStreamEndpointApiVlChatStreamPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ChatStreamEndpointApiVlChatStreamPostError,
    Schemas.ChatRequest,
    {},
    {},
    {}
  >({ url: "/api/vl-chat/stream", method: "post", ...variables, signal });

/**
 * Streaming chat endpoint using assistant-stream.
 *
 * Accepts messages in assistant-ui format and streams back responses
 * using Server-Sent Events (SSE) via DataStreamResponse.
 */
export const useChatStreamEndpointApiVlChatStreamPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ChatStreamEndpointApiVlChatStreamPostError,
      ChatStreamEndpointApiVlChatStreamPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ChatStreamEndpointApiVlChatStreamPostError,
    ChatStreamEndpointApiVlChatStreamPostVariables
  >({
    mutationFn: (variables: ChatStreamEndpointApiVlChatStreamPostVariables) =>
      fetchChatStreamEndpointApiVlChatStreamPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ChatInvokeEndpointApiVlChatInvokePostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ChatInvokeEndpointApiVlChatInvokePostVariables = {
  body: Schemas.ChatRequest;
} & VlContext["fetcherOptions"];

/**
 * Non-streaming chat endpoint for simple queries.
 * Returns the complete response at once.
 */
export const fetchChatInvokeEndpointApiVlChatInvokePost = (
  variables: ChatInvokeEndpointApiVlChatInvokePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ChatInvokeEndpointApiVlChatInvokePostError,
    Schemas.ChatRequest,
    {},
    {},
    {}
  >({ url: "/api/vl-chat/invoke", method: "post", ...variables, signal });

/**
 * Non-streaming chat endpoint for simple queries.
 * Returns the complete response at once.
 */
export const useChatInvokeEndpointApiVlChatInvokePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ChatInvokeEndpointApiVlChatInvokePostError,
      ChatInvokeEndpointApiVlChatInvokePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ChatInvokeEndpointApiVlChatInvokePostError,
    ChatInvokeEndpointApiVlChatInvokePostVariables
  >({
    mutationFn: (variables: ChatInvokeEndpointApiVlChatInvokePostVariables) =>
      fetchChatInvokeEndpointApiVlChatInvokePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ChatHistoryEndpointApiVlChatHistoryGetQueryParams = {
  thread_id: string;
  dataset_id?: string | null;
};

export type ChatHistoryEndpointApiVlChatHistoryGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ChatHistoryEndpointApiVlChatHistoryGetVariables = {
  queryParams: ChatHistoryEndpointApiVlChatHistoryGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Retrieve chat history for a thread from the checkpointer.
 *
 * Returns persisted messages in assistant-ui format.
 */
export const fetchChatHistoryEndpointApiVlChatHistoryGet = (
  variables: ChatHistoryEndpointApiVlChatHistoryGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ChatHistoryEndpointApiVlChatHistoryGetError,
    undefined,
    {},
    ChatHistoryEndpointApiVlChatHistoryGetQueryParams,
    {}
  >({ url: "/api/vl-chat/history", method: "get", ...variables, signal });

/**
 * Retrieve chat history for a thread from the checkpointer.
 *
 * Returns persisted messages in assistant-ui format.
 */
export function chatHistoryEndpointApiVlChatHistoryGetQuery(
  variables: ChatHistoryEndpointApiVlChatHistoryGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function chatHistoryEndpointApiVlChatHistoryGetQuery(
  variables:
    | ChatHistoryEndpointApiVlChatHistoryGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function chatHistoryEndpointApiVlChatHistoryGetQuery(
  variables:
    | ChatHistoryEndpointApiVlChatHistoryGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/vl-chat/history",
      operationId: "chatHistoryEndpointApiVlChatHistoryGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchChatHistoryEndpointApiVlChatHistoryGet(variables, signal),
  };
}

/**
 * Retrieve chat history for a thread from the checkpointer.
 *
 * Returns persisted messages in assistant-ui format.
 */
export const useSuspenseChatHistoryEndpointApiVlChatHistoryGet = <TData = void>(
  variables: ChatHistoryEndpointApiVlChatHistoryGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ChatHistoryEndpointApiVlChatHistoryGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ChatHistoryEndpointApiVlChatHistoryGetError,
    TData
  >({
    ...chatHistoryEndpointApiVlChatHistoryGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Retrieve chat history for a thread from the checkpointer.
 *
 * Returns persisted messages in assistant-ui format.
 */
export const useChatHistoryEndpointApiVlChatHistoryGet = <TData = void>(
  variables:
    | ChatHistoryEndpointApiVlChatHistoryGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ChatHistoryEndpointApiVlChatHistoryGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ChatHistoryEndpointApiVlChatHistoryGetError,
    TData
  >({
    ...chatHistoryEndpointApiVlChatHistoryGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type NewDatasetApiV1IngestionNewDatasetGetQueryParams = {
  name?: string | null;
  source_type?: Schemas.DatasetSourceType | null;
};

export type NewDatasetApiV1IngestionNewDatasetGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type NewDatasetApiV1IngestionNewDatasetGetVariables = {
  queryParams?: NewDatasetApiV1IngestionNewDatasetGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchNewDatasetApiV1IngestionNewDatasetGet = (
  variables: NewDatasetApiV1IngestionNewDatasetGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    NewDatasetApiV1IngestionNewDatasetGetError,
    undefined,
    {},
    NewDatasetApiV1IngestionNewDatasetGetQueryParams,
    {}
  >({
    url: "/api/v1/ingestion/new_dataset",
    method: "get",
    ...variables,
    signal,
  });

export function newDatasetApiV1IngestionNewDatasetGetQuery(
  variables: NewDatasetApiV1IngestionNewDatasetGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DatasetOutput>;
};

export function newDatasetApiV1IngestionNewDatasetGetQuery(
  variables:
    | NewDatasetApiV1IngestionNewDatasetGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.DatasetOutput>)
    | reactQuery.SkipToken;
};

export function newDatasetApiV1IngestionNewDatasetGetQuery(
  variables:
    | NewDatasetApiV1IngestionNewDatasetGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/new_dataset",
      operationId: "newDatasetApiV1IngestionNewDatasetGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchNewDatasetApiV1IngestionNewDatasetGet(variables, signal),
  };
}

export const useSuspenseNewDatasetApiV1IngestionNewDatasetGet = <
  TData = Schemas.DatasetOutput,
>(
  variables: NewDatasetApiV1IngestionNewDatasetGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      NewDatasetApiV1IngestionNewDatasetGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DatasetOutput,
    NewDatasetApiV1IngestionNewDatasetGetError,
    TData
  >({
    ...newDatasetApiV1IngestionNewDatasetGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useNewDatasetApiV1IngestionNewDatasetGet = <
  TData = Schemas.DatasetOutput,
>(
  variables:
    | NewDatasetApiV1IngestionNewDatasetGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      NewDatasetApiV1IngestionNewDatasetGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.DatasetOutput,
    NewDatasetApiV1IngestionNewDatasetGetError,
    TData
  >({
    ...newDatasetApiV1IngestionNewDatasetGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type TriggerPipelineApiV1IngestionTriggerPipelinePostQueryParams = {
  path: string;
  /**
   * Name for new dataset
   */
  dataset_name?: string | null;
  /**
   * Accepts reduce_disk_space
   */
  serve_mode?: string | null;
  dataset_id?: string | null;
  config?: string | null;
  /**
   * Enrichment config (alias for config, used by frontend)
   */
  config_dict?: string | null;
};

export type TriggerPipelineApiV1IngestionTriggerPipelinePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type TriggerPipelineApiV1IngestionTriggerPipelinePostVariables = {
  queryParams: TriggerPipelineApiV1IngestionTriggerPipelinePostQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Trigger pipeline for on-prem dataset creation.
 *
 * In K3s/Kubernetes environments (VL_ARGO_PIPELINE_ENABLED=true):
 *     Calls trigger_processing directly to use Argo/K8s pipelines.
 * In Docker-compose environments:
 *     Proxies to pipeline service via Caddy at http://cd:2080.
 */
export const fetchTriggerPipelineApiV1IngestionTriggerPipelinePost = (
  variables: TriggerPipelineApiV1IngestionTriggerPipelinePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    TriggerPipelineApiV1IngestionTriggerPipelinePostError,
    undefined,
    {},
    TriggerPipelineApiV1IngestionTriggerPipelinePostQueryParams,
    {}
  >({
    url: "/api/v1/ingestion/trigger_pipeline",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Trigger pipeline for on-prem dataset creation.
 *
 * In K3s/Kubernetes environments (VL_ARGO_PIPELINE_ENABLED=true):
 *     Calls trigger_processing directly to use Argo/K8s pipelines.
 * In Docker-compose environments:
 *     Proxies to pipeline service via Caddy at http://cd:2080.
 */
export const useTriggerPipelineApiV1IngestionTriggerPipelinePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      TriggerPipelineApiV1IngestionTriggerPipelinePostError,
      TriggerPipelineApiV1IngestionTriggerPipelinePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    TriggerPipelineApiV1IngestionTriggerPipelinePostError,
    TriggerPipelineApiV1IngestionTriggerPipelinePostVariables
  >({
    mutationFn: (
      variables: TriggerPipelineApiV1IngestionTriggerPipelinePostVariables,
    ) =>
      fetchTriggerPipelineApiV1IngestionTriggerPipelinePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ConnectS3ApiV1IngestionDatasetIdS3connectGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ConnectS3ApiV1IngestionDatasetIdS3connectGetQueryParams = {
  s3_uri: string;
};

export type ConnectS3ApiV1IngestionDatasetIdS3connectGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ConnectS3ApiV1IngestionDatasetIdS3connectGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables = {
  body?: ConnectS3ApiV1IngestionDatasetIdS3connectGetRequestBody;
  pathParams: ConnectS3ApiV1IngestionDatasetIdS3connectGetPathParams;
  queryParams: ConnectS3ApiV1IngestionDatasetIdS3connectGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchConnectS3ApiV1IngestionDatasetIdS3connectGet = (
  variables: ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ConnectS3ApiV1IngestionDatasetIdS3connectGetError,
    ConnectS3ApiV1IngestionDatasetIdS3connectGetRequestBody,
    {},
    ConnectS3ApiV1IngestionDatasetIdS3connectGetQueryParams,
    ConnectS3ApiV1IngestionDatasetIdS3connectGetPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/s3connect",
    method: "get",
    ...variables,
    signal,
  });

export function connectS3ApiV1IngestionDatasetIdS3ConnectGetQuery(
  variables: ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function connectS3ApiV1IngestionDatasetIdS3ConnectGetQuery(
  variables:
    | ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function connectS3ApiV1IngestionDatasetIdS3ConnectGetQuery(
  variables:
    | ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/{datasetId}/s3connect",
      operationId: "connectS3ApiV1IngestionDatasetIdS3connectGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchConnectS3ApiV1IngestionDatasetIdS3connectGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseConnectS3ApiV1IngestionDatasetIdS3connectGet = <
  TData = void,
>(
  variables: ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ConnectS3ApiV1IngestionDatasetIdS3connectGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ConnectS3ApiV1IngestionDatasetIdS3connectGetError,
    TData
  >({
    ...connectS3ApiV1IngestionDatasetIdS3ConnectGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useConnectS3ApiV1IngestionDatasetIdS3connectGet = <TData = void>(
  variables:
    | ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ConnectS3ApiV1IngestionDatasetIdS3connectGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ConnectS3ApiV1IngestionDatasetIdS3connectGetError,
    TData
  >({
    ...connectS3ApiV1IngestionDatasetIdS3ConnectGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetRequestBody =
  Schemas.AccessOperation[] | null;

export type StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables =
  {
    body?: StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetRequestBody;
    pathParams: StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetPathParams;
  } & VlContext["fetcherOptions"];

export const fetchStartUploadTransactionApiV1IngestionDatasetIdDataFilesGet = (
  variables: StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError,
    StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetRequestBody,
    {},
    {},
    StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/data_files",
    method: "get",
    ...variables,
    signal,
  });

export function startUploadTransactionApiV1IngestionDatasetIdDataFilesGetQuery(
  variables: StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function startUploadTransactionApiV1IngestionDatasetIdDataFilesGetQuery(
  variables:
    | StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function startUploadTransactionApiV1IngestionDatasetIdDataFilesGetQuery(
  variables:
    | StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/{datasetId}/data_files",
      operationId: "startUploadTransactionApiV1IngestionDatasetIdDataFilesGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchStartUploadTransactionApiV1IngestionDatasetIdDataFilesGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseStartUploadTransactionApiV1IngestionDatasetIdDataFilesGet =
  <TData = void>(
    variables: StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError,
      TData
    >({
      ...startUploadTransactionApiV1IngestionDatasetIdDataFilesGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useStartUploadTransactionApiV1IngestionDatasetIdDataFilesGet = <
  TData = void,
>(
  variables:
    | StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetError,
    TData
  >({
    ...startUploadTransactionApiV1IngestionDatasetIdDataFilesGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    transactionId: number;
  };

export type UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostQueryParams =
  {
    /**
     * @default false
     */
    last_chunk?: boolean;
  };

export type UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostVariables =
  {
    body: Schemas.BodyUploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPost;
    pathParams: UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostPathParams;
    queryParams?: UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchUploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPost =
  (
    variables: UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostError,
      Schemas.BodyUploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPost,
      {},
      UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostQueryParams,
      UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostPathParams
    >({
      url: "/api/v1/ingestion/{datasetId}/data_files/{transactionId}",
      method: "post",
      ...variables,
      signal,
    });

export const useUploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostError,
        UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostError,
      UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostVariables
    >({
      mutationFn: (
        variables: UploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPostVariables,
      ) =>
        fetchUploadDataFilesApiV1IngestionDatasetIdDataFilesTransactionIdPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    transactionId: number;
  };

export type ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostVariables =
  {
    body?: Schemas.BodyProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPost;
    pathParams: ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostPathParams;
  } & VlContext["fetcherOptions"];

export const fetchProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPost =
  (
    variables: ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostError,
      Schemas.BodyProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPost,
      {},
      {},
      ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostPathParams
    >({
      url: "/api/v1/ingestion/{datasetId}/process_files/{transactionId}",
      method: "post",
      ...variables,
      signal,
    });

export const useProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostError,
        ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostError,
      ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostVariables
    >({
      mutationFn: (
        variables: ProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPostVariables,
      ) =>
        fetchProcessFilesApiV1IngestionDatasetIdProcessFilesTransactionIdPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ProcessS3ApiV1IngestionDatasetIdProcessS3PostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ProcessS3ApiV1IngestionDatasetIdProcessS3PostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ProcessS3ApiV1IngestionDatasetIdProcessS3PostVariables = {
  body?: Schemas.BodyProcessS3ApiV1IngestionDatasetIdProcessS3Post;
  pathParams: ProcessS3ApiV1IngestionDatasetIdProcessS3PostPathParams;
} & VlContext["fetcherOptions"];

export const fetchProcessS3ApiV1IngestionDatasetIdProcessS3Post = (
  variables: ProcessS3ApiV1IngestionDatasetIdProcessS3PostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ProcessS3ApiV1IngestionDatasetIdProcessS3PostError,
    Schemas.BodyProcessS3ApiV1IngestionDatasetIdProcessS3Post,
    {},
    {},
    ProcessS3ApiV1IngestionDatasetIdProcessS3PostPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/process_s3",
    method: "post",
    ...variables,
    signal,
  });

export const useProcessS3ApiV1IngestionDatasetIdProcessS3Post = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ProcessS3ApiV1IngestionDatasetIdProcessS3PostError,
      ProcessS3ApiV1IngestionDatasetIdProcessS3PostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ProcessS3ApiV1IngestionDatasetIdProcessS3PostError,
    ProcessS3ApiV1IngestionDatasetIdProcessS3PostVariables
  >({
    mutationFn: (
      variables: ProcessS3ApiV1IngestionDatasetIdProcessS3PostVariables,
    ) =>
      fetchProcessS3ApiV1IngestionDatasetIdProcessS3Post(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type PreviewStatusApiV1IngestionDatasetIdStatusGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type PreviewStatusApiV1IngestionDatasetIdStatusGetQueryParams = {
  /**
   * @default 0
   */
  offset?: number;
};

export type PreviewStatusApiV1IngestionDatasetIdStatusGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type PreviewStatusApiV1IngestionDatasetIdStatusGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type PreviewStatusApiV1IngestionDatasetIdStatusGetVariables = {
  body?: PreviewStatusApiV1IngestionDatasetIdStatusGetRequestBody;
  pathParams: PreviewStatusApiV1IngestionDatasetIdStatusGetPathParams;
  queryParams?: PreviewStatusApiV1IngestionDatasetIdStatusGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchPreviewStatusApiV1IngestionDatasetIdStatusGet = (
  variables: PreviewStatusApiV1IngestionDatasetIdStatusGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    PreviewStatusApiV1IngestionDatasetIdStatusGetError,
    PreviewStatusApiV1IngestionDatasetIdStatusGetRequestBody,
    {},
    PreviewStatusApiV1IngestionDatasetIdStatusGetQueryParams,
    PreviewStatusApiV1IngestionDatasetIdStatusGetPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/status",
    method: "get",
    ...variables,
    signal,
  });

export function previewStatusApiV1IngestionDatasetIdStatusGetQuery(
  variables: PreviewStatusApiV1IngestionDatasetIdStatusGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function previewStatusApiV1IngestionDatasetIdStatusGetQuery(
  variables:
    | PreviewStatusApiV1IngestionDatasetIdStatusGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function previewStatusApiV1IngestionDatasetIdStatusGetQuery(
  variables:
    | PreviewStatusApiV1IngestionDatasetIdStatusGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/{datasetId}/status",
      operationId: "previewStatusApiV1IngestionDatasetIdStatusGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchPreviewStatusApiV1IngestionDatasetIdStatusGet(
              variables,
              signal,
            ),
  };
}

export const useSuspensePreviewStatusApiV1IngestionDatasetIdStatusGet = <
  TData = void,
>(
  variables: PreviewStatusApiV1IngestionDatasetIdStatusGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      PreviewStatusApiV1IngestionDatasetIdStatusGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    PreviewStatusApiV1IngestionDatasetIdStatusGetError,
    TData
  >({
    ...previewStatusApiV1IngestionDatasetIdStatusGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const usePreviewStatusApiV1IngestionDatasetIdStatusGet = <TData = void>(
  variables:
    | PreviewStatusApiV1IngestionDatasetIdStatusGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      PreviewStatusApiV1IngestionDatasetIdStatusGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    PreviewStatusApiV1IngestionDatasetIdStatusGetError,
    TData
  >({
    ...previewStatusApiV1IngestionDatasetIdStatusGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostVariables = {
  body: Schemas.BodyUploadAnnotationsApiV1IngestionDatasetIdAnnotationsPost;
  pathParams: UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchUploadAnnotationsApiV1IngestionDatasetIdAnnotationsPost = (
  variables: UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostError,
    Schemas.BodyUploadAnnotationsApiV1IngestionDatasetIdAnnotationsPost,
    {},
    {},
    UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/annotations",
    method: "post",
    ...variables,
    signal,
  });

export const useUploadAnnotationsApiV1IngestionDatasetIdAnnotationsPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostError,
      UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostError,
    UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostVariables
  >({
    mutationFn: (
      variables: UploadAnnotationsApiV1IngestionDatasetIdAnnotationsPostVariables,
    ) =>
      fetchUploadAnnotationsApiV1IngestionDatasetIdAnnotationsPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteRequestBody =
  Schemas.AccessOperation[] | null;

export type DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteVariables =
  {
    body?: DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteRequestBody;
    pathParams: DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeletePathParams;
  } & VlContext["fetcherOptions"];

export const fetchDeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDelete = (
  variables: DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteError,
    DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteRequestBody,
    {},
    {},
    DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeletePathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/annotations",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteError,
      DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteError,
    DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteVariables
  >({
    mutationFn: (
      variables: DeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDeleteVariables,
    ) =>
      fetchDeleteAnnotationsApiV1IngestionDatasetIdAnnotationsDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type UploadArchiveApiV1IngestionDatasetIdArchivePostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type UploadArchiveApiV1IngestionDatasetIdArchivePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadArchiveApiV1IngestionDatasetIdArchivePostVariables = {
  body: Schemas.BodyUploadArchiveApiV1IngestionDatasetIdArchivePost;
  pathParams: UploadArchiveApiV1IngestionDatasetIdArchivePostPathParams;
} & VlContext["fetcherOptions"];

export const fetchUploadArchiveApiV1IngestionDatasetIdArchivePost = (
  variables: UploadArchiveApiV1IngestionDatasetIdArchivePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    UploadArchiveApiV1IngestionDatasetIdArchivePostError,
    Schemas.BodyUploadArchiveApiV1IngestionDatasetIdArchivePost,
    {},
    {},
    UploadArchiveApiV1IngestionDatasetIdArchivePostPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/archive",
    method: "post",
    ...variables,
    signal,
  });

export const useUploadArchiveApiV1IngestionDatasetIdArchivePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      UploadArchiveApiV1IngestionDatasetIdArchivePostError,
      UploadArchiveApiV1IngestionDatasetIdArchivePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    UploadArchiveApiV1IngestionDatasetIdArchivePostError,
    UploadArchiveApiV1IngestionDatasetIdArchivePostVariables
  >({
    mutationFn: (
      variables: UploadArchiveApiV1IngestionDatasetIdArchivePostVariables,
    ) =>
      fetchUploadArchiveApiV1IngestionDatasetIdArchivePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostVariables = {
  body?: Schemas.BodyProcessArchiveApiV1IngestionDatasetIdProcessArchivePost;
  pathParams: ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostPathParams;
} & VlContext["fetcherOptions"];

export const fetchProcessArchiveApiV1IngestionDatasetIdProcessArchivePost = (
  variables: ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostError,
    Schemas.BodyProcessArchiveApiV1IngestionDatasetIdProcessArchivePost,
    {},
    {},
    ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/process_archive",
    method: "post",
    ...variables,
    signal,
  });

export const useProcessArchiveApiV1IngestionDatasetIdProcessArchivePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostError,
      ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostError,
    ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostVariables
  >({
    mutationFn: (
      variables: ProcessArchiveApiV1IngestionDatasetIdProcessArchivePostVariables,
    ) =>
      fetchProcessArchiveApiV1IngestionDatasetIdProcessArchivePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ListCvatApiV1IngestionDatasetIdListCvatGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ListCvatApiV1IngestionDatasetIdListCvatGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ListCvatApiV1IngestionDatasetIdListCvatGetVariables = {
  pathParams: ListCvatApiV1IngestionDatasetIdListCvatGetPathParams;
} & VlContext["fetcherOptions"];

export const fetchListCvatApiV1IngestionDatasetIdListCvatGet = (
  variables: ListCvatApiV1IngestionDatasetIdListCvatGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ListCvatApiV1IngestionDatasetIdListCvatGetError,
    undefined,
    {},
    {},
    ListCvatApiV1IngestionDatasetIdListCvatGetPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/list_cvat",
    method: "get",
    ...variables,
    signal,
  });

export function listCvatApiV1IngestionDatasetIdListCvatGetQuery(
  variables: ListCvatApiV1IngestionDatasetIdListCvatGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function listCvatApiV1IngestionDatasetIdListCvatGetQuery(
  variables:
    | ListCvatApiV1IngestionDatasetIdListCvatGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function listCvatApiV1IngestionDatasetIdListCvatGetQuery(
  variables:
    | ListCvatApiV1IngestionDatasetIdListCvatGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/{datasetId}/list_cvat",
      operationId: "listCvatApiV1IngestionDatasetIdListCvatGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchListCvatApiV1IngestionDatasetIdListCvatGet(variables, signal),
  };
}

export const useSuspenseListCvatApiV1IngestionDatasetIdListCvatGet = <
  TData = void,
>(
  variables: ListCvatApiV1IngestionDatasetIdListCvatGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ListCvatApiV1IngestionDatasetIdListCvatGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ListCvatApiV1IngestionDatasetIdListCvatGetError,
    TData
  >({
    ...listCvatApiV1IngestionDatasetIdListCvatGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useListCvatApiV1IngestionDatasetIdListCvatGet = <TData = void>(
  variables:
    | ListCvatApiV1IngestionDatasetIdListCvatGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ListCvatApiV1IngestionDatasetIdListCvatGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ListCvatApiV1IngestionDatasetIdListCvatGetError,
    TData
  >({
    ...listCvatApiV1IngestionDatasetIdListCvatGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ImportCvatApiV1IngestionDatasetIdImportCvatGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ImportCvatApiV1IngestionDatasetIdImportCvatGetQueryParams = {
  project_id?: string;
  task_id?: string;
};

export type ImportCvatApiV1IngestionDatasetIdImportCvatGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables = {
  pathParams: ImportCvatApiV1IngestionDatasetIdImportCvatGetPathParams;
  queryParams?: ImportCvatApiV1IngestionDatasetIdImportCvatGetQueryParams;
} & VlContext["fetcherOptions"];

export const fetchImportCvatApiV1IngestionDatasetIdImportCvatGet = (
  variables: ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ImportCvatApiV1IngestionDatasetIdImportCvatGetError,
    undefined,
    {},
    ImportCvatApiV1IngestionDatasetIdImportCvatGetQueryParams,
    ImportCvatApiV1IngestionDatasetIdImportCvatGetPathParams
  >({
    url: "/api/v1/ingestion/{datasetId}/import_cvat",
    method: "get",
    ...variables,
    signal,
  });

export function importCvatApiV1IngestionDatasetIdImportCvatGetQuery(
  variables: ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function importCvatApiV1IngestionDatasetIdImportCvatGetQuery(
  variables:
    | ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function importCvatApiV1IngestionDatasetIdImportCvatGetQuery(
  variables:
    | ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/ingestion/{datasetId}/import_cvat",
      operationId: "importCvatApiV1IngestionDatasetIdImportCvatGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchImportCvatApiV1IngestionDatasetIdImportCvatGet(
              variables,
              signal,
            ),
  };
}

export const useSuspenseImportCvatApiV1IngestionDatasetIdImportCvatGet = <
  TData = void,
>(
  variables: ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ImportCvatApiV1IngestionDatasetIdImportCvatGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    void,
    ImportCvatApiV1IngestionDatasetIdImportCvatGetError,
    TData
  >({
    ...importCvatApiV1IngestionDatasetIdImportCvatGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useImportCvatApiV1IngestionDatasetIdImportCvatGet = <TData = void>(
  variables:
    | ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      void,
      ImportCvatApiV1IngestionDatasetIdImportCvatGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    void,
    ImportCvatApiV1IngestionDatasetIdImportCvatGetError,
    TData
  >({
    ...importCvatApiV1IngestionDatasetIdImportCvatGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type CreateDatasetApiV1DatasetPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateDatasetApiV1DatasetPostVariables =
  VlContext["fetcherOptions"];

export const fetchCreateDatasetApiV1DatasetPost = (
  variables: CreateDatasetApiV1DatasetPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    CreateDatasetApiV1DatasetPostError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/dataset", method: "post", ...variables, signal });

export const useCreateDatasetApiV1DatasetPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DatasetOutput,
      CreateDatasetApiV1DatasetPostError,
      CreateDatasetApiV1DatasetPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.DatasetOutput,
    CreateDatasetApiV1DatasetPostError,
    CreateDatasetApiV1DatasetPostVariables
  >({
    mutationFn: (variables: CreateDatasetApiV1DatasetPostVariables) =>
      fetchCreateDatasetApiV1DatasetPost(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostVariables = {
  pathParams: DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostPathParams;
} & VlContext["fetcherOptions"];

export const fetchDuplicateDatasetApiV1DatasetDatasetIdDuplicatePost = (
  variables: DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostError,
    undefined,
    {},
    {},
    DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/duplicate",
    method: "post",
    ...variables,
    signal,
  });

export const useDuplicateDatasetApiV1DatasetDatasetIdDuplicatePost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostError,
      DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostError,
    DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostVariables
  >({
    mutationFn: (
      variables: DuplicateDatasetApiV1DatasetDatasetIdDuplicatePostVariables,
    ) =>
      fetchDuplicateDatasetApiV1DatasetDatasetIdDuplicatePost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostQueryParams = {
  enrichment_context_id?: string | null;
};

export type EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostVariables = {
  body?: Schemas.EnrichmentConfigInput;
  pathParams: EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostPathParams;
  queryParams?: EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostQueryParams;
} & VlContext["fetcherOptions"];

export const fetchEnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPost = (
  variables: EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostError,
    Schemas.EnrichmentConfigInput,
    {},
    EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostQueryParams,
    EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/enrich_dataset",
    method: "post",
    ...variables,
    signal,
  });

export const useEnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DatasetOutput,
      EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostError,
      EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.DatasetOutput,
    EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostError,
    EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostVariables
  >({
    mutationFn: (
      variables: EnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPostVariables,
    ) =>
      fetchEnrichDatasetApiV1DatasetDatasetIdEnrichDatasetPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type NewDatasetApiV1WorkflowDatasetNewPostError =
  Fetcher.ErrorWrapper<undefined>;

export type NewDatasetApiV1WorkflowDatasetNewPostVariables =
  VlContext["fetcherOptions"];

export const fetchNewDatasetApiV1WorkflowDatasetNewPost = (
  variables: NewDatasetApiV1WorkflowDatasetNewPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    NewDatasetApiV1WorkflowDatasetNewPostError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v1/workflow/dataset/new",
    method: "post",
    ...variables,
    signal,
  });

export const useNewDatasetApiV1WorkflowDatasetNewPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DatasetOutput,
      NewDatasetApiV1WorkflowDatasetNewPostError,
      NewDatasetApiV1WorkflowDatasetNewPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    Schemas.DatasetOutput,
    NewDatasetApiV1WorkflowDatasetNewPostError,
    NewDatasetApiV1WorkflowDatasetNewPostVariables
  >({
    mutationFn: (variables: NewDatasetApiV1WorkflowDatasetNewPostVariables) =>
      fetchNewDatasetApiV1WorkflowDatasetNewPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostVariables =
  {
    body?: Schemas.BodyCreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPost;
    pathParams: CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Get or create a batch for adding media to existing dataset.
 *
 * Returns existing batch if one exists with CREATED status (not yet processed).
 * Creates new batch if no unprocessed batch exists.
 */
export const fetchCreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPost =
  (
    variables: CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostError,
      Schemas.BodyCreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPost,
      {},
      {},
      CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostPathParams
    >({
      url: "/api/v1/workflow/dataset/{datasetId}/batch/new",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Get or create a batch for adding media to existing dataset.
 *
 * Returns existing batch if one exists with CREATED status (not yet processed).
 * Creates new batch if no unprocessed batch exists.
 */
export const useCreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostError,
        CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostError,
      CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostVariables
    >({
      mutationFn: (
        variables: CreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPostVariables,
      ) =>
        fetchCreateBatchForAddMediaApiV1WorkflowDatasetDatasetIdBatchNewPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeletePathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    /**
     * @format uuid
     */
    batchId: string;
  };

export type DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteVariables =
  {
    body?: Schemas.BodyDeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDelete;
    pathParams: DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeletePathParams;
  } & VlContext["fetcherOptions"];

/**
 * Abort/cancel a batch upload by deleting the batch and all its folders.
 * Can only be called when dataset status is UPLOADING (before processing starts).
 */
export const fetchDeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDelete = (
  variables: DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteError,
    Schemas.BodyDeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDelete,
    {},
    {},
    DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeletePathParams
  >({
    url: "/api/v1/workflow/dataset/{datasetId}/batch/{batchId}",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Abort/cancel a batch upload by deleting the batch and all its folders.
 * Can only be called when dataset status is UPLOADING (before processing starts).
 */
export const useDeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteError,
      DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteError,
    DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteVariables
  >({
    mutationFn: (
      variables: DeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDeleteVariables,
    ) =>
      fetchDeleteBatchApiV1WorkflowDatasetDatasetIdBatchBatchIdDelete(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostVariables = {
  body: Schemas.BodySetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPost;
  pathParams: SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostPathParams;
} & VlContext["fetcherOptions"];

export const fetchSetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPost = (
  variables: SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostError,
    Schemas.BodySetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPost,
    {},
    {},
    SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostPathParams
  >({
    url: "/api/v1/workflow/dataset/{datasetId}/set_folders",
    method: "post",
    ...variables,
    signal,
  });

export const useSetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostError,
      SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostError,
    SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostVariables
  >({
    mutationFn: (
      variables: SetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPostVariables,
    ) =>
      fetchSetFoldersApiV1WorkflowDatasetDatasetIdSetFoldersPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostQueryParams =
  {
    folder_name: string;
  };

export type ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostVariables =
  {
    body: Schemas.BodyValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPost;
    pathParams: ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostPathParams;
    queryParams: ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostQueryParams;
  } & VlContext["fetcherOptions"];

export const fetchValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPost =
  (
    variables: ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostError,
      Schemas.BodyValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPost,
      {},
      ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostQueryParams,
      ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/data/pre_upload_validation",
      method: "post",
      ...variables,
      signal,
    });

export const useValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostError,
        ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostError,
      ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostVariables
    >({
      mutationFn: (
        variables: ValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPostVariables,
      ) =>
        fetchValidateDatasetPreUploadApiV1DatasetDatasetIdDataPreUploadValidationPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQueryParams =
  {
    folder_name: string;
    /**
     * @default 0
     */
    total_files?: number;
    batch_id?: string | null;
  };

export type StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables =
  {
    body?: Schemas.BodyStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet;
    pathParams: StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetPathParams;
    queryParams: StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Start a new folder upload transaction for chunked file uploads.
 */
export const fetchStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet =
  (
    variables: StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError,
      Schemas.BodyStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet,
      {},
      StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQueryParams,
      StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/data/folder_upload_transaction",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Start a new folder upload transaction for chunked file uploads.
 */
export function startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQuery(
  variables: StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<void>;
};

export function startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQuery(
  variables:
    | StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<void>) | reactQuery.SkipToken;
};

export function startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQuery(
  variables:
    | StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/data/folder_upload_transaction",
      operationId:
        "startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet(
              variables,
              signal,
            ),
  };
}

/**
 * Start a new folder upload transaction for chunked file uploads.
 */
export const useSuspenseStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet =
  <TData = void>(
    variables: StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      void,
      StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError,
      TData
    >({
      ...startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Start a new folder upload transaction for chunked file uploads.
 */
export const useStartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet =
  <TData = void>(
    variables:
      | StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        void,
        StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      void,
      StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetError,
      TData
    >({
      ...startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
    transactionId: string;
  };

export type UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostQueryParams =
  {
    /**
     * @default false
     */
    last_chunk?: boolean;
  };

export type UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostVariables =
  {
    body: Schemas.BodyUploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPost;
    pathParams: UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostPathParams;
    queryParams?: UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Upload files in chunks to a specific folder within the dataset.
 */
export const fetchUploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPost =
  (
    variables: UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      void,
      UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostError,
      Schemas.BodyUploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPost,
      {},
      UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostQueryParams,
      UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/data/folder_upload/{transactionId}",
      method: "post",
      ...variables,
      signal,
    });

/**
 * Upload files in chunks to a specific folder within the dataset.
 */
export const useUploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPost =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        void,
        UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostError,
        UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useVlContext();
    return reactQuery.useMutation<
      void,
      UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostError,
      UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostVariables
    >({
      mutationFn: (
        variables: UploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPostVariables,
      ) =>
        fetchUploadFolderFilesApiV1DatasetDatasetIdDataFolderUploadTransactionIdPost(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type ProcessApiV1DatasetDatasetIdProcessGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ProcessApiV1DatasetDatasetIdProcessGetQueryParams = {
  batch_id?: string | null;
  /**
   * @default false
   */
  auto_reindex?: boolean;
  use_spot?: boolean | null;
};

export type ProcessApiV1DatasetDatasetIdProcessGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ProcessApiV1DatasetDatasetIdProcessGetRequestBody =
  | Schemas.AccessOperation[]
  | null;

export type ProcessApiV1DatasetDatasetIdProcessGetVariables = {
  body?: ProcessApiV1DatasetDatasetIdProcessGetRequestBody;
  pathParams: ProcessApiV1DatasetDatasetIdProcessGetPathParams;
  queryParams?: ProcessApiV1DatasetDatasetIdProcessGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Process selected folders for a dataset - triggers either creation or add media flow.
 *
 * Flow route is based on the batch_id parameter:
 * - batch_id=None: Dataset creation flow
 * - batch_id provided: Add media flow
 *
 * auto_reindex: If True and batch_id is provided, triggers combined partial_update + reindex workflow.
 * use_spot: If True, allows pipeline pods to be scheduled on spot/preemptible instances.
 */
export const fetchProcessApiV1DatasetDatasetIdProcessGet = (
  variables: ProcessApiV1DatasetDatasetIdProcessGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetOutput,
    ProcessApiV1DatasetDatasetIdProcessGetError,
    ProcessApiV1DatasetDatasetIdProcessGetRequestBody,
    {},
    ProcessApiV1DatasetDatasetIdProcessGetQueryParams,
    ProcessApiV1DatasetDatasetIdProcessGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/process",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Process selected folders for a dataset - triggers either creation or add media flow.
 *
 * Flow route is based on the batch_id parameter:
 * - batch_id=None: Dataset creation flow
 * - batch_id provided: Add media flow
 *
 * auto_reindex: If True and batch_id is provided, triggers combined partial_update + reindex workflow.
 * use_spot: If True, allows pipeline pods to be scheduled on spot/preemptible instances.
 */
export function processApiV1DatasetDatasetIdProcessGetQuery(
  variables: ProcessApiV1DatasetDatasetIdProcessGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DatasetOutput>;
};

export function processApiV1DatasetDatasetIdProcessGetQuery(
  variables:
    | ProcessApiV1DatasetDatasetIdProcessGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.DatasetOutput>)
    | reactQuery.SkipToken;
};

export function processApiV1DatasetDatasetIdProcessGetQuery(
  variables:
    | ProcessApiV1DatasetDatasetIdProcessGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/process",
      operationId: "processApiV1DatasetDatasetIdProcessGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchProcessApiV1DatasetDatasetIdProcessGet(variables, signal),
  };
}

/**
 * Process selected folders for a dataset - triggers either creation or add media flow.
 *
 * Flow route is based on the batch_id parameter:
 * - batch_id=None: Dataset creation flow
 * - batch_id provided: Add media flow
 *
 * auto_reindex: If True and batch_id is provided, triggers combined partial_update + reindex workflow.
 * use_spot: If True, allows pipeline pods to be scheduled on spot/preemptible instances.
 */
export const useSuspenseProcessApiV1DatasetDatasetIdProcessGet = <
  TData = Schemas.DatasetOutput,
>(
  variables: ProcessApiV1DatasetDatasetIdProcessGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      ProcessApiV1DatasetDatasetIdProcessGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DatasetOutput,
    ProcessApiV1DatasetDatasetIdProcessGetError,
    TData
  >({
    ...processApiV1DatasetDatasetIdProcessGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Process selected folders for a dataset - triggers either creation or add media flow.
 *
 * Flow route is based on the batch_id parameter:
 * - batch_id=None: Dataset creation flow
 * - batch_id provided: Add media flow
 *
 * auto_reindex: If True and batch_id is provided, triggers combined partial_update + reindex workflow.
 * use_spot: If True, allows pipeline pods to be scheduled on spot/preemptible instances.
 */
export const useProcessApiV1DatasetDatasetIdProcessGet = <
  TData = Schemas.DatasetOutput,
>(
  variables:
    | ProcessApiV1DatasetDatasetIdProcessGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetOutput,
      ProcessApiV1DatasetDatasetIdProcessGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.DatasetOutput,
    ProcessApiV1DatasetDatasetIdProcessGetError,
    TData
  >({
    ...processApiV1DatasetDatasetIdProcessGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQueryParams =
  {
    batch_id?: string | null;
  };

export type GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables =
  {
    body?: Schemas.BodyGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet;
    pathParams: GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetPathParams;
    queryParams?: GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQueryParams;
  } & VlContext["fetcherOptions"];

/**
 * Get metadata for all folders in a dataset.
 *
 * batch_id: when provided alongside an active upload, in-progress folders for that batch
 * are also included in the response.
 */
export const fetchGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet =
  (
    variables: GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables,
    signal?: AbortSignal,
  ) =>
    vlFetch<
      Schemas.FoldersMetadataResponse,
      GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError,
      Schemas.BodyGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet,
      {},
      GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQueryParams,
      GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetPathParams
    >({
      url: "/api/v1/dataset/{datasetId}/folders_metadata",
      method: "get",
      ...variables,
      signal,
    });

/**
 * Get metadata for all folders in a dataset.
 *
 * batch_id: when provided alongside an active upload, in-progress folders for that batch
 * are also included in the response.
 */
export function getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQuery(
  variables: GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.FoldersMetadataResponse>;
};

export function getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQuery(
  variables:
    | GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.FoldersMetadataResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQuery(
  variables:
    | GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/folders_metadata",
      operationId:
        "getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get metadata for all folders in a dataset.
 *
 * batch_id: when provided alongside an active upload, in-progress folders for that batch
 * are also included in the response.
 */
export const useSuspenseGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet =
  <TData = Schemas.FoldersMetadataResponse>(
    variables: GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.FoldersMetadataResponse,
        GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.FoldersMetadataResponse,
      GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError,
      TData
    >({
      ...getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get metadata for all folders in a dataset.
 *
 * batch_id: when provided alongside an active upload, in-progress folders for that batch
 * are also included in the response.
 */
export const useGetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet =
  <TData = Schemas.FoldersMetadataResponse>(
    variables:
      | GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.FoldersMetadataResponse,
        GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useQuery<
      Schemas.FoldersMetadataResponse,
      GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetError,
      TData
    >({
      ...getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostPathParams =
  {
    /**
     * @format uuid
     */
    datasetId: string;
  };

export type SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostVariables =
  {
    body: Schemas.BodySelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPost;
    pathParams: SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostPathParams;
  } & VlContext["fetcherOptions"];

/**
 * Select specified folders for a dataset.
 */
export const fetchSelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPost = (
  variables: SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostError,
    Schemas.BodySelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPost,
    {},
    {},
    SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/select_folders",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Select specified folders for a dataset.
 */
export const useSelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostError,
      SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostError,
    SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostVariables
  >({
    mutationFn: (
      variables: SelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPostVariables,
    ) =>
      fetchSelectDatasetFoldersApiV1DatasetDatasetIdSelectFoldersPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type CreationStatusApiV1DatasetsDatasetIdCreationStatusGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables = {
  body?: Schemas.BodyCreationStatusApiV1DatasetsDatasetIdCreationStatusGet;
  pathParams: CreationStatusApiV1DatasetsDatasetIdCreationStatusGetPathParams;
} & VlContext["fetcherOptions"];

/**
 * Get creation/media addition status for a dataset.
 *
 * Returns the dataset's status field along with secondary progress from tasks.
 * This endpoint serves both initial dataset creation and add_media workflows.
 */
export const fetchCreationStatusApiV1DatasetsDatasetIdCreationStatusGet = (
  variables: CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.DatasetCreationStatusResponse,
    CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError,
    Schemas.BodyCreationStatusApiV1DatasetsDatasetIdCreationStatusGet,
    {},
    {},
    CreationStatusApiV1DatasetsDatasetIdCreationStatusGetPathParams
  >({
    url: "/api/v1/datasets/{datasetId}/creation-status",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get creation/media addition status for a dataset.
 *
 * Returns the dataset's status field along with secondary progress from tasks.
 * This endpoint serves both initial dataset creation and add_media workflows.
 */
export function creationStatusApiV1DatasetsDatasetIdCreationStatusGetQuery(
  variables: CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DatasetCreationStatusResponse>;
};

export function creationStatusApiV1DatasetsDatasetIdCreationStatusGetQuery(
  variables:
    | CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DatasetCreationStatusResponse>)
    | reactQuery.SkipToken;
};

export function creationStatusApiV1DatasetsDatasetIdCreationStatusGetQuery(
  variables:
    | CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/datasets/{datasetId}/creation-status",
      operationId: "creationStatusApiV1DatasetsDatasetIdCreationStatusGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchCreationStatusApiV1DatasetsDatasetIdCreationStatusGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get creation/media addition status for a dataset.
 *
 * Returns the dataset's status field along with secondary progress from tasks.
 * This endpoint serves both initial dataset creation and add_media workflows.
 */
export const useSuspenseCreationStatusApiV1DatasetsDatasetIdCreationStatusGet =
  <TData = Schemas.DatasetCreationStatusResponse>(
    variables: CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.DatasetCreationStatusResponse,
        CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError,
        TData
      >,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useVlContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.DatasetCreationStatusResponse,
      CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError,
      TData
    >({
      ...creationStatusApiV1DatasetsDatasetIdCreationStatusGetQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

/**
 * Get creation/media addition status for a dataset.
 *
 * Returns the dataset's status field along with secondary progress from tasks.
 * This endpoint serves both initial dataset creation and add_media workflows.
 */
export const useCreationStatusApiV1DatasetsDatasetIdCreationStatusGet = <
  TData = Schemas.DatasetCreationStatusResponse,
>(
  variables:
    | CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DatasetCreationStatusResponse,
      CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.DatasetCreationStatusResponse,
    CreationStatusApiV1DatasetsDatasetIdCreationStatusGetError,
    TData
  >({
    ...creationStatusApiV1DatasetsDatasetIdCreationStatusGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQueryParams = {
  batch_id?: string | null;
};

export type GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables = {
  body?: Schemas.BodyGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet;
  pathParams: GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetPathParams;
  queryParams?: GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQueryParams;
} & VlContext["fetcherOptions"];

/**
 * Get previews from selected folders in a dataset, optionally filtered by batch.
 */
export const fetchGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet = (
  variables: GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.PreviewsResponse,
    GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError,
    Schemas.BodyGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet,
    {},
    GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQueryParams,
    GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/previews",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get previews from selected folders in a dataset, optionally filtered by batch.
 */
export function getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQuery(
  variables: GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PreviewsResponse>;
};

export function getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQuery(
  variables:
    | GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.PreviewsResponse>)
    | reactQuery.SkipToken;
};

export function getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQuery(
  variables:
    | GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/dataset/{datasetId}/previews",
      operationId: "getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet(
              variables,
              signal,
            ),
  };
}

/**
 * Get previews from selected folders in a dataset, optionally filtered by batch.
 */
export const useSuspenseGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet = <
  TData = Schemas.PreviewsResponse,
>(
  variables: GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PreviewsResponse,
      GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.PreviewsResponse,
    GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError,
    TData
  >({
    ...getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

/**
 * Get previews from selected folders in a dataset, optionally filtered by batch.
 */
export const useGetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet = <
  TData = Schemas.PreviewsResponse,
>(
  variables:
    | GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PreviewsResponse,
      GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.PreviewsResponse,
    GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetError,
    TData
  >({
    ...getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GetUsageReportApiV1UsageReportGetError =
  Fetcher.ErrorWrapper<undefined>;

export type GetUsageReportApiV1UsageReportGetVariables =
  VlContext["fetcherOptions"];

export const fetchGetUsageReportApiV1UsageReportGet = (
  variables: GetUsageReportApiV1UsageReportGetVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    Schemas.UsageReport,
    GetUsageReportApiV1UsageReportGetError,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v1/usage_report", method: "get", ...variables, signal });

export function getUsageReportApiV1UsageReportGetQuery(
  variables: GetUsageReportApiV1UsageReportGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.UsageReport>;
};

export function getUsageReportApiV1UsageReportGetQuery(
  variables: GetUsageReportApiV1UsageReportGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.UsageReport>)
    | reactQuery.SkipToken;
};

export function getUsageReportApiV1UsageReportGetQuery(
  variables: GetUsageReportApiV1UsageReportGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: "/api/v1/usage_report",
      operationId: "getUsageReportApiV1UsageReportGet",
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchGetUsageReportApiV1UsageReportGet(variables, signal),
  };
}

export const useSuspenseGetUsageReportApiV1UsageReportGet = <
  TData = Schemas.UsageReport,
>(
  variables: GetUsageReportApiV1UsageReportGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UsageReport,
      GetUsageReportApiV1UsageReportGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.UsageReport,
    GetUsageReportApiV1UsageReportGetError,
    TData
  >({
    ...getUsageReportApiV1UsageReportGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useGetUsageReportApiV1UsageReportGet = <
  TData = Schemas.UsageReport,
>(
  variables: GetUsageReportApiV1UsageReportGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UsageReport,
      GetUsageReportApiV1UsageReportGetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useVlContext(options);
  return reactQuery.useQuery<
    Schemas.UsageReport,
    GetUsageReportApiV1UsageReportGetError,
    TData
  >({
    ...getUsageReportApiV1UsageReportGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostVariables = {
  body?: Schemas.BodyAddMediaToDatasetApiV1DatasetDatasetIdAddMediaPost;
  pathParams: AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Simplified API to support media uploads until the new dataset creation flow is finalized.
 *
 * Supports one of the following media sources per request:
 * - Direct File Upload - files[]
 * - S3 URI
 * - archive – ZIP or TAR
 */
export const fetchAddMediaToDatasetApiV1DatasetDatasetIdAddMediaPost = (
  variables: AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostError,
    Schemas.BodyAddMediaToDatasetApiV1DatasetDatasetIdAddMediaPost,
    {},
    {},
    AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/add_media",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Simplified API to support media uploads until the new dataset creation flow is finalized.
 *
 * Supports one of the following media sources per request:
 * - Direct File Upload - files[]
 * - S3 URI
 * - archive – ZIP or TAR
 */
export const useAddMediaToDatasetApiV1DatasetDatasetIdAddMediaPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostError,
      AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostError,
    AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostVariables
  >({
    mutationFn: (
      variables: AddMediaToDatasetApiV1DatasetDatasetIdAddMediaPostVariables,
    ) =>
      fetchAddMediaToDatasetApiV1DatasetDatasetIdAddMediaPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ReindexDatasetApiV1DatasetDatasetIdReindexPostPathParams = {
  /**
   * @format uuid
   */
  datasetId: string;
};

export type ReindexDatasetApiV1DatasetDatasetIdReindexPostError =
  Fetcher.ErrorWrapper<{
    status: 422;
    payload: Schemas.HTTPValidationError;
  }>;

export type ReindexDatasetApiV1DatasetDatasetIdReindexPostVariables = {
  pathParams: ReindexDatasetApiV1DatasetDatasetIdReindexPostPathParams;
} & VlContext["fetcherOptions"];

/**
 * Trigger reindex flow to re-process entire dataset (original + pending batches)
 */
export const fetchReindexDatasetApiV1DatasetDatasetIdReindexPost = (
  variables: ReindexDatasetApiV1DatasetDatasetIdReindexPostVariables,
  signal?: AbortSignal,
) =>
  vlFetch<
    void,
    ReindexDatasetApiV1DatasetDatasetIdReindexPostError,
    undefined,
    {},
    {},
    ReindexDatasetApiV1DatasetDatasetIdReindexPostPathParams
  >({
    url: "/api/v1/dataset/{datasetId}/reindex",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Trigger reindex flow to re-process entire dataset (original + pending batches)
 */
export const useReindexDatasetApiV1DatasetDatasetIdReindexPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ReindexDatasetApiV1DatasetDatasetIdReindexPostError,
      ReindexDatasetApiV1DatasetDatasetIdReindexPostVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useVlContext();
  return reactQuery.useMutation<
    void,
    ReindexDatasetApiV1DatasetDatasetIdReindexPostError,
    ReindexDatasetApiV1DatasetDatasetIdReindexPostVariables
  >({
    mutationFn: (
      variables: ReindexDatasetApiV1DatasetDatasetIdReindexPostVariables,
    ) =>
      fetchReindexDatasetApiV1DatasetDatasetIdReindexPost(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type QueryOperation =
  | {
      path: "/api/v1/manage/{datasetId}/share";
      operationId: "listAccessApiV1ManageDatasetIdShareGet";
      variables:
        | ListAccessApiV1ManageDatasetIdShareGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/auth/check";
      operationId: "authCheckApiV1AuthCheckGet";
      variables: AuthCheckApiV1AuthCheckGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/user";
      operationId: "getUserRouteApiV1UserGet";
      variables: GetUserRouteApiV1UserGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/pvld";
      operationId: "getPvldsApiV1PvldGet";
      variables: GetPvldsApiV1PvldGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets";
      operationId: "getDatasetsApiV1DatasetsGet";
      variables: GetDatasetsApiV1DatasetsGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/sample_data";
      operationId: "getSampleDatasetsApiV1DatasetsSampleDataGet";
      variables:
        | GetSampleDatasetsApiV1DatasetsSampleDataGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}";
      operationId: "getDatasetApiV1DatasetDatasetIdGet";
      variables:
        | GetDatasetApiV1DatasetDatasetIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/stats";
      operationId: "getDatasetStatsApiV1DatasetDatasetIdStatsGet";
      variables:
        | GetDatasetStatsApiV1DatasetDatasetIdStatsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/issues";
      operationId: "getClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGet";
      variables:
        | GetClusterIssuesApiV1DatasetDatasetIdClusterClusterIdIssuesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/issue_types_of_entities";
      operationId: "getIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGet";
      variables:
        | GetIssuesApiV1DatasetDatasetIdIssueTypesOfEntitiesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/tags";
      operationId: "getMediaTagsForDatasetApiV1DatasetDatasetIdTagsGet";
      variables:
        | GetMediaTagsForDatasetApiV1DatasetDatasetIdTagsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/cluster/{clusterId}/tags";
      operationId: "getMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGet";
      variables:
        | GetMediaTagsForClusterApiV1DatasetDatasetIdClusterClusterIdTagsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/label_sources";
      operationId: "getDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGet";
      variables:
        | GetDatasetSourcesApiV1DatasetDatasetIdLabelSourcesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/healthcheck";
      operationId: "healthcheckApiV1HealthcheckGet";
      variables: HealthcheckApiV1HealthcheckGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/version";
      operationId: "getVersionApiV1VersionGet";
      variables: GetVersionApiV1VersionGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/user_config";
      operationId: "getUserConfigApiV1UserConfigGet";
      variables:
        | GetUserConfigApiV1UserConfigGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/bucket";
      operationId: "testBucketConnectivityApiV1BucketGet";
      variables:
        | TestBucketConnectivityApiV1BucketGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/backoffice";
      operationId: "backofficeBackofficeGet";
      variables: BackofficeBackofficeGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/mustache";
      operationId: "mustacheMustacheGet";
      variables: MustacheMustacheGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/github-sso/{env}";
      operationId: "githubSsoEnvApiV1GithubSsoEnvGet";
      variables:
        | GithubSsoEnvApiV1GithubSsoEnvGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/github-sso";
      operationId: "githubSsoApiV1GithubSsoGet";
      variables: GithubSsoApiV1GithubSsoGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/oidc/logout";
      operationId: "oidcLogoutApiV1OidcLogoutGet";
      variables: OidcLogoutApiV1OidcLogoutGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/oidc/login";
      operationId: "oidcLoginApiV1OidcLoginGet";
      variables: OidcLoginApiV1OidcLoginGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/oidc/callback";
      operationId: "oidcCallbackApiV1OidcCallbackGet";
      variables:
        | OidcCallbackApiV1OidcCallbackGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset_image/{datasetId}/{imageId}";
      operationId: "getImageApiV1DatasetImageDatasetIdImageIdGet";
      variables:
        | GetImageApiV1DatasetImageDatasetIdImageIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/links";
      operationId: "getLinksApiV1DatasetImageDatasetIdImageIdLinksGet";
      variables:
        | GetLinksApiV1DatasetImageDatasetIdImageIdLinksGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/labels";
      operationId: "getLabelsApiV1DatasetImageDatasetIdImageIdLabelsGet";
      variables:
        | GetLabelsApiV1DatasetImageDatasetIdImageIdLabelsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/issues";
      operationId: "getIssuesApiV1DatasetImageDatasetIdImageIdIssuesGet";
      variables:
        | GetIssuesApiV1DatasetImageDatasetIdImageIdIssuesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset_image/{datasetId}/{imageId}/uniqueness_score";
      operationId: "getUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGet";
      variables:
        | GetUniquenessScoreApiV1DatasetImageDatasetIdImageIdUniquenessScoreGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/query_image/{queryImageId}";
      operationId: "getImageApiV1DatasetDatasetIdQueryImageQueryImageIdGet";
      variables:
        | GetImageApiV1DatasetDatasetIdQueryImageQueryImageIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/api_credentials";
      operationId: "getCredsApiV1ApiCredentialsGet";
      variables: GetCredsApiV1ApiCredentialsGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export";
      operationId: "exportDatasetApiV1DatasetDatasetIdExportGet";
      variables:
        | ExportDatasetApiV1DatasetDatasetIdExportGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_entities";
      operationId: "exportEntitiesApiV1DatasetDatasetIdExportEntitiesGet";
      variables:
        | ExportEntitiesApiV1DatasetDatasetIdExportEntitiesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_context";
      operationId: "exportContextApiV1DatasetDatasetIdExportContextGet";
      variables:
        | ExportContextApiV1DatasetDatasetIdExportContextGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_entities_async";
      operationId: "exportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGet";
      variables:
        | ExportEntitiesAsyncApiV1DatasetDatasetIdExportEntitiesAsyncGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_context_async";
      operationId: "exportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGet";
      variables:
        | ExportContextAsyncApiV1DatasetDatasetIdExportContextAsyncGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_status";
      operationId: "exportStatusApiV1DatasetDatasetIdExportStatusGet";
      variables:
        | ExportStatusApiV1DatasetDatasetIdExportStatusGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/export_media_id";
      operationId: "exportMediaIdApiV1DatasetDatasetIdExportMediaIdGet";
      variables:
        | ExportMediaIdApiV1DatasetDatasetIdExportMediaIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/exploration_metadata";
      operationId: "getExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGet";
      variables:
        | GetExplorationMetadataApiV1ExploreDatasetIdExplorationMetadataGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/exploration_metadata_get_thresholds";
      operationId: "getExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGet";
      variables:
        | GetExplorationMetadataGetThresholdsApiV1ExploreDatasetIdExplorationMetadataGetThresholdsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}";
      operationId: "exploreApiV1ExploreDatasetIdGet";
      variables:
        | ExploreApiV1ExploreDatasetIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/labels";
      operationId: "getDatasetLabelNamesApiV1ExploreDatasetIdLabelsGet";
      variables:
        | GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/cluster/{clusterId}/labels";
      operationId: "getClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGet";
      variables:
        | GetClusterLabelNamesApiV1ExploreDatasetIdClusterClusterIdLabelsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/origins";
      operationId: "getDatasetOriginsApiV1ExploreDatasetIdOriginsGet";
      variables:
        | GetDatasetOriginsApiV1ExploreDatasetIdOriginsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}";
      operationId: "getSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGet";
      variables:
        | GetSimilarityClusterApiV1ExploreDatasetIdSimilarityClusterClusterIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/tags";
      operationId: "getSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGet";
      variables:
        | GetSimilarityClusterTagsApiV1ExploreDatasetIdSimilarityClusterClusterIdTagsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/cluster_metadata";
      operationId: "getSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGet";
      variables:
        | GetSimilarityClusterMetadataApiV1ExploreDatasetIdSimilarityClusterClusterIdClusterMetadataGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/file_tree";
      operationId: "getFileTreeApiV1ExploreDatasetIdFileTreeGet";
      variables:
        | GetFileTreeApiV1ExploreDatasetIdFileTreeGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/metadata_sources";
      operationId: "getMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGet";
      variables:
        | GetMetadataSourcesApiV1ExploreDatasetIdMetadataSourcesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary";
      operationId: "getSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGet";
      variables:
        | GetSimilarityClusterMetadataSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummaryGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/metadata_summary";
      operationId: "getDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGet";
      variables:
        | GetDatasetMetadataSummaryApiV1ExploreDatasetIdMetadataSummaryGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/similarity_cluster/{clusterId}/metadata_summary/{section}";
      operationId: "getSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGet";
      variables:
        | GetSimilarityClusterSectionSummaryApiV1ExploreDatasetIdSimilarityClusterClusterIdMetadataSummarySectionGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/metadata_summary/{section}";
      operationId: "getDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGet";
      variables:
        | GetDatasetSectionSummaryApiV1ExploreDatasetIdMetadataSummarySectionGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/media/{mediaId}/vertex";
      operationId: "getVertexApiV1ExploreDatasetIdMediaMediaIdVertexGet";
      variables:
        | GetVertexApiV1ExploreDatasetIdMediaMediaIdVertexGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/tags";
      operationId: "getTagsApiV1TagsGet";
      variables: GetTagsApiV1TagsGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/media/{mediaId}/tags";
      operationId: "getMediaTagsByMediaIdApiV1MediaMediaIdTagsGet";
      variables:
        | GetMediaTagsByMediaIdApiV1MediaMediaIdTagsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/media/tags";
      operationId: "exploreMediaTagsApiV1DatasetDatasetIdMediaTagsGet";
      variables:
        | ExploreMediaTagsApiV1DatasetDatasetIdMediaTagsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/media/tags";
      operationId: "getMediaTagsApiV1MediaTagsGet";
      variables: GetMediaTagsApiV1MediaTagsGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/media/metadata";
      operationId: "getTagsApiV1MediaMetadataGet";
      variables: GetTagsApiV1MediaMetadataGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/enrichment/{datasetId}/context";
      operationId: "getEnrichmentContextApiV1EnrichmentDatasetIdContextGet";
      variables:
        | GetEnrichmentContextApiV1EnrichmentDatasetIdContextGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/enrichment/{datasetId}/list_models";
      operationId: "getModelsListApiV1EnrichmentDatasetIdListModelsGet";
      variables:
        | GetModelsListApiV1EnrichmentDatasetIdListModelsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/enrichment/{datasetId}/{enrichmentContextId}/status";
      operationId: "getEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGet";
      variables:
        | GetEnrichmentProgressApiV1EnrichmentDatasetIdEnrichmentContextIdStatusGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/views";
      operationId: "listViewsApiV1DatasetDatasetIdViewsGet";
      variables:
        | ListViewsApiV1DatasetDatasetIdViewsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/views/{viewId}/trend";
      operationId: "getViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGet";
      variables:
        | GetViewTrendApiV1DatasetDatasetIdViewsViewIdTrendGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/custom_metadata/tasks/{taskId}/status";
      operationId: "checkUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGet";
      variables:
        | CheckUploadStatusApiV1DatasetsDatasetIdCustomMetadataTasksTaskIdStatusGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/custom_metadata/schema";
      operationId: "listCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGet";
      variables:
        | ListCustomMetadataSchemaEndpointApiV1DatasetsDatasetIdCustomMetadataSchemaGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/image/{imageId}/custom_metadata";
      operationId: "retrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGet";
      variables:
        | RetrieveImageCustomMetadataApiV1DatasetsDatasetIdImageImageIdCustomMetadataGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/custom_metadata/fields/{fieldId}/unique_values";
      operationId: "getFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet";
      variables:
        | GetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/label_category/{datasetId}";
      operationId: "getLabelCategoryApiV1LabelCategoryDatasetIdGet";
      variables:
        | GetLabelCategoryApiV1LabelCategoryDatasetIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/seed/{seedId}";
      operationId: "getSeedApiV1FlywheelDatasetIdSeedSeedIdGet";
      variables:
        | GetSeedApiV1FlywheelDatasetIdSeedSeedIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/review/{flowId}";
      operationId: "getReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGet";
      variables:
        | GetReviewClustersApiV1FlywheelDatasetIdReviewFlowIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/review/{flowId}/{labelCategoryId}";
      operationId: "getLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGet";
      variables:
        | GetLabelReviewClustersApiV1FlywheelDatasetIdReviewFlowIdLabelCategoryIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/cycle/{flowId}";
      operationId: "flywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGet";
      variables:
        | FlywheelRunCycleApiV1FlywheelDatasetIdCycleFlowIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/status/{flowId}";
      operationId: "flywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGet";
      variables:
        | FlywheelRunStatusApiV1FlywheelDatasetIdStatusFlowIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/stats/{flowId}";
      operationId: "flywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGet";
      variables:
        | FlywheelRunStatsApiV1FlywheelDatasetIdStatsFlowIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}";
      operationId: "flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet";
      variables:
        | FlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/flywheel/{datasetId}/annotations/latest";
      operationId: "getFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGet";
      variables:
        | GetFlywheelAnnotationsLatestApiV1FlywheelDatasetIdAnnotationsLatestGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/export_csv";
      operationId: "csvExportApiV1DatasetsDatasetIdExportCsvGet";
      variables:
        | CsvExportApiV1DatasetsDatasetIdExportCsvGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/training/models";
      operationId: "listModelsApiV1TrainingModelsGet";
      variables:
        | ListModelsApiV1TrainingModelsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/training/tasks";
      operationId: "getTrainingTasksApiV1TrainingTasksGet";
      variables:
        | GetTrainingTasksApiV1TrainingTasksGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/training/tasks/{trainingTaskId}";
      operationId: "getSingleTaskApiV1TrainingTasksTrainingTaskIdGet";
      variables:
        | GetSingleTaskApiV1TrainingTasksTrainingTaskIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog/models/{modelId}";
      operationId: "getModelApiV1ModelsCatalogModelsModelIdGet";
      variables:
        | GetModelApiV1ModelsCatalogModelsModelIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog/filters";
      operationId: "getModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGet";
      variables:
        | GetModelCatalogFilterOptionsApiV1ModelsCatalogFiltersGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog";
      operationId: "listModelsApiV1ModelsCatalogGet";
      variables:
        | ListModelsApiV1ModelsCatalogGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/model-validation/tasks";
      operationId: "getValidationTasksApiV1ModelValidationTasksGet";
      variables:
        | GetValidationTasksApiV1ModelValidationTasksGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/model-validation/tasks/{taskId}";
      operationId: "getValidationTaskApiV1ModelValidationTasksTaskIdGet";
      variables:
        | GetValidationTaskApiV1ModelValidationTasksTaskIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog/validations/filters";
      operationId: "getValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGet";
      variables:
        | GetValidationCatalogFilterOptionsApiV1ModelsCatalogValidationsFiltersGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog/validations/{validationId}";
      operationId: "getValidationApiV1ModelsCatalogValidationsValidationIdGet";
      variables:
        | GetValidationApiV1ModelsCatalogValidationsValidationIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/models_catalog/validations";
      operationId: "listValidationsApiV1ModelsCatalogValidationsGet";
      variables:
        | ListValidationsApiV1ModelsCatalogValidationsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/keycloak/admin/users";
      operationId: "listUsersApiV1KeycloakAdminUsersGet";
      variables:
        | ListUsersApiV1KeycloakAdminUsersGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/keycloak/admin/users/{userId}";
      operationId: "getUserApiV1KeycloakAdminUsersUserIdGet";
      variables:
        | GetUserApiV1KeycloakAdminUsersUserIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/keycloak/admin/users/{userId}/sessions";
      operationId: "getUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGet";
      variables:
        | GetUserSessionsApiV1KeycloakAdminUsersUserIdSessionsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/admin/settings";
      operationId: "getSettingApiV1AdminSettingsGet";
      variables:
        | GetSettingApiV1AdminSettingsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/internal/runtime-config/settings";
      operationId: "listSettingsApiV1InternalRuntimeConfigSettingsGet";
      variables:
        | ListSettingsApiV1InternalRuntimeConfigSettingsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/tasks";
      operationId: "getTasksApiV1TasksGet";
      variables: GetTasksApiV1TasksGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/tasks/filters";
      operationId: "getTaskFilterOptionsApiV1TasksFiltersGet";
      variables:
        | GetTaskFilterOptionsApiV1TasksFiltersGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/explore/{datasetId}/video/{videoId}/frames";
      operationId: "getVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGet";
      variables:
        | GetVideoFramesApiV1ExploreDatasetIdVideoVideoIdFramesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/snapshot";
      operationId: "listSnapshotsApiV1DatasetDatasetIdSnapshotGet";
      variables:
        | ListSnapshotsApiV1DatasetDatasetIdSnapshotGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/organizations";
      operationId: "listOrganizationsApiV1OrganizationsGet";
      variables:
        | ListOrganizationsApiV1OrganizationsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/organizations/{organizationId}";
      operationId: "getOrganizationApiV1OrganizationsOrganizationIdGet";
      variables:
        | GetOrganizationApiV1OrganizationsOrganizationIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/workspaces";
      operationId: "listWorkspacesApiV1WorkspacesGet";
      variables:
        | ListWorkspacesApiV1WorkspacesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/workspaces/{workspaceId}";
      operationId: "getWorkspaceApiV1WorkspacesWorkspaceIdGet";
      variables:
        | GetWorkspaceApiV1WorkspacesWorkspaceIdGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/workspace/members";
      operationId: "listWorkspaceMembersApiV1WorkspaceMembersGet";
      variables:
        | ListWorkspaceMembersApiV1WorkspaceMembersGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/workspace/settings/access";
      operationId: "checkWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGet";
      variables:
        | CheckWorkspaceSettingsAccessApiV1WorkspaceSettingsAccessGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/notifications";
      operationId: "listNotificationsApiV1NotificationsGet";
      variables:
        | ListNotificationsApiV1NotificationsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/notifications/unread-count";
      operationId: "getUnreadCountApiV1NotificationsUnreadCountGet";
      variables:
        | GetUnreadCountApiV1NotificationsUnreadCountGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/notifications/stream";
      operationId: "notificationStreamApiV1NotificationsStreamGet";
      variables:
        | NotificationStreamApiV1NotificationsStreamGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/vl-chat/history";
      operationId: "chatHistoryEndpointApiVlChatHistoryGet";
      variables:
        | ChatHistoryEndpointApiVlChatHistoryGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/new_dataset";
      operationId: "newDatasetApiV1IngestionNewDatasetGet";
      variables:
        | NewDatasetApiV1IngestionNewDatasetGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/{datasetId}/s3connect";
      operationId: "connectS3ApiV1IngestionDatasetIdS3connectGet";
      variables:
        | ConnectS3ApiV1IngestionDatasetIdS3connectGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/{datasetId}/data_files";
      operationId: "startUploadTransactionApiV1IngestionDatasetIdDataFilesGet";
      variables:
        | StartUploadTransactionApiV1IngestionDatasetIdDataFilesGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/{datasetId}/status";
      operationId: "previewStatusApiV1IngestionDatasetIdStatusGet";
      variables:
        | PreviewStatusApiV1IngestionDatasetIdStatusGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/{datasetId}/list_cvat";
      operationId: "listCvatApiV1IngestionDatasetIdListCvatGet";
      variables:
        | ListCvatApiV1IngestionDatasetIdListCvatGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/ingestion/{datasetId}/import_cvat";
      operationId: "importCvatApiV1IngestionDatasetIdImportCvatGet";
      variables:
        | ImportCvatApiV1IngestionDatasetIdImportCvatGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/data/folder_upload_transaction";
      operationId: "startFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGet";
      variables:
        | StartFolderUploadTransactionApiV1DatasetDatasetIdDataFolderUploadTransactionGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/process";
      operationId: "processApiV1DatasetDatasetIdProcessGet";
      variables:
        | ProcessApiV1DatasetDatasetIdProcessGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/folders_metadata";
      operationId: "getDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGet";
      variables:
        | GetDatasetFoldersMetadataApiV1DatasetDatasetIdFoldersMetadataGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/datasets/{datasetId}/creation-status";
      operationId: "creationStatusApiV1DatasetsDatasetIdCreationStatusGet";
      variables:
        | CreationStatusApiV1DatasetsDatasetIdCreationStatusGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/dataset/{datasetId}/previews";
      operationId: "getDatasetPreviewsApiV1DatasetDatasetIdPreviewsGet";
      variables:
        | GetDatasetPreviewsApiV1DatasetDatasetIdPreviewsGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/usage_report";
      operationId: "getUsageReportApiV1UsageReportGet";
      variables:
        | GetUsageReportApiV1UsageReportGetVariables
        | reactQuery.SkipToken;
    };
